(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 4878:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(95587);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D4": function() { return /* binding */ getLocationsAutocompleteSelfDatabase; },
/* harmony export */   "Fx": function() { return /* binding */ getSearchKeywords; },
/* harmony export */   "U_": function() { return /* binding */ getLocationDetails; },
/* harmony export */   "iN": function() { return /* binding */ getLocationsAutocomplete; },
/* harmony export */   "z1": function() { return /* binding */ getSearchAutocomplete; }
/* harmony export */ });
/* harmony import */ var _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5001);
/* harmony import */ var _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28253);
/* harmony import */ var _utils_getConfigVariable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81027);
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30628);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var basePath = (0,_utils_getConfigVariable__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("BASIC_API_URL");
var internalApiUrl = (0,_utils_getConfigVariable__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("INTERNAL_API_URL");
var getLocationsAutocomplete = function() {
    var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var searchString, lang, language, lat, lon, query;
        return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    searchString = param.searchString, lang = param.lang, language = param.language, lat = param.lat, lon = param.lon;
                    query = (0,_utils_query__WEBPACK_IMPORTED_MODULE_3__/* .transformToQuery */ .aR)({
                        searchString: searchString,
                        language: language,
                        lat: lat,
                        lon: lon
                    });
                    return _ctx.abrupt("return", (0,_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("".concat(basePath, "/").concat(lang, "/search/autocomplete-locations?limit=", 10, "&").concat(query)).then(function(r) {
                        return r.json();
                    }));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getLocationsAutocomplete(_) {
        return _ref.apply(this, arguments);
    };
}();
var getLocationsAutocompleteSelfDatabase = function() {
    var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var locationId, lang, keywordId, search, type, searchParams, queryParams, url;
        return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locationId = param.locationId, lang = param.lang, keywordId = param.keywordId, search = param.search, type = param.type;
                    searchParams = new URLSearchParams();
                    if (keywordId && keywordId !== 1) {
                        searchParams.append("keywordId", keywordId.toString());
                    }
                    if (search === null || search === void 0 ? void 0 : search.length) {
                        searchParams.append("search", search);
                    }
                    if (type) {
                        searchParams.append("type", type);
                    }
                    queryParams = searchParams.toString();
                    url = "".concat(internalApiUrl, "/").concat(lang, "/api/search/locations");
                    if (locationId) {
                        url += "/".concat(locationId);
                    }
                    if (queryParams === null || queryParams === void 0 ? void 0 : queryParams.length) {
                        url += "?".concat(queryParams);
                    }
                    return _ctx.abrupt("return", (0,_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(url).then(function(r) {
                        return r.json();
                    }));
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getLocationsAutocompleteSelfDatabase(_) {
        return _ref.apply(this, arguments);
    };
}();
var getLocationDetails = function() {
    var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var locationId, lang;
        return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    locationId = param.locationId, lang = param.lang;
                    return _ctx.abrupt("return", (0,_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("".concat(basePath, "/").concat(lang, "/search/location-details/").concat(locationId)).then(function(r) {
                        return r.json();
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getLocationDetails(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSearchAutocomplete = function() {
    var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var searchString, lang, type, specialties, searchType, query;
        return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    searchString = param.searchString, lang = param.lang, type = param.type, specialties = param.specialties, searchType = param.searchType;
                    query = (0,_utils_query__WEBPACK_IMPORTED_MODULE_3__/* .transformToQuery */ .aR)({
                        searchString: searchString,
                        type: type,
                        specialties: specialties,
                        searchType: searchType
                    });
                    return _ctx.abrupt("return", (0,_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("".concat(basePath, "/").concat(lang, "/search/autocomplete?limit=", 10, "&").concat(query)).then(function(r) {
                        return r.json();
                    }));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSearchAutocomplete(_) {
        return _ref.apply(this, arguments);
    };
}();
var getSearchKeywords = function() {
    var _ref = _asyncToGenerator(_builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var keywordId, keywordType, locationId, locale, url;
        return _builds_hermes_platform_build_hermes_web_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    keywordId = param.keywordId, keywordType = param.keywordType, locationId = param.locationId, locale = param.locale;
                    url = "".concat(internalApiUrl, "/").concat(locale, "/api/keywords?");
                    if (keywordType) {
                        url += "keyword_type=".concat(keywordType, "&");
                    }
                    if (locationId) {
                        url += "locationId=".concat(locationId);
                    }
                    if (keywordId && keywordId !== 1) {
                        url += "&keywordId=".concat(keywordId);
                    }
                    return _ctx.abrupt("return", (0,_request__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(url).then(function(r) {
                        return r.json();
                    }));
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getSearchKeywords(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 35726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);


var errorDescriptionMap = {
    "404": "This page could not be found.",
    "500": "Internal server error.",
    default: "This page could not be found."
};
// Mimic default Next error page
var Error = function(param) {
    var statusCode = param.statusCode, errorText = param.errorText;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.body.style.backgroundColor = "#000";
    }, []);
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            fontFamily: '-apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", "Fira Sans", Avenir, "Helvetica Neue", "Lucida Grande", sans-serif',
            height: "100vh",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "20px"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        borderRight: "1px solid rgba(255, 255, 255, .3)"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        style: {
                            display: "inline-block",
                            margin: "0",
                            padding: "10px 23px 10px 0",
                            fontSize: "24px",
                            fontWeight: "500",
                            verticalAlign: "top"
                        },
                        children: statusCode
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        fontSize: "14px",
                        fontWeight: "normal",
                        lineHeight: "inherit",
                        padding: "0 0 6px 0",
                        margin: "0"
                    },
                    children: (ref = errorText !== null && errorText !== void 0 ? errorText : errorDescriptionMap[statusCode]) !== null && ref !== void 0 ? ref : errorDescriptionMap["default"]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Error);


/***/ }),

/***/ 2730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93716);
/* harmony import */ var _utils_addRtlProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32737);


var ArrowRight = (0,_utils_addRtlProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
/* harmony default export */ __webpack_exports__["Z"] = (ArrowRight);


/***/ }),

/***/ 33137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65729);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64495);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  animation: ",
        " 1.5s linear infinite;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var rotate = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject());
var RotatingSVG = (0,_hermes_web_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("svg")(_templateObject1(), rotate);
var LoadingWheel = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RotatingSVG, _objectSpread({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: 23.811,
        height: 23.812,
        viewBox: "98.131 158.59 23.811 23.812"
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#AABDF3",
            d: "M112.269 160.822a2.233 2.233 0 1 1-4.467 0 2.233 2.233 0 0 1 4.467 0Zm-2.233 17.115a2.232 2.232 0 1 0 0 4.463 2.232 2.232 0 0 0 0-4.463Zm9.674-9.674a2.233 2.233 0 1 0 0 4.467 2.233 2.233 0 0 0 0-4.467Zm-17.115 2.233a2.232 2.232 0 1 0-4.465-.001 2.232 2.232 0 0 0 4.465.001Zm.601 4.608a2.232 2.232 0 1 0 0 4.463 2.232 2.232 0 0 0 0-4.463Zm13.68 0a2.232 2.232 0 1 0 0 4.465 2.232 2.232 0 0 0 0-4.465Zm-13.68-13.681a2.232 2.232 0 1 0 0 4.465 2.232 2.232 0 0 0 0-4.465Z"
        })
    }));
});
/* harmony default export */ __webpack_exports__["Z"] = (LoadingWheel);


/***/ }),

/***/ 4261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32735);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46224);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var SearchIcon = function(_param) /*#__PURE__*/ {
    var props = _extends({}, _param);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
        width: "22",
        height: "22",
        viewBox: "0 0 22 22"
    }, props, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M9.03431 16.6642C13.2903 16.6642 16.7405 13.3783 16.7405 9.32494C16.7405 5.2716 13.2903 1.98572 9.03431 1.98572C4.7783 1.98572 1.32812 5.2716 1.32812 9.32494C1.32812 13.3783 4.7783 16.6642 9.03431 16.6642Z",
                    stroke: "currentColor",
                    strokeWidth: "2.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M20.6313 20.3699L14.4766 14.5082",
                    stroke: "currentColor",
                    strokeWidth: "2.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchIcon);


/***/ }),

/***/ 71899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46582);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var PageMeta = function(meta) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: meta.description
            }),
            meta.isProfile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "profile"
                    }),
                    !!meta.profileFirstName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "profile:first_name",
                        content: meta.profileFirstName
                    }),
                    !!meta.profileLastName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "profile:last_name",
                        content: meta.profileLastName
                    }),
                    !!meta.profileSlug && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "profile:username",
                        content: meta.profileSlug
                    }),
                    !!meta.profileGender && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "profile:gender",
                        content: meta.profileGender
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Doctify"
            }),
            !!meta.preloadImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: meta.preloadImage
            }),
            !!meta.canonicalUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: meta.canonicalUrl,
                        hrefLang: meta.language
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: meta.canonicalUrl
                    })
                ]
            }),
            (meta === null || meta === void 0 ? void 0 : meta.noindex) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex"
            }) : null,
            !!meta.hrefLangs && meta.hrefLangs.map(function(hrefLang) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", _objectSpread({}, hrefLang), "meta-hreflang-".concat(hrefLang.hreflang));
            }),
            meta.children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMeta);


/***/ }),

/***/ 721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var _hermes_web_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4595);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var ConditionalRenderBox = function(param) {
    var children = param.children, isOpen = param.isOpen, isClientSide = param.isClientSide, sx = param.sx;
    return isClientSide ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        sx: sx,
        children: isOpen && children
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hermes_web_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        sx: _objectSpread({
            display: isOpen ? "block" : "none"
        }, sx),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ConditionalRenderBox);


/***/ }),

/***/ 8211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ withError; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);
/* harmony import */ var _Error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35726);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function withError(Component) {
    return function(_param) {
        var errorCode = _param.errorCode, errorText = _param.errorText, props = _objectWithoutProperties(_param, [
            "errorCode",
            "errorText"
        ]);
        if (errorCode) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Error__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                statusCode: errorCode,
                errorText: errorText
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, _objectSpread({}, props, {
            errorCode: errorCode
        }));
    };
};


/***/ }),

/***/ 61110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ useTimeout; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);

var useTimeout = function() {
    var timeoutRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(callback) {
        var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300;
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(function() {
            callback();
        }, delay);
        return function() {
            return clearTimeout(timeoutRef.current);
        };
    }, []);
};


/***/ }),

/***/ 95587:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./components/withError.tsx
var withError = __webpack_require__(8211);
// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 1 modules
var Box_esm = __webpack_require__(4595);
// EXTERNAL MODULE: ../../../node_modules/@splidejs/react-splide/dist/css/splide.min.css
var splide_min = __webpack_require__(71762);
// EXTERNAL MODULE: ./components/ProfileMeta.tsx
var ProfileMeta = __webpack_require__(71899);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
;// CONCATENATED MODULE: ./components/HomePage/styles.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var primaryFont = "ES Klarheit Kurrent";
var SECTION_WIDTH = "1096px";
var HomePageLayout = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP)(function(param) {
    var theme = param.theme;
    return _defineProperty({
        backgroundColor: "#fff",
        paddingTop: "60px",
        paddingBottom: "65px",
        display: "flex",
        flexDirection: "column",
        gap: "48px",
        alignItems: "center",
        width: "100%"
    }, theme.breakpoints.down("md"), {
        paddingTop: "48px"
    });
});
var SectionContentPlaceholder = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function() {
    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "lightgray",
        width: "100%"
    };
});
var HeroSection = (0,styled_esm/* default */.ZP)("section")(function() {
    return {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        maxWidth: SECTION_WIDTH,
        textAlign: "center",
        width: "100%"
    };
});
var Section = (0,styled_esm/* default */.ZP)("section")(function() {
    return {
        display: "flex",
        flexDirection: "column",
        maxWidth: SECTION_WIDTH,
        textAlign: "center",
        width: "100%",
        padding: "0 16px"
    };
});
var SecondarySection = (0,styled_esm/* default */.ZP)(Section)(function(param) {
    var theme = param.theme;
    return _defineProperty({}, theme.breakpoints.down("sm"), {
        padding: "0 24px"
    });
});
var H1Title = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)(function() {
    return {
        color: "#11245a",
        fontFamily: primaryFont,
        fontSize: "44px",
        fontWeight: 600,
        letterSpacing: "-2px",
        lineHeight: "56px",
        margin: 0
    };
});
var H2Title = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)(function() {
    return {
        color: "#11245a",
        fontFamily: "Poppins",
        fontSize: "24px",
        fontWeight: 600,
        letterSpacing: 0,
        lineHeight: "32px",
        margin: 0
    };
});
var H3Title = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)(function() {
    return {
        fontFamily: primaryFont,
        fontWeight: 700,
        fontSize: "30px",
        lineHeight: "40px",
        letterSpacing: "-1px",
        textAlign: "center",
        color: "#11245A",
        margin: 0
    };
});
var H4Title = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)(function() {
    return {
        fontFamily: primaryFont,
        fontWeight: 700,
        fontSize: "24px",
        lineHeight: "32.04px",
        letterSpacing: "-1px",
        textAlign: "center",
        color: "#11245A",
        margin: 0
    };
});
var BodyLarge = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)(function() {
    return {
        fontFamily: "Poppins",
        fontWeight: 500,
        fontSize: "18px",
        lineHeight: "26px",
        letterSpacing: 0,
        color: "#11245A"
    };
});
var BodyMedium = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)(function() {
    return {
        fontFamily: "Poppins",
        fontWeight: 400,
        fontSize: "15px",
        lineHeight: "20px",
        letterSpacing: 0,
        color: "#11245A",
        display: "-webkit-box",
        WebkitLineClamp: 5,
        WebkitBoxOrient: "vertical",
        overflow: "hidden"
    };
});
var Specialty = (0,styled_esm/* default */.ZP)("div")(function() {
    return {
        background: "#eef",
        borderRadius: "5px",
        padding: "10px 20px"
    };
});

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/icons-material/Check.esm.js
var Check_esm = __webpack_require__(89995);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Button/Button.esm.js + 2 modules
var Button_esm = __webpack_require__(77428);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Hidden/Hidden.esm.js + 4 modules
var Hidden_esm = __webpack_require__(49889);
;// CONCATENATED MODULE: ./components/HomePage/ProvidersSection/styles.tsx
function styles_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


var Container = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        position: "relative",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        padding: "110px 0"
    }, styles_defineProperty(_obj, theme.breakpoints.down("md"), {
        flexDirection: "column",
        alignItems: "flex-start",
        paddingBottom: 0
    }), styles_defineProperty(_obj, theme.breakpoints.down("sm"), {
        paddingTop: 0
    }), _obj;
});
var styles_Section = (0,styled_esm/* default */.ZP)(Section)({
    padding: "0 24px",
    maxWidth: "100%",
    position: "relative",
    alignItems: "center",
    background: "radial-gradient(circle at 0% 95%, rgb(178, 109, 232) -7%, transparent 10%),radial-gradient(circle at 57% 70%, rgb(178, 109, 232) 0%, transparent 35%), rgb(255, 255, 255)"
});
var Wrapper = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function() {
    return {
        display: "flex",
        alignItems: "start",
        flexDirection: "column",
        gap: "24px"
    };
});
var Title = (0,styled_esm/* default */.ZP)(H3Title)(function(param) {
    var theme = param.theme;
    return styles_defineProperty({
        fontSize: "36px",
        textAlign: "start",
        lineHeight: "48px",
        fontWeight: 900
    }, theme.breakpoints.down("md"), {
        fontSize: "30px",
        lineHeight: "40px",
        fontWeight: 700
    });
});
var CoverImageWrapper = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        position: "absolute",
        right: 0,
        bottom: 0,
        width: "900px",
        height: "570px"
    }, styles_defineProperty(_obj, theme.breakpoints.down("xl"), {
        right: "-320px"
    }), styles_defineProperty(_obj, theme.breakpoints.down("md"), {
        position: "relative",
        height: "350px",
        width: "530px",
        right: "-24px",
        marginLeft: "auto",
        objectFit: "cover"
    }), styles_defineProperty(_obj, theme.breakpoints.down("sm"), {
        marginTop: "50px",
        right: 0
    }), _obj;
});

// EXTERNAL MODULE: ./utils/url.ts
var url = __webpack_require__(46937);
// EXTERNAL MODULE: ./providers/AppData/index.tsx
var AppData = __webpack_require__(3426);
// EXTERNAL MODULE: ./hooks/useTranslateMessage.tsx + 1 modules
var useTranslateMessage = __webpack_require__(75986);
// EXTERNAL MODULE: ../../../node_modules/next/image.js
var next_image = __webpack_require__(43875);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/HomePage/ProvidersSection/index.tsx









var providerFeatures = [
    "collect",
    "validate",
    "connect",
    "realtime",
    "other"
];
var ProvidersSection = function() {
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var providerLink = (0,url/* getProviderUrl */.Qi)(locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Section, {
        sx: {
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                sx: {
                    maxWidth: SECTION_WIDTH
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                    sx: {
                        maxWidth: "488px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                                gap: "12px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    variant: "h2",
                                    children: translate("homepage.search.providers.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyMedium, {
                                    sx: {
                                        textAlign: "start"
                                    },
                                    children: translate("homepage.search.providers.subtitle")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "start",
                                gap: "16px"
                            },
                            children: providerFeatures.map(function(item, key) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                                    sx: {
                                        display: "flex",
                                        gap: "12px",
                                        alignItems: "center"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                            style: {
                                                borderRadius: "50%",
                                                border: "solid #11245A thin",
                                                height: "18px",
                                                width: "18px",
                                                flexShrink: 0,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Check_esm/* default */.Z, {
                                                sx: {
                                                    color: "#11245A",
                                                    width: "12px"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyMedium, {
                                            sx: {
                                                textAlign: "start"
                                            },
                                            children: translate("homepage.search.providers.feat.".concat(item))
                                        })
                                    ]
                                }, key);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_esm/* default */.Z, {
                            sx: {
                                width: "fit-content",
                                borderRadius: "20px",
                                color: "#1A3586",
                                borderColor: "#1A3586",
                                paddingLeft: "10px",
                                paddingRight: "10px",
                                padding: "8px 24px",
                                backgroundColor: "#fff",
                                "&:focus": {
                                    borderColor: "transparent",
                                    color: "#fff"
                                }
                            },
                            href: "".concat((0,url/* purifyTenantDomain */.ng)("", locale)).concat(providerLink),
                            variant: "outlined",
                            children: translate("homepage.search.providers.learnmore")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CoverImageWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                        component: Hidden_esm/* default */.Z,
                        mdDown: true,
                        implementation: "css",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            loading: "lazy",
                            src: "/hermes-static/images/providers-cover.png",
                            alt: "Providers Cover",
                            layout: "fill"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                        component: Hidden_esm/* default */.Z,
                        mdUp: true,
                        implementation: "css",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            loading: "lazy",
                            src: "/hermes-static/images/providers-cover-mobile.png",
                            alt: "Providers Cover",
                            layout: "fill"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var HomePage_ProvidersSection = (ProvidersSection);

;// CONCATENATED MODULE: ./components/HomePage/RollAnimation/styles.tsx
function RollAnimation_styles_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var RollLabel = (0,styled_esm/* default */.ZP)("span", {
    shouldForwardProp: function(prop) {
        return ![
            "decreasedFontSize",
            "isAnimating"
        ].includes(prop);
    }
})(function(param) {
    var theme = param.theme, decreasedFontSize = param.decreasedFontSize, isAnimating = param.isAnimating;
    var _obj;
    return _obj = {
        background: "linear-gradient(91.02deg, #1515B7 6.2%, #1717F2 57.9%, #03DBC7 120.55%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        display: "inline-block",
        animation: isAnimating ? "rollAnimation 1s ease" : "none",
        "@keyframes rollAnimation": {
            "0%": {
                transform: "translateY(0)"
            },
            "45%": {
                transform: "translateY(-20%)",
                opacity: 0
            },
            "55%": {
                transform: "translateY(30%)",
                opacity: 0
            },
            "100%": {
                transform: "translateY(0)",
                opacity: 1
            }
        }
    }, RollAnimation_styles_defineProperty(_obj, theme.breakpoints.up("sm"), {
        whiteSpace: "nowrap"
    }), RollAnimation_styles_defineProperty(_obj, theme.breakpoints.down("sm"), {
        fontSize: decreasedFontSize ? "30px" : ""
    }), RollAnimation_styles_defineProperty(_obj, theme.breakpoints.down("md"), {
        width: "100%"
    }), _obj;
});

;// CONCATENATED MODULE: ./components/HomePage/RollAnimation/index.tsx




var RollAnimation = function(param) {
    var items = param.items;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var ref = (0,react.useState)(0), currentIndex = ref[0], setCurrentIndex = ref[1];
    var ref1 = (0,react.useState)(false), isAnimating = ref1[0], setIsAnimating = ref1[1];
    var ref2 = (0,react.useState)(true), isFirstRender = ref2[0], setIsFirstRender = ref2[1];
    (0,react.useEffect)(function() {
        setIsFirstRender(false);
        var interval = setInterval(function() {
            setIsAnimating(true);
            setTimeout(function() {
                setCurrentIndex(function(prevIndex) {
                    return (prevIndex + 1) % items.length;
                });
            }, 500);
        }, 4000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        items.length
    ]);
    var onAnimationEnd = (0,react.useCallback)(function() {
        return setIsAnimating(false);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RollLabel, {
        isAnimating: !isFirstRender && isAnimating,
        onAnimationEnd: onAnimationEnd,
        children: translate(items[currentIndex])
    });
};
/* harmony default export */ var HomePage_RollAnimation = (RollAnimation);

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Carousel/index.esm.js + 2 modules
var index_esm = __webpack_require__(725);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/node_modules/@splidejs/splide-extension-auto-scroll/dist/js/splide-extension-auto-scroll.esm.esm.js
/*!
 * @splidejs/splide-extension-auto-scroll
 * Version  : 0.5.3
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */
function empty(array) {
  array.length = 0;
}

function slice$1(arrayLike, start, end) {
  return Array.prototype.slice.call(arrayLike, start, end);
}

function apply$1(func) {
  return func.bind.apply(func, [null].concat(slice$1(arguments, 1)));
}

function raf(func) {
  return requestAnimationFrame(func);
}

function typeOf$1(type, subject) {
  return typeof subject === type;
}

var isArray$1 = Array.isArray;
apply$1(typeOf$1, "function");
apply$1(typeOf$1, "string");
apply$1(typeOf$1, "undefined");

function toArray$1(value) {
  return isArray$1(value) ? value : [value];
}

function forEach$1(values, iteratee) {
  toArray$1(values).forEach(iteratee);
}

var ownKeys$1 = Object.keys;

function forOwn$1(object, iteratee, right) {
  if (object) {
    var keys = ownKeys$1(object);
    keys = right ? keys.reverse() : keys;

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== "__proto__") {
        if (iteratee(object[key], key) === false) {
          break;
        }
      }
    }
  }

  return object;
}

function assign$1(object) {
  slice$1(arguments, 1).forEach(function (source) {
    forOwn$1(source, function (value, key) {
      object[key] = source[key];
    });
  });
  return object;
}

var min$1 = Math.min;

function EventBinder() {
  var listeners = [];

  function bind(targets, events, callback, options) {
    forEachEvent(targets, events, function (target, event, namespace) {
      var isEventTarget = ("addEventListener" in target);
      var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
      isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
      listeners.push([target, event, namespace, callback, remover]);
    });
  }

  function unbind(targets, events, callback) {
    forEachEvent(targets, events, function (target, event, namespace) {
      listeners = listeners.filter(function (listener) {
        if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
          listener[4]();
          return false;
        }

        return true;
      });
    });
  }

  function dispatch(target, type, detail) {
    var e;
    var bubbles = true;

    if (typeof CustomEvent === "function") {
      e = new CustomEvent(type, {
        bubbles: bubbles,
        detail: detail
      });
    } else {
      e = document.createEvent("CustomEvent");
      e.initCustomEvent(type, bubbles, false, detail);
    }

    target.dispatchEvent(e);
    return e;
  }

  function forEachEvent(targets, events, iteratee) {
    forEach$1(targets, function (target) {
      target && forEach$1(events, function (events2) {
        events2.split(" ").forEach(function (eventNS) {
          var fragment = eventNS.split(".");
          iteratee(target, fragment[0], fragment[1]);
        });
      });
    });
  }

  function destroy() {
    listeners.forEach(function (data) {
      data[4]();
    });
    empty(listeners);
  }

  return {
    bind: bind,
    unbind: unbind,
    dispatch: dispatch,
    destroy: destroy
  };
}
var EVENT_MOVE = "move";
var EVENT_MOVED = "moved";
var EVENT_UPDATED = "updated";
var EVENT_DRAG = "drag";
var EVENT_DRAGGED = "dragged";
var EVENT_SCROLL = "scroll";
var EVENT_SCROLLED = "scrolled";
var EVENT_DESTROY = "destroy";

function EventInterface(Splide2) {
  var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
  var binder = EventBinder();

  function on(events, callback) {
    binder.bind(bus, toArray$1(events).join(" "), function (e) {
      callback.apply(callback, isArray$1(e.detail) ? e.detail : []);
    });
  }

  function emit(event) {
    binder.dispatch(bus, event, slice$1(arguments, 1));
  }

  if (Splide2) {
    Splide2.event.on(EVENT_DESTROY, binder.destroy);
  }

  return assign$1(binder, {
    bus: bus,
    on: on,
    off: apply$1(binder.unbind, bus),
    emit: emit
  });
}

function RequestInterval(interval, onInterval, onUpdate, limit) {
  var now = Date.now;
  var startTime;
  var rate = 0;
  var id;
  var paused = true;
  var count = 0;

  function update() {
    if (!paused) {
      rate = interval ? min$1((now() - startTime) / interval, 1) : 1;
      onUpdate && onUpdate(rate);

      if (rate >= 1) {
        onInterval();
        startTime = now();

        if (limit && ++count >= limit) {
          return pause();
        }
      }

      raf(update);
    }
  }

  function start(resume) {
    !resume && cancel();
    startTime = now() - (resume ? rate * interval : 0);
    paused = false;
    raf(update);
  }

  function pause() {
    paused = true;
  }

  function rewind() {
    startTime = now();
    rate = 0;

    if (onUpdate) {
      onUpdate(rate);
    }
  }

  function cancel() {
    id && cancelAnimationFrame(id);
    rate = 0;
    id = 0;
    paused = true;
  }

  function set(time) {
    interval = time;
  }

  function isPaused() {
    return paused;
  }

  return {
    start: start,
    rewind: rewind,
    pause: pause,
    cancel: cancel,
    set: set,
    isPaused: isPaused
  };
}

function Throttle(func, duration) {
  var interval;

  function throttled() {
    if (!interval) {
      interval = RequestInterval(duration || 0, function () {
        func();
        interval = null;
      }, null, 1);
      interval.start();
    }
  }

  return throttled;
}
var CLASS_ACTIVE = "is-active";

var SLIDE = "slide";
var FADE = "fade";

function slice(arrayLike, start, end) {
  return Array.prototype.slice.call(arrayLike, start, end);
}

function apply(func) {
  return func.bind(null, ...slice(arguments, 1));
}

function typeOf(type, subject) {
  return typeof subject === type;
}
function isObject(subject) {
  return !isNull(subject) && typeOf("object", subject);
}
const isArray = Array.isArray;
apply(typeOf, "function");
apply(typeOf, "string");
const isUndefined = apply(typeOf, "undefined");
function isNull(subject) {
  return subject === null;
}

function toArray(value) {
  return isArray(value) ? value : [value];
}

function forEach(values, iteratee) {
  toArray(values).forEach(iteratee);
}

function toggleClass(elm, classes, add) {
  if (elm) {
    forEach(classes, (name) => {
      if (name) {
        elm.classList[add ? "add" : "remove"](name);
      }
    });
  }
}

const ownKeys = Object.keys;

function forOwn(object, iteratee, right) {
  if (object) {
    let keys = ownKeys(object);
    keys = right ? keys.reverse() : keys;
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      if (key !== "__proto__") {
        if (iteratee(object[key], key) === false) {
          break;
        }
      }
    }
  }
  return object;
}

function splide_extension_auto_scroll_esm_esm_assign(object) {
  slice(arguments, 1).forEach((source) => {
    forOwn(source, (value, key) => {
      object[key] = source[key];
    });
  });
  return object;
}

function removeAttribute(elms, attrs) {
  forEach(elms, (elm) => {
    forEach(attrs, (attr) => {
      elm && elm.removeAttribute(attr);
    });
  });
}

function setAttribute(elms, attrs, value) {
  if (isObject(attrs)) {
    forOwn(attrs, (value2, name) => {
      setAttribute(elms, name, value2);
    });
  } else {
    forEach(elms, (elm) => {
      isNull(value) || value === "" ? removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
  }
}

const { min, max, floor, ceil, abs } = Math;

function clamp(number, x, y) {
  const minimum = min(x, y);
  const maximum = max(x, y);
  return min(max(minimum, number), maximum);
}

const DEFAULTS = {
  speed: 1,
  autoStart: true,
  pauseOnHover: true,
  pauseOnFocus: true
};

const I18N = {
  startScroll: "Start auto scroll",
  pauseScroll: "Pause auto scroll"
};

function AutoScroll(Splide2, Components2, options) {
  const { on, off, bind, unbind } = EventInterface(Splide2);
  const { translate, getPosition, toIndex, getLimit } = Components2.Move;
  const { setIndex, getIndex } = Components2.Controller;
  const { orient } = Components2.Direction;
  const { toggle } = Components2.Elements;
  const { Live } = Components2;
  const { root } = Splide2;
  const throttledUpdateArrows = Throttle(Components2.Arrows.update, 500);
  let autoScrollOptions = {};
  let interval;
  let stopped;
  let hovered;
  let focused;
  let busy;
  let currPosition;
  function setup() {
    const { autoScroll } = options;
    autoScrollOptions = splide_extension_auto_scroll_esm_esm_assign({}, DEFAULTS, isObject(autoScroll) ? autoScroll : {});
  }
  function mount() {
    if (!Splide2.is(FADE)) {
      if (!interval && options.autoScroll !== false) {
        interval = RequestInterval(0, move);
        listen();
        autoStart();
      }
    }
  }
  function destroy() {
    if (interval) {
      interval.cancel();
      interval = null;
      currPosition = void 0;
      off([EVENT_MOVE, EVENT_DRAG, EVENT_SCROLL, EVENT_MOVED, EVENT_SCROLLED]);
      unbind(root, "mouseenter mouseleave focusin focusout");
      unbind(toggle, "click");
    }
  }
  function listen() {
    if (autoScrollOptions.pauseOnHover) {
      bind(root, "mouseenter mouseleave", (e) => {
        hovered = e.type === "mouseenter";
        autoToggle();
      });
    }
    if (autoScrollOptions.pauseOnFocus) {
      bind(root, "focusin focusout", (e) => {
        focused = e.type === "focusin";
        autoToggle();
      });
    }
    if (autoScrollOptions.useToggleButton) {
      bind(toggle, "click", () => {
        stopped ? play() : pause();
      });
    }
    on(EVENT_UPDATED, update);
    on([EVENT_MOVE, EVENT_DRAG, EVENT_SCROLL], () => {
      busy = true;
      pause(false);
    });
    on([EVENT_MOVED, EVENT_DRAGGED, EVENT_SCROLLED], () => {
      busy = false;
      autoToggle();
    });
  }
  function update() {
    const { autoScroll } = options;
    if (autoScroll !== false) {
      autoScrollOptions = splide_extension_auto_scroll_esm_esm_assign({}, autoScrollOptions, isObject(autoScroll) ? autoScroll : {});
      mount();
    } else {
      destroy();
    }
    if (interval && !isUndefined(currPosition)) {
      translate(currPosition);
    }
  }
  function autoStart() {
    if (autoScrollOptions.autoStart) {
      if (document.readyState === "complete") {
        play();
      } else {
        bind(window, "load", play);
      }
    }
  }
  function play() {
    if (isPaused()) {
      interval.start(true);
      Live.disable(true);
      focused = hovered = stopped = false;
      updateButton();
    }
  }
  function pause(stop = true) {
    if (!stopped) {
      stopped = stop;
      updateButton();
      if (!isPaused()) {
        interval.pause();
        Live.disable(false);
      }
    }
  }
  function autoToggle() {
    if (!stopped) {
      hovered || focused || busy ? pause(false) : play();
    }
  }
  function move() {
    const position = getPosition();
    const destination = computeDestination(position);
    if (position !== destination) {
      translate(destination);
      updateIndex(currPosition = getPosition());
    } else {
      pause(false);
      if (autoScrollOptions.rewind) {
        Splide2.go(autoScrollOptions.speed > 0 ? 0 : Components2.Controller.getEnd());
      }
    }
    throttledUpdateArrows();
  }
  function computeDestination(position) {
    const speed = autoScrollOptions.speed || 1;
    position += orient(speed);
    if (Splide2.is(SLIDE)) {
      position = clamp(position, getLimit(false), getLimit(true));
    }
    return position;
  }
  function updateIndex(position) {
    const { length } = Splide2;
    const index = (toIndex(position) + length) % length;
    if (index !== getIndex()) {
      setIndex(index);
      Components2.Slides.update();
      Components2.Pagination.update();
      options.lazyLoad === "nearby" && Components2.LazyLoad.check();
    }
  }
  function updateButton() {
    if (toggle) {
      const key = stopped ? "startScroll" : "pauseScroll";
      toggleClass(toggle, CLASS_ACTIVE, !stopped);
      setAttribute(toggle, "aria-label", options.i18n[key] || I18N[key]);
    }
  }
  function isPaused() {
    return !interval || interval.isPaused();
  }
  return {
    setup,
    mount,
    destroy,
    play,
    pause,
    isPaused
  };
}



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Link/Link.esm.js + 2 modules
var Link_esm = __webpack_require__(26025);
;// CONCATENATED MODULE: ./components/HomePage/PeerEndorsementsCard/styles.ts

var styles_Container = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function() {
    return {
        padding: "16px",
        borderRadius: "16px",
        textAlign: "start",
        width: "260px",
        border: "1px solid #D5DEF9",
        background: "#F4F7FD"
    };
});
var ImagePlaceholder = (0,styled_esm/* default */.ZP)("div")(function() {
    return {
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#9faabe",
        color: "white",
        minWidth: "20px",
        minHeight: "20px"
    };
});
var Text = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)(function() {
    return {
        color: "#11245A",
        fontSize: "13px",
        lineHeight: "20px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        height: "20px",
        textOverflow: "ellipsis",
        width: "100%"
    };
});
var CustomLink = (0,styled_esm/* default */.ZP)(Link_esm/* default */.Z)(function() {
    return {
        textDecoration: "none"
    };
});
var RecommendedFor = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function() {
    return {
        borderRadius: "16px",
        background: "#1A3586",
        textAlign: "center",
        width: "100%",
        color: "#fff",
        fontSize: "13px",
        padding: "2px 12px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    };
});
var ImageWrapper = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function() {
    return {
        width: "33px",
        height: "33px",
        borderRadius: "50%",
        border: "1px solid #00F",
        overflow: "hidden"
    };
});

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Image/index.esm.js
var Image_index_esm = __webpack_require__(80088);
// EXTERNAL MODULE: ./utils/getDomainName.ts
var getDomainName = __webpack_require__(77332);
// EXTERNAL MODULE: ./utils/imageLoaders.ts
var imageLoaders = __webpack_require__(32013);
// EXTERNAL MODULE: ./utils/getConfigVariable.ts
var getConfigVariable = __webpack_require__(81027);
;// CONCATENATED MODULE: ./components/HomePage/PeerEndorsementsCard/index.tsx











var PeerEndorsementsCard = function(param) {
    var avatar = param.avatar, name = param.name, recommendedFor = param.recommendedFor, specialty = param.specialty, recommender = param.recommender, slug = param.slug, recommenderSlug = param.recommenderSlug;
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    var domainName = (0,getDomainName/* default */.Z)();
    var translate = (0,useTranslateMessage/* default */.Z)();
    var originWithLang = (0,url/* purifyTenantDomain */.ng)(domainName, locale);
    var host = (0,getConfigVariable/* default */.Z)("HOST");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink, {
                    href: "".concat(originWithLang, "/specialist/").concat(slug),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_index_esm/* default */.Z, {
                        src: (0,imageLoaders/* preloadImageLoader */.z6)({
                            src: avatar || "",
                            host: host
                        }),
                        alt: "avatar",
                        width: 33,
                        height: 33
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink, {
                        href: "".concat(originWithLang, "/specialist/").concat(slug),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyMedium, {
                            sx: {
                                fontWeight: 500,
                                color: "#11245A",
                                mt: "12px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                width: "100%"
                            },
                            children: name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        children: specialty
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        children: translate("homepage.endorsement.card.recommended-by")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink, {
                        href: "".concat(originWithLang, "/specialist/").concat(recommenderSlug),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            children: [
                                (recommender === null || recommender === void 0 ? void 0 : recommender.avatar) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_index_esm/* default */.Z, {
                                    lazy: true,
                                    src: (0,imageLoaders/* preloadImageLoader */.z6)({
                                        src: recommender === null || recommender === void 0 ? void 0 : recommender.avatar,
                                        host: host
                                    }),
                                    alt: "Recommender avatar",
                                    width: 20,
                                    style: {
                                        borderRadius: "50%"
                                    },
                                    height: 20
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePlaceholder, {
                                    style: {
                                        width: "20px",
                                        height: "20px",
                                        fontSize: "8px"
                                    },
                                    children: recommender.initials
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                                    sx: {
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    },
                                    children: [
                                        recommender === null || recommender === void 0 ? void 0 : recommender.name,
                                        " ",
                                        translate("homepage.endorsement.card.for")
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedFor, {
                style: {
                    marginTop: "12px"
                },
                children: recommendedFor
            })
        ]
    });
};
/* harmony default export */ var HomePage_PeerEndorsementsCard = (PeerEndorsementsCard);

;// CONCATENATED MODULE: ./components/HomePage/PeerEndorsementsSection/index.tsx
function PeerEndorsementsSection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PeerEndorsementsSection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var CAROUSEL_OPTIONS = {
    type: "loop",
    lazyLoad: "sequential",
    perMove: 1,
    gap: "24px",
    drag: "free",
    autoWidth: true,
    autoScroll: {
        speed: 0.5,
        pauseOnHover: true,
        pauseOnFocus: false
    },
    pagination: false,
    arrows: false
};
var PeerEndorsementsSection = function(param) {
    var endorsements = param.endorsements;
    var translate = (0,useTranslateMessage/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        sx: {
            maxWidth: "100%",
            padding: 0,
            marginBottom: "24px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
            sx: {
                display: "flex",
                flexDirection: "column",
                gap: "32px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyLarge, {
                    variant: "h3",
                    children: translate("homepage.search.peerrecomendation.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Carousel */.lr, {
                    lazyLoad: true,
                    options: CAROUSEL_OPTIONS,
                    extensions: {
                        AutoScroll: AutoScroll
                    },
                    children: endorsements === null || endorsements === void 0 ? void 0 : endorsements.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselSlide */.qs, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_PeerEndorsementsCard, _objectSpread({}, item))
                        }, item.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var HomePage_PeerEndorsementsSection = (PeerEndorsementsSection);

;// CONCATENATED MODULE: ./components/HomePage/ReviewCard/styles.ts

var Specialties = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)(function() {
    return {
        color: "#051851",
        fontSize: "12px",
        lineHeight: "18px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "200px",
        display: "block"
    };
});
var ReviewCard_styles_Container = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function() {
    return {
        padding: "24px",
        marginBottom: "24px",
        backgroundColor: "#FFF",
        borderRadius: "16px",
        border: "1px solid #D5DEF9",
        textAlign: "start",
        width: "100%",
        height: "300px",
        outline: "none"
    };
});
var ReviewHeader = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function() {
    return {
        display: "flex",
        alignItems: "center",
        gap: "14px",
        borderBottom: "1px solid #D5DEF9",
        paddingBottom: "16px",
        marginBottom: "16px",
        maxHeight: "57px"
    };
});
var Verified = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)(function() {
    return {
        color: "#2C3341",
        fontSize: "11px",
        lineHeight: "14px",
        textShadow: "0px 1px 2px rgba(0, 0, 0, 0.04)"
    };
});
var SeenFor = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)(function() {
    return {
        color: "#4C5870",
        fontSize: "11px",
        fontWeight: 500,
        lineHeight: "14px",
        whiteSpace: "nowrap"
    };
});
var Tag = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function() {
    return {
        backgroundColor: "#EAEEFC",
        borderRadius: "16px",
        lineHeight: "20px",
        fontSize: "13px",
        fontWeight: 500,
        padding: "2px 12px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: "#1A3586"
    };
});
var RatingWrapper = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function() {
    return {
        display: "flex",
        alignItems: "start",
        gap: "8px"
    };
});
var styles_CustomLink = (0,styled_esm/* default */.ZP)(Link_esm/* default */.Z)(function() {
    return {
        textDecoration: "none",
        fontWeight: 500,
        lineHeight: "22px",
        color: "#051851",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "220px",
        display: "block"
    };
});

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/useMediaQuery/useMediaQuery.esm.js
var useMediaQuery_esm = __webpack_require__(45077);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/components/Rating/index.esm.js
var Rating_index_esm = __webpack_require__(98855);
// EXTERNAL MODULE: ./constants/global.ts
var global = __webpack_require__(14257);
;// CONCATENATED MODULE: ./components/HomePage/ReviewCard/index.tsx
function ReviewCard_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ReviewCard_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ReviewCard_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var ReviewCard = function(param) {
    var avatar = param.avatar, name = param.name, specialties = param.specialties, review = param.review, hrefToRedirect = param.hrefToRedirect, initials = param.initials;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var ref = (0,react.useState)(false), cardIsFocused = ref[0], setCardIsFocused = ref[1];
    var containerRef = (0,react.useRef)(null);
    var theme = (0,useTheme_esm/* default */.Z)();
    var isDesktop = (0,useMediaQuery_esm/* default */.Z)(theme.breakpoints.up("sm"));
    var handleToggleFocusContainer = (0,react.useCallback)(function() {
        return setCardIsFocused(function(prev) {
            return !prev;
        });
    }, []);
    (0,react.useEffect)(function() {
        if (containerRef.current && !isDesktop) {
            if (cardIsFocused) {
                containerRef.current.focus();
            } else {
                containerRef.current.blur();
            }
        }
    }, [
        cardIsFocused,
        isDesktop
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewCard_styles_Container, ReviewCard_objectSpread({
        ref: containerRef
    }, !isDesktop && {
        tabindex: "0",
        onTouchStart: handleToggleFocusContainer,
        onTouchEnd: handleToggleFocusContainer
    }, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ReviewHeader, {
                children: [
                    avatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: avatar || global/* PATH_TO_UNAVAILABLE_IMG */.Dv,
                        alt: "User avatar",
                        style: {
                            borderRadius: "50%",
                            cursor: "pointer"
                        },
                        width: 40,
                        height: 40,
                        onClick: function() {
                            return window.location.assign(hrefToRedirect);
                        }
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePlaceholder, {
                        style: {
                            width: "40px",
                            height: "40px",
                            fontSize: "20px"
                        },
                        children: initials
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_CustomLink, {
                                href: hrefToRedirect,
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Specialties, {
                                children: specialties
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RatingWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating_index_esm/* default */.Z, {
                                value: +review.rating,
                                size: "small",
                                readOnly: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyMedium, {
                                sx: {
                                    fontWeight: 600
                                },
                                children: review.rating
                            })
                        ]
                    }),
                    review.isVerified && /*#__PURE__*/ (0,jsx_runtime.jsx)(Verified, {
                        children: translate("homepage.review.card.verified")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyMedium, {
                sx: {
                    my: "16px",
                    color: "#2C3341",
                    minHeight: "100px"
                },
                children: review.message
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "flex",
                    gap: "8px",
                    alignItems: "center"
                },
                children: !!review.seenFor.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SeenFor, {
                            children: translate("homepage.review.card.seen-for")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                            sx: {
                                maxWidth: "100%"
                            },
                            children: review.seenFor[0].name
                        }, review.seenFor[0].name)
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var HomePage_ReviewCard = (ReviewCard);

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/system/esm/styled.esm.js
var esm_styled_esm = __webpack_require__(64495);
;// CONCATENATED MODULE: ./components/HomePage/ReviewsSection/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  transition: opacity 0.5s ease-in-out;\n\n  &.splide__slide.is-visible {\n    opacity: 1;\n\n    & > div {\n      transform: scale(1);\n      transition: transform 0.5s ease-in-out;\n    }\n  }\n\n  &:not(.is-visible) {\n    opacity: 0;\n\n    & > div {\n      transform: scale(0.8);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledSplideSlide = (0,esm_styled_esm/* default */.Z)(index_esm/* CarouselSlide */.qs)(_templateObject());

;// CONCATENATED MODULE: ./components/HomePage/ReviewsSection/index.tsx
function ReviewsSection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ReviewsSection_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ReviewsSection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var ReviewsSection = function(param) {
    var reviews = param.reviews;
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    var domainName = (0,getDomainName/* default */.Z)();
    var originWithLang = (0,url/* purifyTenantDomain */.ng)(domainName, locale);
    var hrefBuilder = function(type, slug) {
        return "".concat(originWithLang, "/").concat(type, "/").concat(slug);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
            sx: {
                display: "flex",
                flexDirection: "column",
                gap: {
                    xs: "48px",
                    md: "32px"
                }
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Carousel */.lr, {
                navigationPosition: "bottom",
                options: {
                    autoplay: true,
                    rewind: true,
                    interval: 4000,
                    autoScroll: {
                        pauseOnHover: true,
                        pauseOnFocus: true
                    }
                },
                breakpoints: {
                    768: {
                        perPage: 1
                    },
                    1024: {
                        perPage: 2
                    }
                },
                spaceBetween: 24,
                navButtonStyles: {
                    background: "none",
                    svg: {
                        width: "16px",
                        height: "16px"
                    },
                    width: "40px",
                    height: "40px",
                    "svg > path": {
                        fill: "#11245A"
                    }
                },
                navigation: true,
                slidesPerView: 3,
                lazyLoad: true,
                children: reviews === null || reviews === void 0 ? void 0 : reviews.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSplideSlide, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_ReviewCard, ReviewsSection_objectSpread({}, item, {
                            hrefToRedirect: hrefBuilder(item.type, item.slug)
                        }))
                    }, item.id);
                })
            })
        })
    });
};
/* harmony default export */ var HomePage_ReviewsSection = (ReviewsSection);

;// CONCATENATED MODULE: ./components/HomePage/SpecialtiesSection/styles.ts
function SpecialtiesSection_styles_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: 30px;\n  font-weight: 700;\n  background: linear-gradient(0deg, #2B59E0, #2B59E0),\n              linear-gradient(90deg, rgba(17, 41, 113, 0.5) 0%, rgba(43, 89, 224, 0.5) 99.99%, rgba(43, 89, 224, 0.5) 100%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  color: transparent;\n  margin: 0;\n  -webkit-text-fill-color: transparent;\n  @media (max-width: 768px) {\n    text-align: center;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  padding: 8px 24px;\n  border-radius: 20px;\n  border: 1px solid #1A3586;\n  height: 40px;\n  width: fit-content;\n  background-color: transparent;\n  color: #1A3586;\n  font-weight: 500;\n  font-size: 15px;\n  text-decoration: none;\n  line-height: 22px;\n  box-shadow: 0px 1px 2px 0px #0000000A;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  &:hover {\n  background-color: #EAEEFC;\n  }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 24px;\n  justify-content: center;\n  @media (max-width: 1110px) {\n    flex-wrap: wrap;\n    max-width: 700px;\n  } \n  @media (max-width: 768px) {\n    flex-wrap: wrap;\n    width: 100%;\n    max-width: 578px;\n  }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var DefaultContainer = (0,styled_esm/* default */.ZP)("section")({
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
    width: "100%",
    padding: "0px 16px 22px 16px",
    "@media (max-width: 1110px)": {
        justifyContent: "center",
        alignItems: "center",
        padding: "0px 120px 12px 120px"
    },
    "@media (max-width: 768px)": {
        padding: "0px 16px 12px 16px"
    }
});
var Variant2Container = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gridRowGap: "54px",
        gridColumnGap: "32px"
    }, SpecialtiesSection_styles_defineProperty(_obj, theme.breakpoints.down("lg"), {
        gridTemplateColumns: "repeat(3, 1fr)"
    }), SpecialtiesSection_styles_defineProperty(_obj, theme.breakpoints.down("md"), {
        gridTemplateColumns: "repeat(2, 1fr)"
    }), SpecialtiesSection_styles_defineProperty(_obj, theme.breakpoints.down("sm"), {
        gridTemplateColumns: "repeat(1, 1fr)"
    }), _obj;
});
var TitleContainer = (0,styled_esm/* default */.ZP)("div")({
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    alignItems: "center"
});
var styles_Title = (0,styled_esm/* default */.ZP)("h2")(styles_templateObject());
var SeeButton = (0,styled_esm/* default */.ZP)("a")(_templateObject1());
var RoundCardContainer = (0,styled_esm/* default */.ZP)("div")(_templateObject2());

;// CONCATENATED MODULE: ./components/HomePage/SpecialtiesSection/components/RoundCard/styles.ts
function RoundCard_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function RoundCard_styles_templateObject() {
    var data = RoundCard_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: center;\n  max-width: 162px;\n  cursor: pointer;\n  @media (max-width: 768px) {\n  max-width: 132px;\n  }\n  "
    ]);
    RoundCard_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = RoundCard_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 163px;\n  height: 163px;\n  border-radius: 50%;\n  background-color: #f4f7fd;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 0;\n  overflow: hidden;\n  border: 1px solid #AABDF3;\n  transition: background-color 0.3s ease-in-out;\n\n  &::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    padding: 2px;\n    border-radius: 50%;\n    background: ",
        ";\n    -webkit-mask:\n      linear-gradient(#fff 0 0) content-box,\n      linear-gradient(#fff 0 0);\n    -webkit-mask-composite: xor;\n    mask-composite: exclude;\n    transition: opacity 0.3s ease-in-out;\n    opacity: 0;\n    z-index: -1;\n  }\n\n  &:hover::before {\n    opacity: 1;\n  }\n\n  &:hover {\n    background-color: transparent;\n  }\n\n  @media (max-width: 768px) {\n    width: 132px;\n    height: 132px;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = RoundCard_styles_taggedTemplateLiteral([
        "\n  color: #2A2461;\n  font-weight: 500;\n  font-size: 15px;\n  text-align: center;\n  text-decoration: none;\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = RoundCard_styles_taggedTemplateLiteral([
        "\n  object-fit: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var CardContainer = (0,styled_esm/* default */.ZP)("div")(RoundCard_styles_templateObject());
var CustomRound = (0,styled_esm/* default */.ZP)("span")(styles_templateObject1(), function(param) {
    var gradient = param.gradient;
    return gradient;
});
var CardText = (0,styled_esm/* default */.ZP)("a")(styles_templateObject2());
var CustomImage = (0,styled_esm/* default */.ZP)((image_default()))(_templateObject3(), function(param) {
    var isAltImage = param.isAltImage;
    return isAltImage ? "" : "contain";
});

;// CONCATENATED MODULE: ./components/HomePage/SpecialtiesSection/components/RoundCard/index.tsx





var RoundCard = function(param) {
    var icon = param.icon, altIcon = param.altIcon, text = param.text, _gradient = param.gradient, gradient = _gradient === void 0 ? "linear-gradient(180deg, #FFD633 0%, #FFA19D 100%)" : _gradient, linkToRedirect = param.linkToRedirect;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomRound, {
                gradient: gradient,
                onClick: function() {
                    return window.location.assign(linkToRedirect);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                        smDown: true,
                        implementation: "css",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage, {
                            src: icon || altIcon || global/* PATH_TO_UNAVAILABLE_IMG */.Dv,
                            isAltImage: !icon,
                            width: 78,
                            height: 78,
                            alt: "specialty"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                        smUp: true,
                        implementation: "css",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage, {
                            src: icon || altIcon || global/* PATH_TO_UNAVAILABLE_IMG */.Dv,
                            isAltImage: !icon,
                            width: 62,
                            height: 62,
                            alt: "specialty"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardText, {
                href: linkToRedirect,
                children: text
            })
        ]
    });
};
/* harmony default export */ var components_RoundCard = (RoundCard);

;// CONCATENATED MODULE: ./components/HomePage/SpecialtiesSection/components/ServiceArea/styles.ts
function ServiceArea_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ServiceArea_styles_templateObject() {
    var data = ServiceArea_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n"
    ]);
    ServiceArea_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ServiceArea_styles_templateObject1() {
    var data = ServiceArea_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 43px;\n  align-items: center;\n  justify-content: center;\n  "
    ]);
    ServiceArea_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ServiceArea_styles_templateObject2() {
    var data = ServiceArea_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 16px;\n  flex-direction: column;\n  "
    ]);
    ServiceArea_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = ServiceArea_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 32px;\n  "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = ServiceArea_styles_taggedTemplateLiteral([
        "\n  color: #11245A;\n  font-weight: 500;\n  font-size: 18px;\n  margin: 0;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var ServiceArea_styles_Container = (0,styled_esm/* default */.ZP)("div")(ServiceArea_styles_templateObject());
var AreasItemsContainer = (0,styled_esm/* default */.ZP)("div")(ServiceArea_styles_templateObject1());
var MobileAreasItemsContainer = (0,styled_esm/* default */.ZP)("div")(ServiceArea_styles_templateObject2());
var MobileContainer = (0,styled_esm/* default */.ZP)("div")(styles_templateObject3());
var MainText = (0,styled_esm/* default */.ZP)("h2")(_templateObject4());

;// CONCATENATED MODULE: ./components/HomePage/SpecialtiesSection/components/AreasItem/styles.ts
function AreasItem_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function AreasItem_styles_templateObject() {
    var data = AreasItem_styles_taggedTemplateLiteral([
        "\n  height: 48px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n"
    ]);
    AreasItem_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AreasItem_styles_templateObject1() {
    var data = AreasItem_styles_taggedTemplateLiteral([
        "\n  font-weight: 500;\n  font-size: 15px;\n  color: #11245A;\n  text-wrap: nowrap;\n  "
    ]);
    AreasItem_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AreasItem_styles_templateObject2() {
    var data = AreasItem_styles_taggedTemplateLiteral([
        "\n  width: 22px;\n  heigth: 22px;\n  "
    ]);
    AreasItem_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var StyledContainer = (0,styled_esm/* default */.ZP)("div")(AreasItem_styles_templateObject());
var StyledText = (0,styled_esm/* default */.ZP)("span")(AreasItem_styles_templateObject1());
var ImageContainer = (0,styled_esm/* default */.ZP)("div")(AreasItem_styles_templateObject2());

;// CONCATENATED MODULE: ./components/HomePage/SpecialtiesSection/components/AreasItem/index.tsx






var AreasItem = function(param) {
    var icon = param.icon, text = param.text;
    var domain = (0,getDomainName/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    loader: imageLoaders/* defaultLoader */.xy,
                    src: "".concat(domain, "/hermes-static/icons/").concat(icon, ".svg"),
                    alt: "",
                    width: 22,
                    height: 22,
                    objectFit: "none"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                children: text
            })
        ]
    });
};
/* harmony default export */ var components_AreasItem = (AreasItem);

;// CONCATENATED MODULE: ./components/HomePage/SpecialtiesSection/components/ServiceArea/index.tsx






var ServiceArea = function() {
    var translate = (0,useTranslateMessage/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ServiceArea_styles_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainText, {
                children: translate("home-page.specialties.service")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                mdDown: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AreasItemsContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AreasItem, {
                            icon: "HeartPulseIcon",
                            text: translate("specialists")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AreasItem, {
                            icon: "ClinicIcon",
                            text: translate("practices")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AreasItem, {
                            icon: "DentistIcon",
                            text: translate("dentist")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AreasItem, {
                            icon: "HospitalIcon",
                            text: translate("hospitals")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AreasItem, {
                            icon: "CareHomeIcon",
                            text: translate("care-home")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AreasItem, {
                            icon: "PharmaciesIcon",
                            text: translate("pharmacies")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AreasItem, {
                            icon: "HomeCareSpecIcon",
                            text: translate("home-care-one")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                mdUp: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileAreasItemsContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AreasItem, {
                                    icon: "HeartPulseIcon",
                                    text: translate("specialists")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AreasItem, {
                                    icon: "ClinicIcon",
                                    text: translate("practices")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AreasItem, {
                                    icon: "DentistIcon",
                                    text: translate("dentist")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AreasItem, {
                                    icon: "HospitalIcon",
                                    text: translate("hospitals")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileAreasItemsContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AreasItem, {
                                    icon: "CareHomeIcon",
                                    text: translate("care-home")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AreasItem, {
                                    icon: "PharmaciesIcon",
                                    text: translate("pharmacies")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AreasItem, {
                                    icon: "HomeCareSpecIcon",
                                    text: translate("home-care-one")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_ServiceArea = (ServiceArea);

// EXTERNAL MODULE: ./utils/getCountryByLocale.ts
var getCountryByLocale = __webpack_require__(89794);
;// CONCATENATED MODULE: ./components/HomePage/SpecialtiesSection/components/SectionItemVarTwo/styles.ts
function SectionItemVarTwo_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SectionItemVarTwo_styles_templateObject() {
    var data = SectionItemVarTwo_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  cursor: pointer;\n  text-decoration: none;\n  @media (max-width: 768px) {\n  width: 100%;\n  justify-content: space-between;\n  padding: 0 12px;\n  }\n  "
    ]);
    SectionItemVarTwo_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SectionItemVarTwo_styles_templateObject1() {
    var data = SectionItemVarTwo_styles_taggedTemplateLiteral([
        "\n  margin-top: -50%;\n  margin-left: -50%;\n  "
    ]);
    SectionItemVarTwo_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SectionItemVarTwo_styles_templateObject2() {
    var data = SectionItemVarTwo_styles_taggedTemplateLiteral([
        "\n  font-weight: 500;\n  font-size: 14px;\n  color: #11245A;\n  width: 165px;\n  text-decoration: none;\n  text-align: left;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;    \n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  @media (max-width: 768px) {\n    width: 100%;\n    white-space: normal;\n  }\n  "
    ]);
    SectionItemVarTwo_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SectionItemVarTwo_styles_templateObject3() {
    var data = SectionItemVarTwo_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  @media (max-width: 768px) {\n  gap: 20px;\n  }"
    ]);
    SectionItemVarTwo_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = SectionItemVarTwo_styles_taggedTemplateLiteral([
        "\n  width: 30px;\n  height: 30px;\n  min-width: 30px;\n  "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var styles_StyledContainer = (0,styled_esm/* default */.ZP)("div")(SectionItemVarTwo_styles_templateObject());
var StyledImage = (0,styled_esm/* default */.ZP)((image_default()))(SectionItemVarTwo_styles_templateObject1());
var styles_StyledText = (0,styled_esm/* default */.ZP)("a")(SectionItemVarTwo_styles_templateObject2());
var SubContainer = (0,styled_esm/* default */.ZP)("div")(SectionItemVarTwo_styles_templateObject3());
var styles_ImageContainer = (0,styled_esm/* default */.ZP)("span")(styles_templateObject4());

;// CONCATENATED MODULE: ./components/HomePage/icons/ArrowRightIcon.tsx
function ArrowRightIcon_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ArrowRightIcon_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ArrowRightIcon_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var ArrowRightIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", ArrowRightIcon_objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 18,
        fill: "none"
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#11245A",
            fillRule: "evenodd",
            d: "m7.592 2.603-.002.002 5.58 5.59H1a1 1 0 1 0 0 2h12.17l-5.58 5.59.002.002a.996.996 0 1 0 1.413 1.403L17 9.195 9.034 1.23a.996.996 0 1 0-1.442 1.373Z",
            clipRule: "evenodd"
        })
    }));
};
/* harmony default export */ var icons_ArrowRightIcon = (ArrowRightIcon);

;// CONCATENATED MODULE: ./components/HomePage/SpecialtiesSection/components/SectionItemVarTwo/index.tsx





var SectionItemVarTwo = function(param) {
    var name = param.name, img = param.img, linkToRedirect = param.linkToRedirect;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_StyledContainer, {
        onClick: function() {
            window.location.href = linkToRedirect;
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ImageContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                            loader: imageLoaders/* defaultLoader */.xy,
                            width: 60,
                            height: 60,
                            src: img,
                            alt: name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_StyledText, {
                        onClick: function(e) {
                            return e.preventDefault();
                        },
                        href: linkToRedirect,
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ArrowRightIcon, {
                style: {
                    minWidth: "fit-content"
                }
            })
        ]
    });
};
/* harmony default export */ var components_SectionItemVarTwo = (SectionItemVarTwo);

;// CONCATENATED MODULE: ./components/HomePage/SpecialtiesSection/index.tsx











var DefaultVariant = function(param1) {
    var specialties = param1.specialties;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var ref = (0,react.useContext)(AppData/* AppDataContext */.R), locale = ref.locale, language = ref.language;
    var domainName = (0,getDomainName/* default */.Z)();
    var originWithLang = (0,url/* purifyTenantDomain */.ng)(domainName, locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DefaultContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleContainer, {
                sx: {
                    marginBottom: "40px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Title, {
                        children: translate("home-page.specialties.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SeeButton, {
                        href: "".concat(originWithLang, "/find/all/").concat((0,getCountryByLocale/* default */.Z)(locale), "/specialists"),
                        children: translate("home-page.specialties.button")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundCardContainer, {
                sx: {
                    marginBottom: {
                        md: "96px",
                        xs: "72px"
                    }
                },
                children: specialties.map(function(param) {
                    var iconUri = param.iconUri, icon = param.icon, name = param.name, gradient = param.gradient, id = param.id, slug = param.slug;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RoundCard, {
                        altIcon: iconUri,
                        icon: icon,
                        text: name[language],
                        gradient: gradient,
                        linkToRedirect: "".concat(originWithLang, "/find/").concat(slug, "/").concat((0,getCountryByLocale/* default */.Z)(locale), "/specialists")
                    }, id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ServiceArea, {})
        ]
    });
};
var Variant2 = function(param2) {
    var specialties = param2.specialties;
    var ref = (0,react.useContext)(AppData/* AppDataContext */.R), locale = ref.locale, language = ref.language;
    var domainName = (0,getDomainName/* default */.Z)();
    var originWithLang = (0,url/* purifyTenantDomain */.ng)(domainName, locale);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Variant2Container, {
        children: specialties.map(function(param) {
            var id = param.id, name = param.name, icon = param.icon, slug = param.slug;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SectionItemVarTwo, {
                linkToRedirect: "".concat(originWithLang, "/find/").concat(slug, "/").concat((0,getCountryByLocale/* default */.Z)(locale), "/specialists"),
                name: name[language],
                img: icon
            }, id);
        })
    });
};
var SpecialtiesSection = function(param) {
    var specialties = param.specialties, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant;
    switch(variant){
        case "default":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultVariant, {
                    specialties: specialties
                });
            }
        case "variant2":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Variant2, {
                    specialties: specialties
                });
            }
    }
};
/* harmony default export */ var HomePage_SpecialtiesSection = (SpecialtiesSection);

;// CONCATENATED MODULE: ./components/HomePage/TrustSection/styles.ts
function TrustSection_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function TrustSection_styles_templateObject() {
    var data = TrustSection_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  "
    ]);
    TrustSection_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TrustSection_styles_templateObject1() {
    var data = TrustSection_styles_taggedTemplateLiteral([
        "\n  font-weight: 700;\n  font-size: 24px;\n  color: #2A2461;\n  text-wrap: nowrap;\n  margin: 0;\n  "
    ]);
    TrustSection_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TrustSection_styles_templateObject2() {
    var data = TrustSection_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 24px;\n  height: 72px;\n  align-items: center;\n  overflow: hidden;\n  @media (max-width: 768px) {\n  flex-direction: column;\n  height: 100%;\n  }\n  "
    ]);
    TrustSection_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TrustSection_styles_templateObject3() {
    var data = TrustSection_styles_taggedTemplateLiteral([
        "\n  background-color: #11245A;\n  height: 100%;\n  width: 1px;\n  min-width: 1px;\n  "
    ]);
    TrustSection_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var TrustSection_styles_Container = (0,styled_esm/* default */.ZP)("div")(TrustSection_styles_templateObject());
var ProudlyText = (0,styled_esm/* default */.ZP)("h2")(TrustSection_styles_templateObject1());
var TrustedByContainer = (0,styled_esm/* default */.ZP)("div")(TrustSection_styles_templateObject2());
var Line = (0,styled_esm/* default */.ZP)("div")(TrustSection_styles_templateObject3());

;// CONCATENATED MODULE: ./components/HomePage/TrustSection/index.tsx







var TrustSection_CAROUSEL_OPTIONS = {
    type: "loop",
    lazyLoad: "sequential",
    perMove: 1,
    gap: "45px",
    drag: "free",
    autoWidth: true,
    autoScroll: {
        speed: 0.5,
        pauseOnHover: true,
        pauseOnFocus: false
    },
    pagination: false,
    arrows: false
};
var iconsArray = [
    {
        mockId: 1,
        name: "Nuffiled",
        width: 125
    },
    {
        mockId: 2,
        name: "HCA",
        width: 125
    },
    {
        mockId: 3,
        name: "Optegra",
        width: 90
    },
    {
        mockId: 4,
        name: "Vitality",
        width: 81
    },
    {
        mockId: 5,
        name: "WPA",
        width: 55
    },
    {
        mockId: 6,
        name: "Ramsay",
        width: 46
    },
    {
        mockId: 7,
        name: "Cleavland",
        width: 232
    }
];
var TrustSection = function() {
    var host = (0,getConfigVariable/* default */.Z)("HOST");
    var translate = (0,useTranslateMessage/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustSection_styles_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrustedByContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProudlyText, {
                    children: translate("homepage.trust.carousel.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Line, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Carousel */.lr, {
                    lazyLoad: true,
                    updateOnMove: true,
                    options: TrustSection_CAROUSEL_OPTIONS,
                    extensions: {
                        AutoScroll: AutoScroll
                    },
                    sx: {
                        width: "100%"
                    },
                    children: iconsArray === null || iconsArray === void 0 ? void 0 : iconsArray.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* CarouselSlide */.qs, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: item.width
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_index_esm/* default */.Z, {
                                    lazy: true,
                                    src: (0,imageLoaders/* preloadImageLoader */.z6)({
                                        src: "/hermes-static/images/trustedCompanies/".concat(item.name, ".png"),
                                        host: host
                                    }),
                                    width: item.width,
                                    style: {
                                        objectFit: "contain"
                                    },
                                    height: 40,
                                    alt: "Provider image ".concat(item.name)
                                })
                            })
                        }, item.mockId);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var HomePage_TrustSection = (TrustSection);

;// CONCATENATED MODULE: ./components/HomePage/InsightItem/styles.ts
function InsightItem_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function InsightItem_styles_templateObject() {
    var data = InsightItem_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  width: 243px;\n  flex-direction: column;\n  gap: 8px;\n  @media (max-width: 768px) {\n    padding: 24px 0;\n    border-top: 1px solid #D5DEF9;\n    gap: 0px;\n    width: 100%;\n  }\n  "
    ]);
    InsightItem_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function InsightItem_styles_templateObject1() {
    var data = InsightItem_styles_taggedTemplateLiteral([
        "\n  color: #2A2461;\n  font-weight: 700;\n  font-size: 24px;\n  text-align: start;\n  line-height: 32px;\n  margin: 0;\n  @media (max-width: 768px) {\n    margin: 0;\n    line-height: 32px;\n    font-size: 18px;\n    font-weight: 500;\n  }\n  "
    ]);
    InsightItem_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function InsightItem_styles_templateObject2() {
    var data = InsightItem_styles_taggedTemplateLiteral([
        "\n  color: #2A2461;\n  font-weight: 400;\n  font-size: 15px;\n  text-align: start;\n  line-height: 20px;\n  "
    ]);
    InsightItem_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var InsightItem_styles_Container = (0,styled_esm/* default */.ZP)("div")(InsightItem_styles_templateObject());
var InsightItem_styles_Title = (0,styled_esm/* default */.ZP)("h3")(InsightItem_styles_templateObject1());
var Subtitle = (0,styled_esm/* default */.ZP)("span")(InsightItem_styles_templateObject2());

;// CONCATENATED MODULE: ./components/HomePage/InsightItem/index.tsx



var InsightItem = function(param) {
    var title = param.title, subtitle = param.subtitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InsightItem_styles_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InsightItem_styles_Title, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                children: subtitle
            })
        ]
    });
};
/* harmony default export */ var HomePage_InsightItem = (InsightItem);

;// CONCATENATED MODULE: ./components/HomePage/ReviewVideo/styles.ts

var VideoWrapper = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function() {
    return {
        width: "265px",
        position: "relative",
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "8px",
        height: "430px",
        overflow: "hidden",
        border: "1.5px solid transparent",
        cursor: "pointer",
        span: {
            height: "100% !important",
            img: {
                objectFit: "cover"
            }
        },
        "& #sub-video-wrapper": {
            transition: "box-shadow 0.3s ease-in-out"
        },
        "&:hover": {
            "& #sub-video-wrapper": {
                boxShadow: "0px -140px 61px -21px rgba(17,36,90,0.78) inset"
            }
        }
    };
});
var ContentWrapper = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP)({
    flexWrap: "nowrap",
    padding: "19px 16px",
    paddingTop: "20%",
    justifyContent: "space-between",
    gap: "50px",
    "@media (max-width: 681px)": {
        flexWrap: "wrap",
        gap: "10px"
    }
});
var SubVideoWrapper = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP)({
    background: "linear-gradient(180deg, rgba(217, 217, 217, 0) 0%, rgba(13, 12, 14, 0.52) 76.56%)",
    boxShadow: "inset 0px -69px 57px -21px rgba(17,36,90,0.82)"
});

;// CONCATENATED MODULE: ./components/HomePage/ReviewVideo/index.tsx







var ReviewVideo = function(param) {
    var image = param.image, practitioner = param.practitioner, title = param.title, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoWrapper, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: image || global/* PATH_TO_UNAVAILABLE_IMG */.Dv,
                layout: "fill",
                style: {
                    position: "absolute",
                    objectFit: "cover",
                    zIndex: 0
                },
                loading: "lazy",
                alt: title || "",
                loader: imageLoaders/* doctifyCDNLoader */.Ux
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubVideoWrapper, {
                container: true,
                position: "absolute",
                zIndex: 1,
                justifyContent: "space-between",
                flexDirection: "column",
                wrap: "nowrap",
                id: "sub-video-wrapper",
                top: 0,
                height: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                        item: true,
                        padding: "19px 16px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, {
                        container: true,
                        color: "common.white",
                        id: "content-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                            container: true,
                            gap: "8px",
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                    display: "flex",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_index_esm/* default */.Z, {
                                        src: "/hermes-static/icons/video-play-icon.svg",
                                        width: 11,
                                        alt: "play video"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                    variant: "h4",
                                    fontWeight: 600,
                                    fontSize: "24px",
                                    lineHeight: "35.14px",
                                    sx: {
                                        display: "-webkit-box",
                                        WebkitLineClamp: "3",
                                        overflow: "hidden",
                                        WebkitBoxOrient: "vertical",
                                        textAlign: "start"
                                    },
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                    fontSize: "15px",
                                    fontWeight: 500,
                                    lineHeight: "130%",
                                    sx: {
                                        display: "-webkit-box",
                                        WebkitLineClamp: "2",
                                        overflow: "hidden",
                                        WebkitBoxOrient: "vertical",
                                        textAlign: "start"
                                    },
                                    children: practitioner
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var HomePage_ReviewVideo = (ReviewVideo);

;// CONCATENATED MODULE: ./components/HomePage/VideoReviews/styles.ts
function VideoReviews_styles_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function VideoReviews_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function VideoReviews_styles_templateObject() {
    var data = VideoReviews_styles_taggedTemplateLiteral([
        "\n  border: none;\n  background-color: transparent;\n  "
    ]);
    VideoReviews_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function VideoReviews_styles_templateObject1() {
    var data = VideoReviews_styles_taggedTemplateLiteral([
        "\n  width: calc(100vw - ((100vw - 1064px) / 2));\n  @media (max-width: 768px) {\n    width: calc(100% + 16px)\n  }\n  "
    ]);
    VideoReviews_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var Button = (0,styled_esm/* default */.ZP)("button")(VideoReviews_styles_templateObject());
var VideoReviews_styles_Container = (0,styled_esm/* default */.ZP)("div")(VideoReviews_styles_templateObject1());
var ButtonsContainer = (0,styled_esm/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return VideoReviews_styles_defineProperty({
        marginTop: "32px",
        display: "flex",
        gap: "32px"
    }, theme.breakpoints.down("md"), {
        marginTop: "24px"
    });
});

;// CONCATENATED MODULE: ./components/HomePage/VideoReviews/index.tsx








var SPLIDE_OPTIONS = {
    autoWidth: true,
    drag: "free",
    lazyLoad: true,
    gap: "25px",
    pagination: false,
    perMove: 1,
    perPage: 1,
    arrows: false
};
var VideoReviews = function(param) {
    var videoReviews = param.videoReviews;
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    var myCarouselRef = (0,react.useRef)(null);
    var domainName = (0,getDomainName/* default */.Z)();
    var originWithLang = (0,url/* purifyTenantDomain */.ng)(domainName, locale);
    var handleNext = function() {
        var ref;
        (ref = myCarouselRef.current) === null || ref === void 0 ? void 0 : ref.go(">");
    };
    var handlePrev = function() {
        var ref;
        (ref = myCarouselRef.current) === null || ref === void 0 ? void 0 : ref.go("<");
    };
    var handleClickIntroVideo = function(slug) {
        sessionStorage.setItem("showIntroVideo", "true");
        window.location.assign("".concat(originWithLang, "/specialist/").concat(slug));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoReviews_styles_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Carousel */.lr, {
                options: SPLIDE_OPTIONS,
                onRefReady: function(ref) {
                    myCarouselRef.current = ref;
                },
                children: videoReviews.map(function(review) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(index_esm/* CarouselSlide */.qs, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_ReviewVideo, {
                            image: review === null || review === void 0 ? void 0 : review.image,
                            practitioner: review === null || review === void 0 ? void 0 : review.practitioner,
                            title: review === null || review === void 0 ? void 0 : review.title,
                            onClick: function() {
                                return handleClickIntroVideo(review.slug);
                            }
                        })
                    }, review === null || review === void 0 ? void 0 : review.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonsContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        onClick: handlePrev,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/hermes-static/icons/arrow-simple-right.svg",
                            style: {
                                transform: "translateX(-50%) rotate(180deg)"
                            },
                            alt: "left"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        onClick: handleNext,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/hermes-static/icons/arrow-simple-right.svg",
                            alt: "right"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var HomePage_VideoReviews = (VideoReviews);

// EXTERNAL MODULE: ../../../node_modules/next/router.js
var next_router = __webpack_require__(35837);
// EXTERNAL MODULE: ../../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(5001);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./api/autocomplete.ts
var api_autocomplete = __webpack_require__(69115);
;// CONCATENATED MODULE: ./providers/HomePage/types.ts
var AutocompleteSearchTypes;
(function(AutocompleteSearchTypes) {
    AutocompleteSearchTypes["practice"] = "practice";
    AutocompleteSearchTypes["specialist"] = "specialist";
})(AutocompleteSearchTypes || (AutocompleteSearchTypes = {}));
var AlternativeNavigationSearchTypes;
(function(AlternativeNavigationSearchTypes) {
    AlternativeNavigationSearchTypes["practices"] = "practices";
    AlternativeNavigationSearchTypes["specialists"] = "specialists";
    AlternativeNavigationSearchTypes["dentist"] = "dentistry";
    AlternativeNavigationSearchTypes["careHome"] = "care-homes";
    AlternativeNavigationSearchTypes["healthAndSocialCare"] = "home-carers";
    AlternativeNavigationSearchTypes["hospital"] = "hospitals";
    AlternativeNavigationSearchTypes["pharmacy"] = "pharmacies";
})(AlternativeNavigationSearchTypes || (AlternativeNavigationSearchTypes = {}));
var SearchTypes;
(function(SearchTypes) {
    SearchTypes["practices"] = "practices";
    SearchTypes["specialists"] = "specialists";
    SearchTypes["dentist"] = "dentistry";
    SearchTypes["careHome"] = "care-home";
    SearchTypes["healthAndSocialCare"] = "homecare";
    SearchTypes["hospital"] = "hospital";
    SearchTypes["pharmacy"] = "pharmacy";
})(SearchTypes || (SearchTypes = {}));
var ProfileQueryTypes;
(function(ProfileQueryTypes) {
    ProfileQueryTypes[ProfileQueryTypes["dentist"] = SearchTypes.dentist] = "dentist";
    ProfileQueryTypes[ProfileQueryTypes["careHome"] = SearchTypes.careHome] = "careHome";
    ProfileQueryTypes[ProfileQueryTypes["healthAndSocialCare"] = SearchTypes.healthAndSocialCare] = "healthAndSocialCare";
    ProfileQueryTypes[ProfileQueryTypes["hospital"] = SearchTypes.hospital] = "hospital";
    ProfileQueryTypes[ProfileQueryTypes["pharmacy"] = SearchTypes.pharmacy] = "pharmacy";
})(ProfileQueryTypes || (ProfileQueryTypes = {}));
var ProfileTypes;
(function(ProfileTypes) {
    ProfileTypes[ProfileTypes["practices"] = SearchTypes.practices] = "practices";
    ProfileTypes[ProfileTypes["specialists"] = SearchTypes.specialists] = "specialists";
    ProfileTypes[ProfileTypes["dentist"] = SearchTypes.dentist] = "dentist";
    ProfileTypes[ProfileTypes["careHome"] = SearchTypes.careHome] = "careHome";
    ProfileTypes[ProfileTypes["healthAndSocialCare"] = SearchTypes.healthAndSocialCare] = "healthAndSocialCare";
    ProfileTypes[ProfileTypes["hospital"] = SearchTypes.hospital] = "hospital";
    ProfileTypes[ProfileTypes["pharmacy"] = SearchTypes.pharmacy] = "pharmacy";
})(ProfileTypes || (ProfileTypes = {}));
var SortType;
(function(SortType) {
    SortType["relevance"] = "";
    SortType["nearest"] = "nearest";
    SortType["rating"] = "rating";
    SortType["recommended"] = "recommended";
})(SortType || (SortType = {}));

// EXTERNAL MODULE: ./utils/transformAutocomplete.ts
var transformAutocomplete = __webpack_require__(79521);
// EXTERNAL MODULE: ./hooks/useTimeout.ts
var useTimeout = __webpack_require__(61110);
;// CONCATENATED MODULE: ./providers/HomePage/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function HomePage_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function HomePage_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HomePage_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}









var DEFAULT_LOCATION_ID = 562;
var SKIP_PROCEDURE_ID = 152;
var HomePageContext = /*#__PURE__*/ (0,react.createContext)({
    state: {
        specialistsAutocomplete: [],
        practicesAutocomplete: [],
        specialties: [],
        conditionsProcedures: [],
        locations: [],
        filters: {
            searchType: SearchTypes.specialists,
            searchString: "",
            selectedKeywordName: undefined,
            selectedKeywordSlug: "",
            selectedKeywordId: "",
            selectedLocationName: "",
            selectedLocationId: ""
        },
        isLoadingButtonState: false,
        isKeywordChanged: false,
        isLocationChanged: false,
        isKeywordValidationFailed: false,
        isLocationValidationFailed: false
    },
    resetLocationsAutocomplete: function() {
        return null;
    },
    changeFilter: function(key, val) {
        return {
            key: key,
            val: val
        };
    },
    changeSearch: function(search) {
        return search;
    },
    changeLocation: function() {},
    changeLocationSearch: function(search) {
        return {
            search: search
        };
    },
    changeSearchType: function(searchType) {
        return searchType;
    },
    changeCurrentLocation: function(locationId) {
        return locationId;
    },
    openProfilePage: function(slug) {
        return slug;
    },
    loadCurrentLocationByLatLon: function() {
        return Promise.resolve();
    },
    buildUrl: function() {
        return null;
    },
    validate: function() {},
    resetKeywordSearch: function() {},
    resetValidation: function() {},
    changeButtonLoadingState: function(isLoadingButtonState) {
        return isLoadingButtonState;
    },
    isSpecialistSearch: false
});
function HomePageProvider(param1) {
    var children = param1.children, conditionsAndProcedures = param1.conditionsAndProcedures, specialties = param1.specialties, defaultLocation = param1.defaultLocation, locationsAutocomplete = param1.locationsAutocomplete, practicesAutocomplete = param1.practicesAutocomplete, specialistsAutocomplete = param1.specialistsAutocomplete;
    var ref4, ref1;
    var ref2 = (0,react.useContext)(AppData/* AppDataContext */.R), lang = ref2.language, tenantSettings = ref2.tenantSettings;
    var router = (0,next_router.useRouter)();
    var defaultLocations = (0,react.useMemo)(function() {
        return locationsAutocomplete;
    }, [
        locationsAutocomplete
    ]);
    var ref3 = (0,react.useState)({
        specialistsAutocomplete: specialistsAutocomplete || [],
        practicesAutocomplete: practicesAutocomplete || [],
        specialties: specialties || [],
        conditionsProcedures: conditionsAndProcedures,
        locations: locationsAutocomplete || [],
        filters: {
            searchType: SearchTypes.specialists,
            searchString: "",
            selectedKeywordName: undefined,
            selectedKeywordSlug: "",
            selectedKeywordId: "",
            selectedLocationName: "",
            selectedLocationSlug: "",
            selectedLocationId: ""
        },
        isLoadingButtonState: false,
        isKeywordChanged: false,
        isLocationChanged: false,
        isKeywordValidationFailed: false,
        isLocationValidationFailed: false
    }), state = ref3[0], setState = ref3[1];
    var buildUrl = (0,react.useCallback)(function() {
        var ref;
        var validation = validate();
        if (!validation) {
            return null;
        }
        var profileType = (0,transformAutocomplete/* transformSearchType */.lT)(state.filters.searchType.toString());
        var isDentistrySelected = profileType === AlternativeNavigationSearchTypes.dentist;
        var isNewSearchTypeSelected = profileType !== AlternativeNavigationSearchTypes.practices && profileType !== AlternativeNavigationSearchTypes.specialists;
        var keywordSlug = isNewSearchTypeSelected ? "all" : state.filters.selectedKeywordSlug;
        var locationName = state.filters.selectedLocationName;
        var _selectedLocationSlug;
        var locationSlug = (_selectedLocationSlug = state.filters.selectedLocationSlug) !== null && _selectedLocationSlug !== void 0 ? _selectedLocationSlug : (ref = state.filters.selectedLocationName) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        var hashQueryParams = new Map();
        if (locationName === null || locationName === void 0 ? void 0 : locationName.length) {
            hashQueryParams.set("location", locationName);
        }
        var hashQueryString = "";
        if (hashQueryParams.size > 0) {
            hashQueryString = Array.from(hashQueryParams).map(function(param) {
                var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                return "".concat(key, "=").concat(value);
            }).join("&");
        }
        var url = "/".concat(router.locale, "/find/").concat(isDentistrySelected ? "dentistry" : keywordSlug, "/").concat(locationSlug, "/").concat(isDentistrySelected ? AlternativeNavigationSearchTypes.practices : profileType);
        if (hashQueryString) {
            url += "#".concat(hashQueryString);
        }
        return url;
    // eslint-disable-next-line
    }, [
        state.filters,
        router.locale
    ]);
    var changeFilter = function(key, value) {
        var search = tenantSettings === null || tenantSettings === void 0 ? void 0 : tenantSettings.search;
        var dentistrySpecialty = search === null || search === void 0 ? void 0 : search.DENTISTRY;
        if (key === "selectedKeywordName" && value === (dentistrySpecialty === null || dentistrySpecialty === void 0 ? void 0 : dentistrySpecialty.name)) {
            setState(function(prev) {
                var _obj;
                return HomePage_objectSpread({}, prev, {
                    filters: HomePage_objectSpread({}, prev.filters, (_obj = {}, HomePage_defineProperty(_obj, key, value), HomePage_defineProperty(_obj, "searchType", SearchTypes.dentist), _obj))
                });
            });
        }
        setState(function(prev) {
            return HomePage_objectSpread({}, prev, {
                filters: HomePage_objectSpread({}, prev.filters, HomePage_defineProperty({}, key, value))
            });
        });
    };
    var changeButtonLoadingState = function(isLoadingButtonState) {
        setState(function(prev) {
            return HomePage_objectSpread({}, prev, {
                isLoadingButtonState: isLoadingButtonState
            });
        });
    };
    var changeLocation = function() {
        setState(function(prev) {
            return HomePage_objectSpread({}, prev, {
                isLocationChanged: true
            });
        });
    };
    var resetValidation = function() {
        setState(function(prev) {
            return HomePage_objectSpread({}, prev, {
                isKeywordValidationFailed: false,
                isLocationValidationFailed: false
            });
        });
    };
    var openProfilePage = function(slug) {
        router.push("/".concat(router.locale, "/").concat(state.filters.searchType === SearchTypes.specialists ? "specialist" : "practice", "/").concat(slug));
    };
    var conditionProceduresKey = "conditions-procedures";
    var changeSearch = function(search) {
        setState(function(prev) {
            return HomePage_objectSpread({}, prev, {
                filters: HomePage_objectSpread({}, prev.filters, {
                    searchString: search
                })
            });
        });
    };
    var loadAutocomplete = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var autocomplete, ref7, ref5, ref6;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.t0 = state.filters.searchType;
                    _ctx.next = _ctx.t0 === SearchTypes.dentist ? 4 : _ctx.t0 === SearchTypes.careHome ? 10 : _ctx.t0 === SearchTypes.hospital ? 14 : _ctx.t0 === SearchTypes.pharmacy ? 18 : _ctx.t0 === SearchTypes.healthAndSocialCare ? 22 : _ctx.t0 === SearchTypes.practices ? 26 : 30;
                    break;
                case 4:
                    ;
                    ;
                    _ctx.next = 8;
                    return (0,api_autocomplete/* getSearchAutocomplete */.z1)({
                        searchString: state.filters.searchString || "dentist",
                        lang: router.locale,
                        specialties: [
                            (ref6 = tenantSettings === null || tenantSettings === void 0 ? void 0 : (ref7 = tenantSettings.search) === null || ref7 === void 0 ? void 0 : (ref5 = ref7.DENTISTRY) === null || ref5 === void 0 ? void 0 : ref5.id.toString()) !== null && ref6 !== void 0 ? ref6 : "0"
                        ],
                        searchType: AutocompleteSearchTypes.practice
                    });
                case 8:
                    autocomplete = _ctx.sent;
                    return _ctx.abrupt("break", 33);
                case 10:
                    _ctx.next = 12;
                    return (0,api_autocomplete/* getSearchAutocomplete */.z1)({
                        searchString: state.filters.searchString,
                        lang: router.locale,
                        type: SearchTypes.careHome,
                        searchType: AutocompleteSearchTypes.practice
                    });
                case 12:
                    autocomplete = _ctx.sent;
                    return _ctx.abrupt("break", 33);
                case 14:
                    _ctx.next = 16;
                    return (0,api_autocomplete/* getSearchAutocomplete */.z1)({
                        searchString: state.filters.searchString,
                        lang: router.locale,
                        type: SearchTypes.hospital,
                        searchType: AutocompleteSearchTypes.practice
                    });
                case 16:
                    autocomplete = _ctx.sent;
                    return _ctx.abrupt("break", 33);
                case 18:
                    _ctx.next = 20;
                    return (0,api_autocomplete/* getSearchAutocomplete */.z1)({
                        searchString: state.filters.searchString,
                        lang: router.locale,
                        type: SearchTypes.pharmacy,
                        searchType: AutocompleteSearchTypes.practice
                    });
                case 20:
                    autocomplete = _ctx.sent;
                    return _ctx.abrupt("break", 33);
                case 22:
                    _ctx.next = 24;
                    return (0,api_autocomplete/* getSearchAutocomplete */.z1)({
                        searchString: state.filters.searchString,
                        lang: router.locale,
                        type: SearchTypes.healthAndSocialCare,
                        searchType: AutocompleteSearchTypes.specialist
                    });
                case 24:
                    autocomplete = _ctx.sent;
                    return _ctx.abrupt("break", 33);
                case 26:
                    _ctx.next = 28;
                    return (0,api_autocomplete/* getSearchAutocomplete */.z1)({
                        searchString: state.filters.searchString,
                        lang: router.locale,
                        searchType: AutocompleteSearchTypes.practice
                    });
                case 28:
                    autocomplete = _ctx.sent;
                    return _ctx.abrupt("break", 33);
                case 30:
                    _ctx.next = 32;
                    return (0,api_autocomplete/* getSearchAutocomplete */.z1)({
                        searchString: state.filters.searchString,
                        lang: router.locale,
                        searchType: AutocompleteSearchTypes.specialist
                    });
                case 32:
                    autocomplete = _ctx.sent;
                case 33:
                    setState(function(prev) {
                        var ref;
                        return HomePage_objectSpread({}, prev, {
                            practicesAutocomplete: (autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.practices) || [],
                            specialistsAutocomplete: (autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.specialists) || [],
                            specialties: (autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.specialties) || [],
                            conditionsProcedures: (defaultLocation ? autocomplete === null || autocomplete === void 0 ? void 0 : (ref = autocomplete[conditionProceduresKey]) === null || ref === void 0 ? void 0 : ref.filter(function(x) {
                                return x.id !== SKIP_PROCEDURE_ID;
                            }) : autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete[conditionProceduresKey]) || []
                        });
                    });
                case 34:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        defaultLocation,
        router.locale,
        state.filters.searchType,
        state.filters.searchString,
        tenantSettings === null || tenantSettings === void 0 ? void 0 : (ref4 = tenantSettings.search) === null || ref4 === void 0 ? void 0 : (ref1 = ref4.DENTISTRY) === null || ref1 === void 0 ? void 0 : ref1.id
    ]);
    var timeout = (0,useTimeout/* useTimeout */.K)();
    (0,react.useEffect)(function() {
        timeout(function() {
            return loadAutocomplete().then();
        }, 700);
    }, [
        loadAutocomplete,
        state.filters.searchString,
        timeout
    ]);
    var loadCurrentLocationByLatLon = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(lat, lon) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", (0,api_autocomplete/* getLocationsAutocomplete */.iN)({
                            lang: router.locale,
                            lat: lat,
                            lon: lon
                        }).then(function(locations) {
                            setState(function(prev) {
                                return HomePage_objectSpread({}, prev, {
                                    locations: locations
                                });
                            });
                        }));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadCurrentLocationByLatLon(lat, lon) {
            return _ref.apply(this, arguments);
        };
    }();
    var changeLocationSearch = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(search) {
            var locations, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if ((search === null || search === void 0 ? void 0 : search.length) === 0) {
                            setState(function(prev) {
                                return HomePage_objectSpread({}, prev, {
                                    locations: defaultLocations
                                });
                            });
                        }
                        if (!((search === null || search === void 0 ? void 0 : search.length) > 3)) {
                            _ctx.next = 13;
                            break;
                        }
                        locations = [];
                        setState(function(prev) {
                            return HomePage_objectSpread({}, prev, {
                                locations: locations
                            });
                        });
                        ;
                        _ctx.next = 7;
                        return (0,api_autocomplete/* getLocationsAutocompleteSelfDatabase */.D4)({
                            search: search,
                            lang: router.locale,
                            locationId: (ref = defaultLocation === null || defaultLocation === void 0 ? void 0 : defaultLocation.id) !== null && ref !== void 0 ? ref : DEFAULT_LOCATION_ID,
                            type: state.filters.searchType
                        });
                    case 7:
                        locations = _ctx.sent;
                        if (locations.length) {
                            _ctx.next = 12;
                            break;
                        }
                        _ctx.next = 11;
                        return (0,api_autocomplete/* getLocationsAutocomplete */.iN)({
                            searchString: search,
                            lang: router.locale,
                            language: lang
                        });
                    case 11:
                        locations = _ctx.sent;
                    case 12:
                        setState(function(prev) {
                            return HomePage_objectSpread({}, prev, {
                                locations: locations
                            });
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(search) {
            return _ref.apply(this, arguments);
        };
    }(), [
        defaultLocation,
        defaultLocations,
        lang,
        router.locale,
        state.filters
    ]);
    var resetLocationsAutocomplete = function() {
        setState(function(prevState) {
            return HomePage_objectSpread({}, prevState, {
                locations: locationsAutocomplete
            });
        });
    };
    var changeCurrentLocation = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(locationId, locationName, locationSlug) {
            var slug, locationDetails, ref, lat, lng;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        changeLocation();
                        slug = locationSlug;
                        if (locationSlug) {
                            _ctx.next = 8;
                            break;
                        }
                        _ctx.next = 5;
                        return (0,api_autocomplete/* getLocationDetails */.U_)({
                            locationId: locationId,
                            lang: router.locale
                        });
                    case 5:
                        locationDetails = _ctx.sent;
                        ref = (locationDetails === null || locationDetails === void 0 ? void 0 : locationDetails.location) || {
                            lat: 0,
                            lng: 0
                        }, lat = ref.lat, lng = ref.lng;
                        slug = "ext-".concat(lat, "-").concat(lng);
                    case 8:
                        setState(function(prev) {
                            return HomePage_objectSpread({}, prev, {
                                isLocationChanged: false,
                                filters: HomePage_objectSpread({}, prev.filters, {
                                    selectedLocationName: locationName,
                                    selectedLocationId: locationId,
                                    selectedLocationSlug: slug
                                })
                            });
                        });
                        changeLocationSearch(locationName);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function changeCurrentLocation(locationId, locationName, locationSlug) {
            return _ref.apply(this, arguments);
        };
    }();
    var changeSearchType = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(searchType) {
            var isDentistry, isNewSearchType, search, dentistrySpecialty;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(searchType === state.filters.searchType)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        isDentistry = searchType === SearchTypes.dentist;
                        isNewSearchType = searchType !== SearchTypes.specialists && searchType !== SearchTypes.practices && searchType !== SearchTypes.dentist;
                        if (!isDentistry) {
                            resetKeywordSearch();
                        }
                        if (isDentistry) {
                            search = tenantSettings === null || tenantSettings === void 0 ? void 0 : tenantSettings.search;
                            dentistrySpecialty = search === null || search === void 0 ? void 0 : search.DENTISTRY;
                            setState(function(prevState) {
                                var ref, ref8, ref9, ref10;
                                return HomePage_objectSpread({}, prevState, {
                                    filters: HomePage_objectSpread({}, prevState.filters, {
                                        searchType: searchType,
                                        searchString: (ref = dentistrySpecialty === null || dentistrySpecialty === void 0 ? void 0 : dentistrySpecialty.name) !== null && ref !== void 0 ? ref : "",
                                        selectedKeywordId: (ref8 = dentistrySpecialty === null || dentistrySpecialty === void 0 ? void 0 : dentistrySpecialty.id.toString()) !== null && ref8 !== void 0 ? ref8 : "",
                                        selectedKeywordName: (ref9 = dentistrySpecialty === null || dentistrySpecialty === void 0 ? void 0 : dentistrySpecialty.name) !== null && ref9 !== void 0 ? ref9 : undefined,
                                        selectedKeywordSlug: (ref10 = dentistrySpecialty === null || dentistrySpecialty === void 0 ? void 0 : dentistrySpecialty.slug) !== null && ref10 !== void 0 ? ref10 : ""
                                    })
                                });
                            });
                        } else if (isNewSearchType) {
                            setState(function(prevState) {
                                return HomePage_objectSpread({}, prevState, {
                                    filters: HomePage_objectSpread({}, prevState.filters, {
                                        searchType: searchType,
                                        selectedKeywordId: "",
                                        selectedKeywordName: undefined,
                                        selectedKeywordSlug: ""
                                    })
                                });
                            });
                        } else {
                            setState(function(prevState) {
                                return HomePage_objectSpread({}, prevState, {
                                    filters: HomePage_objectSpread({}, prevState.filters, {
                                        searchType: searchType
                                    })
                                });
                            });
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function changeSearchType(searchType) {
            return _ref.apply(this, arguments);
        };
    }();
    var resetKeywordSearch = function() {
        setState(function(prevState) {
            return HomePage_objectSpread({}, prevState, {
                filters: HomePage_objectSpread({}, prevState.filters, {
                    searchString: "",
                    selectedKeywordId: "",
                    selectedKeywordName: undefined,
                    selectedKeywordSlug: ""
                })
            });
        });
    };
    var validate = (0,react.useCallback)(function() {
        var _filters = state.filters, selectedKeywordName = _filters.selectedKeywordName, selectedLocationName = _filters.selectedLocationName, searchType = _filters.searchType;
        var isNewSearchType = searchType !== SearchTypes.specialists && searchType !== SearchTypes.practices && searchType !== SearchTypes.dentist;
        setState(function(prevState) {
            return HomePage_objectSpread({}, prevState, {
                isKeywordValidationFailed: !isNewSearchType && !selectedKeywordName,
                isLocationValidationFailed: !selectedLocationName
            });
        });
        return !(!isNewSearchType && !selectedKeywordName || !selectedLocationName);
    }, [
        state.filters
    ]);
    var isSpecialistSearch = (0,react.useMemo)(function() {
        var profileType = state.filters.searchType;
        return profileType === SearchTypes.specialists || profileType === SearchTypes.healthAndSocialCare;
    }, [
        state.filters.searchType
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageContext.Provider, {
        value: {
            state: state,
            changeSearch: changeSearch,
            changeLocationSearch: changeLocationSearch,
            changeCurrentLocation: changeCurrentLocation,
            changeFilter: changeFilter,
            changeLocation: changeLocation,
            changeSearchType: changeSearchType,
            openProfilePage: openProfilePage,
            resetLocationsAutocomplete: resetLocationsAutocomplete,
            loadCurrentLocationByLatLon: loadCurrentLocationByLatLon,
            resetKeywordSearch: resetKeywordSearch,
            buildUrl: buildUrl,
            validate: validate,
            resetValidation: resetValidation,
            isSpecialistSearch: isSpecialistSearch,
            changeButtonLoadingState: changeButtonLoadingState
        },
        children: children
    });
}


// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/base/ClickAwayListener/ClickAwayListener.esm.js
var ClickAwayListener_esm = __webpack_require__(83964);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/ListItemText/ListItemText.esm.js
var ListItemText_esm = __webpack_require__(91741);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/SearchBarSearchIcon/index.esm.js
var SearchBarSearchIcon_index_esm = __webpack_require__(12841);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Chip/Chip.esm.js + 2 modules
var Chip_esm = __webpack_require__(80338);
// EXTERNAL MODULE: ./utils/highlightText.ts
var highlightText = __webpack_require__(8477);
;// CONCATENATED MODULE: ./components/HomePage/SearchBar/AutocompleteResultsModal/styles.tsx
function AutocompleteResultsModal_styles_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function styles_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AutocompleteResultsModal_styles_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function AutocompleteResultsModal_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function AutocompleteResultsModal_styles_templateObject() {
    var data = AutocompleteResultsModal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    AutocompleteResultsModal_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AutocompleteResultsModal_styles_templateObject1() {
    var data = AutocompleteResultsModal_styles_taggedTemplateLiteral([
        "\n  background-color: white;\n  border: 1px solid #bfcdf6;\n  border-radius: 16px;\n  display: block;\n  filter: drop-shadow(0px 3px 4px rgba(2, 3, 3, 0.03)) drop-shadow(0px 3px 3px rgba(2, 3, 3, 0.02))\n    drop-shadow(0px 1px 8px rgba(2, 3, 3, 0.04));\n  font-family: Poppins;\n  min-width: 432px;\n  position: absolute;\n  z-index: 999;\n  @media (max-width: 1024px) {\n    filter: none;\n    background: #fff;\n    position: static;\n    min-width: unset;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    width: 100%;\n    margin-bottom: 8px;\n  }\n"
    ]);
    AutocompleteResultsModal_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AutocompleteResultsModal_styles_templateObject2() {
    var data = AutocompleteResultsModal_styles_taggedTemplateLiteral([
        "\n  border-radius: 50%;\n  height: 48px;\n  margin-right: 16px;\n  width: 48px;\n"
    ]);
    AutocompleteResultsModal_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AutocompleteResultsModal_styles_templateObject3() {
    var data = AutocompleteResultsModal_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    AutocompleteResultsModal_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AutocompleteResultsModal_styles_templateObject4() {
    var data = AutocompleteResultsModal_styles_taggedTemplateLiteral([
        "\n  min-height: 48px;\n  min-width: 48px;\n"
    ]);
    AutocompleteResultsModal_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var borderStyle = "1px solid #BFCDF6";
var TabsRoot = (0,esm_styled_esm/* default */.Z)("div")(AutocompleteResultsModal_styles_templateObject());
var SearchResultsModalRoot = (0,esm_styled_esm/* default */.Z)("div")(AutocompleteResultsModal_styles_templateObject1());
var RootContainer = (0,esm_styled_esm/* default */.Z)("div", {
    shouldForwardProp: function(prop) {
        return ![
            "specialistOrPractice"
        ].includes(prop);
    }
})(function(param) {
    var specialistOrPractice = param.specialistOrPractice;
    return {
        boxSizing: "border-box",
        maxHeight: "361px",
        overflowY: "auto",
        width: "100%",
        borderRight: !specialistOrPractice ? borderStyle : "",
        "@media (max-width: 760px)": {
            maxHeight: "initial",
            overflowY: "hidden"
        }
    };
});
var ItemRootContainer = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return styles_objectSpread({}, theme.typography.body2, {
        padding: theme.spacing(1.5, 2),
        display: "flex",
        alignItems: "center",
        gap: "16px",
        minHeight: 47,
        borderBottom: borderStyle,
        "&:hover": {
            cursor: "pointer",
            userSelect: "none",
            backgroundColor: "#F4F7FD"
        }
    });
});
var ItemLogo = (0,esm_styled_esm/* default */.Z)("img")(AutocompleteResultsModal_styles_templateObject2());
var ItemTitleContainer = (0,esm_styled_esm/* default */.Z)("div")(AutocompleteResultsModal_styles_templateObject3());
var AutocompleteResultsModal_styles_ImageContainer = (0,esm_styled_esm/* default */.Z)("div")(AutocompleteResultsModal_styles_templateObject4());
var ItemSubTitle = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return styles_objectSpread({}, theme.typography.caption, {
        color: theme.palette.text.disabled
    });
});
var ItemTitle = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return ![
            "specialistOrPractice"
        ].includes(prop);
    }
})(function(param) {
    var theme = param.theme, specialistOrPractice = param.specialistOrPractice;
    var ref, ref1;
    return styles_objectSpread({}, theme.typography.body2, {
        "& .text-highlight": {
            color: theme.palette.primary.main,
            fontWeight: 600
        },
        color: specialistOrPractice ? (ref = theme.custom) === null || ref === void 0 ? void 0 : (ref1 = ref.SearchBar) === null || ref1 === void 0 ? void 0 : ref1.MenuItem.color : theme.palette.text.primary,
        fontWeight: specialistOrPractice ? 600 : 400
    });
});
var SearchModalItemContainer = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP)({
    flex: 1,
    maxWidth: "400px"
});
var SearchModalHeaderTextContainer = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return AutocompleteResultsModal_styles_defineProperty({
        borderBottom: borderStyle
    }, theme.breakpoints.down("md"), {
        borderBottom: "none"
    });
});
var SearchModalHeaderText = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return AutocompleteResultsModal_styles_defineProperty({
        fontSize: "15px",
        lineHeight: "20px",
        padding: "16px 16px 16px 24px"
    }, theme.breakpoints.down("md"), {
        padding: "16px 0 0 16px"
    });
});
var SearchModalKeyContainer = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)({});
var EmptySearchResultsContainer = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)({
    width: "100%",
    padding: "32px",
    justifyContent: "center",
    alignItems: "center"
});

;// CONCATENATED MODULE: ./components/HomePage/SearchBar/AutocompleteResultsModal/NoResultsComponent/styles.tsx

var ContainerForNoResults = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function() {
    return {
        display: "flex",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        gap: "40px",
        flexDirection: "column"
    };
});
var styles_MainText = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)(function() {
    return {
        fontSize: "18px",
        fontWeight: 500,
        color: "#2C3341"
    };
});
var SecondaryText = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)(function() {
    return {
        fontSize: "14px",
        fontWeight: 400,
        paddingLeft: "40px",
        paddingRight: "40px",
        textAlign: "center",
        color: "#2C3341"
    };
});
var TextContainer = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)(function() {
    return {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        justifyContent: "center",
        alignItems: "center"
    };
});
var NestedContainer = (0,styled_esm/* default */.ZP)(TextContainer)(function() {
    return {
        gap: "24px"
    };
});
var ClearButton = (0,styled_esm/* default */.ZP)(Button_esm/* default */.Z)(function() {
    return {
        width: "147px",
        height: "40px",
        borderRadius: "24px",
        fontSize: "15px",
        fontWeight: 500,
        backgroundColor: "transparent",
        color: "#051851",
        border: "1px solid #051851"
    };
});

;// CONCATENATED MODULE: ./components/HomePage/SearchBar/AutocompleteResultsModal/NoResultsComponent/index.tsx




var NoResultsComponent = function(param) {
    var onClick = param.onClick, _withImage = param.withImage, withImage = _withImage === void 0 ? false : _withImage;
    var translate = (0,useTranslateMessage/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerForNoResults, {
        children: [
            withImage && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                width: 351,
                objectFit: "cover",
                height: 116,
                src: "/hermes-static/images/NoResultsMobile.png"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NestedContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_MainText, {
                                children: translate("global.no_results_found")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondaryText, {
                                children: translate("global.no_results_found.secondary")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClearButton, {
                        onClick: onClick,
                        children: translate("global.clean_search")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AutocompleteResultsModal_NoResultsComponent = (NoResultsComponent);

;// CONCATENATED MODULE: ./components/HomePage/SearchBar/AutocompleteResultsModal/ResultsList.tsx
function ResultsList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ResultsList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ResultsList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var letterMapper = function(param) {
    var groups = param.groups, item = param.item;
    var firstLetter = item.name.charAt(0).toUpperCase();
    if (!groups[firstLetter]) {
        groups[firstLetter] = [];
    }
    groups[firstLetter].push(item);
    return groups;
};
var sortByAlphabet = function(param) {
    var contentToSort = param.contentToSort;
    return contentToSort.sort(function(a, b) {
        if (a.name === b.name) {
            return 0;
        }
        return a.name < b.name ? -1 : 1;
    });
};
var ResultsListItemOld = function(param) {
    var name = param.name, logo = param.logo, subtitle = param.subtitle, _specialistOrPractice = param.specialistOrPractice, specialistOrPractice = _specialistOrPractice === void 0 ? false : _specialistOrPractice, onSelect = param.onSelect, searchString = param.searchString;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemRootContainer, {
        onClick: onSelect,
        children: [
            specialistOrPractice && logo && /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteResultsModal_styles_ImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: logo,
                    alt: "search-profile-icon",
                    width: 48,
                    height: 48,
                    style: {
                        borderRadius: "50%"
                    },
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemTitleContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemTitle, {
                        specialistOrPractice: specialistOrPractice && !searchString,
                        dangerouslySetInnerHTML: {
                            __html: (0,highlightText/* default */.Z)(name, searchString)
                        }
                    }),
                    specialistOrPractice && subtitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemSubTitle, {
                        children: subtitle
                    }) : null
                ]
            })
        ]
    });
};
var ResultsListItem = function(param) {
    var name = param.name, onSelect = param.onSelect;
    var handleClick = function() {
        onSelect();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip_esm/* default */.Z, {
            label: name,
            onClick: handleClick,
            sx: {
                fontWeight: 500,
                fontSize: "15px",
                lineHeight: "22px",
                cursor: "pointer",
                "&:hover": {
                    background: "#CCFAF6"
                },
                backgroundColor: "#EAEEFC",
                color: "#1A3586"
            }
        })
    });
};
var AutocompleteKeywordsContainer = function(param) {
    var groupedContentList = param.groupedContentList, specialistOrPractice = param.specialistOrPractice, searchString = param.searchString;
    var ref1;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
        sx: {
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            overflowX: "hidden"
        },
        children: (ref1 = Object.keys(groupedContentList)) === null || ref1 === void 0 ? void 0 : ref1.map(function(key, index) {
            var ref;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModalKeyContainer, {
                        children: key
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                        sx: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px"
                        },
                        children: (ref = groupedContentList[key]) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultsListItem, ResultsList_objectSpread({
                                specialistOrPractice: specialistOrPractice,
                                searchString: searchString
                            }, item), "search-".concat(item.subtitle, "-").concat(item.id));
                        })
                    })
                ]
            }, "".concat(key).concat(index));
        })
    });
};
var ResultsList = function(param) {
    var _rootContainerStyles = param.rootContainerStyles, rootContainerStyles = _rootContainerStyles === void 0 ? {} : _rootContainerStyles, _items = param.items, items = _items === void 0 ? [] : _items, _specialties = param.specialties, specialties = _specialties === void 0 ? [] : _specialties, _conditionsProcedures = param.conditionsProcedures, conditionsProcedures = _conditionsProcedures === void 0 ? [] : _conditionsProcedures, _specialistOrPractice = param.specialistOrPractice, specialistOrPractice = _specialistOrPractice === void 0 ? false : _specialistOrPractice, searchString = param.searchString, _bubbleView = param.bubbleView, bubbleView = _bubbleView === void 0 ? false : _bubbleView, _handleCloseSearch = param.handleCloseSearch, handleCloseSearch = _handleCloseSearch === void 0 ? function() {} : _handleCloseSearch, _isMobileView = param.isMobileView, isMobileView = _isMobileView === void 0 ? false : _isMobileView, _shouldShowProfiles = param.shouldShowProfiles, shouldShowProfiles = _shouldShowProfiles === void 0 ? false : _shouldShowProfiles;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var isSpecialistSearch = (0,react.useContext)(HomePageContext).isSpecialistSearch;
    var reorderedConditionsProcedures = (0,react.useMemo)(function() {
        if (bubbleView) {
            return sortByAlphabet({
                contentToSort: conditionsProcedures
            });
        }
        return conditionsProcedures;
    }, [
        conditionsProcedures,
        bubbleView
    ]);
    var reorderedSpecialties = (0,react.useMemo)(function() {
        if (bubbleView) {
            return sortByAlphabet({
                contentToSort: specialties
            });
        }
        return specialties;
    }, [
        specialties,
        bubbleView
    ]);
    var groupedConditionsProceduresByFirstLetter = (0,react.useMemo)(function() {
        return reorderedConditionsProcedures.reduce(function(groups, item) {
            return letterMapper({
                groups: groups,
                item: item
            });
        }, {});
    }, [
        reorderedConditionsProcedures
    ]);
    var groupedSpecialtiesByFirstLetter = (0,react.useMemo)(function() {
        return reorderedSpecialties.reduce(function(groups, item) {
            return letterMapper({
                groups: groups,
                item: item
            });
        }, {});
    }, [
        reorderedSpecialties
    ]);
    var translatedName = isSpecialistSearch ? translate("specialists") : translate("practices");
    if (items.length || shouldShowProfiles) {
        if (!items.length && shouldShowProfiles && !!searchString.length) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModalHeaderTextContainer, {
                        sx: {
                            marginBottom: "20px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModalHeaderText, {
                            variant: "body2",
                            children: translatedName
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteResultsModal_NoResultsComponent, {
                        onClick: handleCloseSearch,
                        withImage: true
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModalHeaderTextContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModalHeaderText, {
                        variant: "body2",
                        children: translatedName
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(RootContainer, {
                    sx: rootContainerStyles,
                    specialistOrPractice: specialistOrPractice,
                    children: items.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultsListItemOld, ResultsList_objectSpread({
                            specialistOrPractice: specialistOrPractice,
                            searchString: searchString
                        }, item), "search-".concat(item.subtitle, "-").concat(item.id));
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModalHeaderTextContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModalHeaderText, {
                    variant: "body2",
                    children: translate(reorderedConditionsProcedures.length ? "popular_conditions_procedures" : "popular_specialties")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootContainer, {
                sx: rootContainerStyles,
                specialistOrPractice: specialistOrPractice,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteKeywordsContainer, {
                        searchString: searchString,
                        specialistOrPractice: specialistOrPractice,
                        groupedContentList: groupedConditionsProceduresByFirstLetter
                    }),
                    isMobileView && Object.keys(groupedSpecialtiesByFirstLetter).length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModalHeaderTextContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModalHeaderText, {
                            sx: {
                                padding: "16px 0px !important"
                            },
                            variant: "body2",
                            children: translate("popular_specialties")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteKeywordsContainer, {
                        searchString: searchString,
                        specialistOrPractice: specialistOrPractice,
                        groupedContentList: groupedSpecialtiesByFirstLetter
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var AutocompleteResultsModal_ResultsList = (ResultsList);

;// CONCATENATED MODULE: ./components/HomePage/SearchBar/AutocompleteResultsModal/index.tsx
function AutocompleteResultsModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AutocompleteResultsModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AutocompleteResultsModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var AutocompleteResultsModal = function(param) {
    var data = param.data, searchString = param.searchString, onClose = param.onClose, customStyle = param.customStyle, isOpen = param.isOpen;
    var isKeywordsEmpty = (0,react.useMemo)(function() {
        var ref, ref1;
        return (data === null || data === void 0 ? void 0 : (ref = data.specialties) === null || ref === void 0 ? void 0 : ref.length) && (data === null || data === void 0 ? void 0 : (ref1 = data.conditionsProcedures) === null || ref1 === void 0 ? void 0 : ref1.length);
    }, [
        data
    ]);
    var isEmptyContent = (0,react.useMemo)(function() {
        return data.profiles.length === 0 && data.specialties.length === 0 && data.conditionsProcedures.length === 0;
    }, [
        data
    ]);
    var ref2 = (0,react.useContext)(HomePageContext), filters = ref2.state.filters;
    var isAlternativeSearchTypesIncluded = (0,react.useMemo)(function() {
        return (filters === null || filters === void 0 ? void 0 : filters.searchType) && global/* newSearchTypesPractices.includes */.Bg.includes(filters === null || filters === void 0 ? void 0 : filters.searchType);
    }, [
        filters === null || filters === void 0 ? void 0 : filters.searchType
    ]);
    var managedContainerSizes = !isAlternativeSearchTypesIncluded ? {
        left: 0,
        right: 0
    } : {};
    var managedContainerStyle = AutocompleteResultsModal_objectSpread({}, managedContainerSizes, {
        top: "110%",
        textAlign: "start",
        display: !isOpen ? "none" : "block"
    });
    var handleCloseSearch = function() {
        onClose();
    };
    var listBuilder = function() {
        var content;
        if (isAlternativeSearchTypesIncluded) {
            content = /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteResultsModal_ResultsList, {
                rootContainerStyles: {
                    padding: "16px 20px"
                },
                items: data === null || data === void 0 ? void 0 : data.profiles,
                specialties: data === null || data === void 0 ? void 0 : data.specialties,
                shouldShowProfiles: true,
                specialistOrPractice: true,
                handleCloseSearch: handleCloseSearch,
                conditionsProcedures: data === null || data === void 0 ? void 0 : data.conditionsProcedures,
                searchString: searchString,
                bubbleView: true,
                isMobileView: true
            });
        } else if (isEmptyContent) {
            content = /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteResultsModal_ResultsList, {
                rootContainerStyles: {
                    padding: "16px 20px"
                },
                items: data === null || data === void 0 ? void 0 : data.profiles,
                specialistOrPractice: true,
                handleCloseSearch: handleCloseSearch,
                conditionsProcedures: data === null || data === void 0 ? void 0 : data.conditionsProcedures,
                searchString: searchString,
                shouldShowProfiles: true,
                bubbleView: true,
                isMobileView: true
            });
        } else if (isKeywordsEmpty) {
            content = /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteResultsModal_ResultsList, {
                rootContainerStyles: {
                    padding: "16px 20px"
                },
                specialties: data === null || data === void 0 ? void 0 : data.specialties,
                specialistOrPractice: true,
                handleCloseSearch: handleCloseSearch,
                conditionsProcedures: data === null || data === void 0 ? void 0 : data.conditionsProcedures,
                searchString: searchString,
                bubbleView: true,
                isMobileView: true
            });
        } else {
            content = /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteResultsModal_ResultsList, {
                rootContainerStyles: {
                    padding: "16px 20px"
                },
                items: data === null || data === void 0 ? void 0 : data.profiles,
                shouldShowProfiles: true,
                specialistOrPractice: true,
                handleCloseSearch: handleCloseSearch,
                conditionsProcedures: data === null || data === void 0 ? void 0 : data.conditionsProcedures,
                searchString: searchString,
                bubbleView: true,
                isMobileView: true
            });
        }
        return content;
    };
    return(// @ts-ignore
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchResultsModalRoot, {
        sx: AutocompleteResultsModal_objectSpread({}, managedContainerStyle, customStyle),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                lgUp: true,
                implementation: "css",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                    sx: {
                        maxHeight: "400px",
                        overflowY: "auto"
                    },
                    children: listBuilder()
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                lgDown: true,
                implementation: "css",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                    container: true,
                    children: isEmptyContent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptySearchResultsContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteResultsModal_NoResultsComponent, {
                            onClick: handleCloseSearch
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            !isAlternativeSearchTypesIncluded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModalItemContainer, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteResultsModal_ResultsList, {
                                            rootContainerStyles: {
                                                padding: "16px 24px"
                                            },
                                            conditionsProcedures: data === null || data === void 0 ? void 0 : data.conditionsProcedures,
                                            searchString: searchString,
                                            bubbleView: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModalItemContainer, {
                                        item: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteResultsModal_ResultsList, {
                                            rootContainerStyles: {
                                                padding: "16px 24px"
                                            },
                                            specialties: data === null || data === void 0 ? void 0 : data.specialties,
                                            searchString: searchString,
                                            bubbleView: true
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchModalItemContainer, {
                                item: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteResultsModal_ResultsList, {
                                    rootContainerStyles: {
                                        padding: "8px 24px"
                                    },
                                    items: data === null || data === void 0 ? void 0 : data.profiles,
                                    searchString: searchString,
                                    specialistOrPractice: true,
                                    shouldShowProfiles: true
                                })
                            })
                        ]
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var SearchBar_AutocompleteResultsModal = (AutocompleteResultsModal);

// EXTERNAL MODULE: ./providers/SearchProfilesPage/types.ts
var types = __webpack_require__(42108);
// EXTERNAL MODULE: ./hooks/useFeatureFlags.ts
var useFeatureFlags = __webpack_require__(48189);
;// CONCATENATED MODULE: ./components/HomePage/SearchBar/CustomAutocomplete.tsx
function CustomAutocomplete_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CustomAutocomplete_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CustomAutocomplete_defineProperty(target, key, source[key]);
        });
    }
    return target;
}








var CustomAutocomplete = function(param) {
    var isSearchFieldFocused = param.isSearchFieldFocused, setIsSearchFieldFocused = param.setIsSearchFieldFocused, onChangeSearch = param.onChangeSearch, customStyle = param.customStyle, onSearchFieldBlur = param.onSearchFieldBlur;
    var ref = (0,react.useContext)(HomePageContext), changeSearch = ref.changeSearch, changeFilter = ref.changeFilter, openProfilePage = ref.openProfilePage, _state = ref.state, filters = _state.filters, practicesAutocomplete = _state.practicesAutocomplete, specialistsAutocomplete = _state.specialistsAutocomplete, specialties = _state.specialties, conditionsProcedures = _state.conditionsProcedures;
    var tenantSettings = (0,react.useContext)(AppData/* AppDataContext */.R).tenantSettings;
    var alternativeSearchEnabled = (0,useFeatureFlags/* useFeatureFlags */.g)().alternativeSearchEnabled;
    var transformerBuilder = function() {
        if (alternativeSearchEnabled) {
            return transformAutocomplete/* alternativeTransformAutocompletePractices */.bS;
        }
        return transformAutocomplete/* transformAutocompletePractices */.dP;
    };
    var transformerFunctionForPractice = transformerBuilder();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar_AutocompleteResultsModal, {
        customStyle: customStyle,
        data: {
            specialties: specialties.map(function(spec) {
                return (0,transformAutocomplete/* transformAutocompleteKeyword */.EC)(spec, tenantSettings === null || tenantSettings === void 0 ? void 0 : tenantSettings.locales[0]);
            }).map(function(spec) {
                return CustomAutocomplete_objectSpread({}, spec, {
                    onSelect: function() {
                        changeFilter("selectedKeywordName", spec.name);
                        changeFilter("selectedKeywordSlug", spec.slug);
                        changeFilter("selectedKeywordId", spec.id);
                        changeSearch(spec.name);
                        setIsSearchFieldFocused(false);
                    }
                });
            }),
            conditionsProcedures: conditionsProcedures.map(function(conditionProcedure) {
                return (0,transformAutocomplete/* transformAutocompleteKeyword */.EC)(conditionProcedure, tenantSettings === null || tenantSettings === void 0 ? void 0 : tenantSettings.locales[0]);
            }).map(function(conditionProcedure) {
                return CustomAutocomplete_objectSpread({}, conditionProcedure, {
                    onSelect: function() {
                        changeFilter("selectedKeywordName", conditionProcedure.name);
                        changeFilter("selectedKeywordSlug", conditionProcedure.slug);
                        changeFilter("selectedKeywordId", conditionProcedure.id);
                        changeSearch(conditionProcedure.name);
                        setIsSearchFieldFocused(false);
                    }
                });
            }),
            profiles: (filters.searchType === types/* SearchTypes.specialists */.ai.specialists || filters.searchType === types/* SearchTypes.healthAndSocialCare */.ai.healthAndSocialCare ? specialistsAutocomplete.map(function(specialist) {
                return (0,transformAutocomplete/* transformAutocompleteSpecialist */.ae)(specialist, tenantSettings === null || tenantSettings === void 0 ? void 0 : tenantSettings.locales[0]);
            }) : practicesAutocomplete.map(function(practice) {
                return transformerFunctionForPractice(practice, tenantSettings === null || tenantSettings === void 0 ? void 0 : tenantSettings.locales[0]);
            })).map(function(profile) {
                return CustomAutocomplete_objectSpread({}, profile, {
                    onSelect: function() {
                        openProfilePage(profile.slug);
                    }
                });
            })
        },
        searchString: filters.searchString,
        onClose: onSearchFieldBlur,
        onChangeSearch: onChangeSearch,
        isOpen: isSearchFieldFocused
    });
};
/* harmony default export */ var SearchBar_CustomAutocomplete = (CustomAutocomplete);

// EXTERNAL MODULE: ./components/Icons/SearchIcon.tsx
var SearchIcon = __webpack_require__(4261);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/icons-material/ExpandMore.esm.js + 1 modules
var ExpandMore_esm = __webpack_require__(39591);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/Pulse/index.esm.js
var Pulse_index_esm = __webpack_require__(76605);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/icons-material/Search.esm.js
var Search_esm = __webpack_require__(6677);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/LocationOn/index.esm.js
var LocationOn_index_esm = __webpack_require__(67227);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/SearchBarLocationIcon/index.esm.js
var SearchBarLocationIcon_index_esm = __webpack_require__(1758);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/icons-material/MyLocation.esm.js
var MyLocation_esm = __webpack_require__(68858);
// EXTERNAL MODULE: ./components/Icons/ChevronRightIcon.tsx
var ChevronRightIcon = __webpack_require__(92255);
// EXTERNAL MODULE: ./components/Icons/ArrowRightIcon.tsx
var Icons_ArrowRightIcon = __webpack_require__(2730);
;// CONCATENATED MODULE: ./components/search/hooks/useHomePageSearchBarConfig.tsx
function useHomePageSearchBarConfig_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function useHomePageSearchBarConfig_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            useHomePageSearchBarConfig_defineProperty(target, key, source[key]);
        });
    }
    return target;
}













var useHomePageSearchBarConfig = function() {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useContext)(AppData/* AppDataContext */.R), locale = ref4.locale, tenantSettings = ref4.tenantSettings;
    var ref5 = (0,react.useContext)(HomePageContext), filters = ref5.state.filters;
    var alternativeSearchEnabled = (0,useFeatureFlags/* useFeatureFlags */.g)().alternativeSearchEnabled;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var dentistryId = (tenantSettings === null || tenantSettings === void 0 ? void 0 : (ref = tenantSettings.search) === null || ref === void 0 ? void 0 : (ref1 = ref.DENTISTRY) === null || ref1 === void 0 ? void 0 : ref1.id.toString()) || "";
    var careHomeId = (tenantSettings === null || tenantSettings === void 0 ? void 0 : (ref2 = tenantSettings.search) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.CARE_HOME) === null || ref3 === void 0 ? void 0 : ref3.id.toString()) || "";
    var dentistrySlug = (0,react.useMemo)(function() {
        return locale === global/* TENANTS.DE */.rk.DE || locale === global/* TENANTS.AT */.rk.AT ? "zahn-mund-kieferheilkunde" : "dentistry";
    }, [
        locale
    ]);
    var careHomeSlug = "health-and-social-care";
    var searchTypes = (0,react.useMemo)(function() {
        var defaultSearchTypes = [
            {
                title: translate("doctor-specialist"),
                value: types/* SearchTypes.specialists */.ai.specialists,
                Icon: "HeartPulseIcon"
            },
            {
                title: translate("practice"),
                value: types/* SearchTypes.practices */.ai.practices,
                Icon: "ClinicIcon"
            }
        ];
        if (locale !== global/* TENANTS.WPA */.rk.WPA) {
            defaultSearchTypes.push({
                title: translate("homepage.header.roll.dentist"),
                value: types/* SearchTypes.dentist */.ai.dentist,
                slug: dentistrySlug,
                Icon: "DentistIcon",
                id: dentistryId
            });
            defaultSearchTypes.push({
                title: translate("homepage.header.roll.hospital"),
                value: types/* SearchTypes.hospital */.ai.hospital,
                Icon: "HospitalIcon"
            });
        }
        if (locale === global/* TENANTS.UK */.rk.UK) {
            defaultSearchTypes.push({
                title: translate("homepage.header.roll.pharmacy"),
                value: types/* SearchTypes.pharmacy */.ai.pharmacy,
                Icon: "PharmaciesIcon"
            });
            var alternativeCareHomeProps = {
                title: translate("homepage.header.roll.care"),
                value: types/* SearchTypes.careHome */.ai.careHome,
                Icon: "CareHomeIcon"
            };
            defaultSearchTypes.push(alternativeSearchEnabled ? alternativeCareHomeProps : useHomePageSearchBarConfig_objectSpread({}, alternativeCareHomeProps, {
                id: careHomeId,
                slug: careHomeSlug
            }));
            defaultSearchTypes.push({
                title: translate("home-care-spec"),
                value: types/* SearchTypes.healthAndSocialCare */.ai.healthAndSocialCare,
                Icon: "HomeCareSpecIcon"
            });
        }
        return defaultSearchTypes;
    }, [
        careHomeId,
        dentistryId,
        dentistrySlug,
        locale,
        translate,
        alternativeSearchEnabled
    ]);
    var selectedSearchType = (0,react.useMemo)(function() {
        return searchTypes.find(function(st) {
            return st.value === filters.searchType;
        }) || searchTypes[0];
    }, [
        filters.searchType,
        searchTypes
    ]);
    var keywordsResultBubbleView = (0,react.useMemo)(function() {
        return locale === global/* TENANTS.WPA */.rk.WPA;
    }, [
        locale
    ]);
    var MobileProfileTypeLeftIcon = (0,react.useMemo)(function() {
        // potential to extend
        // eslint-disable-next-line sonarjs/no-small-switch
        switch(locale){
            case global/* TENANTS.WPA */.rk.WPA:
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginLeft: "17px",
                            marginRight: "10px",
                            display: "flex",
                            height: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/hermes-static/icons/HeartPulseIcon.svg",
                            alt: "",
                            width: 30,
                            height: 22,
                            objectFit: "none"
                        })
                    });
                }
            default:
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            marginLeft: "17px",
                            marginRight: "10px",
                            display: "flex",
                            height: "100%"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/hermes-static/icons/".concat(selectedSearchType.Icon, ".svg"),
                            alt: "",
                            width: 30,
                            height: 22,
                            objectFit: "none"
                        })
                    });
                }
        }
    }, [
        locale,
        selectedSearchType.Icon
    ]);
    var MobileProfileTypeRightIcon = (0,react.useMemo)(function() {
        return ExpandMore_esm/* default */.Z;
    }, []);
    var MobileKeywordSearchLeftIcon = (0,react.useMemo)(function() {
        // potential to extend
        // eslint-disable-next-line sonarjs/no-small-switch
        switch(locale){
            case global/* TENANTS.WPA */.rk.WPA:
                {
                    return SearchIcon/* default */.Z;
                }
            default:
                {
                    return Pulse_index_esm/* default */.Z;
                }
        }
    }, [
        locale
    ]);
    var MobileKeywordSearchLeftIconAlternative = (0,react.useMemo)(function() {
        // potential to extend
        // eslint-disable-next-line sonarjs/no-small-switch
        switch(locale){
            case global/* TENANTS.WPA */.rk.WPA:
                {
                    return SearchIcon/* default */.Z;
                }
            default:
                {
                    return SearchBarSearchIcon_index_esm/* default */.Z;
                }
        }
    }, [
        locale
    ]);
    var MobileKeywordSearchRightIcon = (0,react.useMemo)(function() {
        // potential to extend
        // eslint-disable-next-line sonarjs/no-small-switch
        switch(locale){
            case global/* TENANTS.WPA */.rk.WPA:
                {
                    return null;
                }
            default:
                {
                    return Search_esm/* default */.Z;
                }
        }
    }, [
        locale
    ]);
    var MobileLocationSearchLeftIcon = (0,react.useMemo)(function() {
        return LocationOn_index_esm/* default */.Z;
    }, []);
    var MobileLocationSearchLeftIconAlternative = (0,react.useMemo)(function() {
        return SearchBarLocationIcon_index_esm/* default */.Z;
    }, []);
    var MobileLocationSearchRightIcon = (0,react.useMemo)(function() {
        // potential to extend
        // eslint-disable-next-line sonarjs/no-small-switch
        switch(locale){
            case global/* TENANTS.WPA */.rk.WPA:
                {
                    return ExpandMore_esm/* default */.Z;
                }
            default:
                {
                    return MyLocation_esm/* default */.Z;
                }
        }
    }, [
        locale
    ]);
    var ref6 = (0,react.useMemo)(function() {
        // potential to extend
        // eslint-disable-next-line sonarjs/no-small-switch
        switch(locale){
            case global/* TENANTS.WPA */.rk.WPA:
                {
                    return {
                        SearchIconVariant: SearchIcon/* default */.Z,
                        searchIconPosition: "startAdornment"
                    };
                }
            default:
                {
                    return {
                        SearchIconVariant: Search_esm/* default */.Z,
                        searchIconPosition: "startAdornment"
                    };
                }
        }
    }, [
        locale
    ]), SearchIconVariant = ref6.SearchIconVariant, searchIconPosition = ref6.searchIconPosition;
    var ModalBackButtonIcon = (0,react.useMemo)(function() {
        // potential to extend
        // eslint-disable-next-line sonarjs/no-small-switch
        switch(locale){
            case global/* TENANTS.WPA */.rk.WPA:
                {
                    return function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                            sx: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transform: "rotate(180deg)",
                                backgroundColor: "white",
                                borderRadius: "32px",
                                width: "40px",
                                height: "40px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ArrowRightIcon/* default */.Z, {
                                sx: {
                                    transform: "scale(0.65)"
                                }
                            })
                        });
                    };
                }
            default:
                {
                    return function() {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon/* default */.Z, {
                                    reflectIfRtl: true,
                                    sx: {
                                        transform: "scaleX(-1)",
                                        ml: -1
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                                    children: translate("back")
                                })
                            ]
                        });
                    };
                }
        }
    }, [
        locale,
        translate
    ]);
    return {
        searchTypes: searchTypes,
        selectedSearchType: selectedSearchType,
        keywordsResultBubbleView: keywordsResultBubbleView,
        MobileProfileTypeLeftIcon: MobileProfileTypeLeftIcon,
        MobileProfileTypeRightIcon: MobileProfileTypeRightIcon,
        MobileKeywordSearchLeftIcon: MobileKeywordSearchLeftIcon,
        MobileKeywordSearchLeftIconAlternative: MobileKeywordSearchLeftIconAlternative,
        MobileKeywordSearchRightIcon: MobileKeywordSearchRightIcon,
        MobileLocationSearchLeftIcon: MobileLocationSearchLeftIcon,
        MobileLocationSearchLeftIconAlternative: MobileLocationSearchLeftIconAlternative,
        MobileLocationSearchRightIcon: MobileLocationSearchRightIcon,
        SearchIcon: SearchIconVariant,
        searchIconPosition: searchIconPosition,
        ModalBackButtonIcon: ModalBackButtonIcon
    };
};
/* harmony default export */ var hooks_useHomePageSearchBarConfig = (useHomePageSearchBarConfig);

// EXTERNAL MODULE: ./components/SearchPage/Alternative/SearchBar/ConditionalRenderBox.tsx
var ConditionalRenderBox = __webpack_require__(721);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/IconButton/IconButton.esm.js + 1 modules
var IconButton_esm = __webpack_require__(56774);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/MenuItem/MenuItem.esm.js + 1 modules
var MenuItem_esm = __webpack_require__(44514);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Autocomplete/Autocomplete.esm.js + 6 modules
var Autocomplete_esm = __webpack_require__(80018);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/TextField/TextField.esm.js + 3 modules
var TextField_esm = __webpack_require__(64322);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/MenuList/MenuList.esm.js
var MenuList_esm = __webpack_require__(39226);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Paper/Paper.esm.js + 2 modules
var Paper_esm = __webpack_require__(41212);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Checkbox/Checkbox.esm.js + 6 modules
var Checkbox_esm = __webpack_require__(32799);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Select/Select.esm.js + 4 modules
var Select_esm = __webpack_require__(99279);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/InputLabel/InputLabel.esm.js + 3 modules
var InputLabel_esm = __webpack_require__(56848);
;// CONCATENATED MODULE: ./components/HomePage/SearchBar/styles.tsx
function SearchBar_styles_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SearchBar_styles_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchBar_styles_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var whiteColor = "#FFF";
var boxShadow = "0px 0px 10px 0px rgba(43, 89, 224, 0.60)";
var errorBorderStyle = "1px solid #FF635C";
var styles_borderStyle = "1px solid #AABDF3";
var defaultHeight = "70px";
var defaultColor = "#F4F7FD";
var hoverColor = "#EAEEFC";
var transparentColor = "transparent";
var getGradientBackground = function(param) {
    var _leftTabHovered = param.leftTabHovered, leftTabHovered = _leftTabHovered === void 0 ? false : _leftTabHovered, _rightTabHovered = param.rightTabHovered, rightTabHovered = _rightTabHovered === void 0 ? false : _rightTabHovered;
    return "linear-gradient(90deg, ".concat(leftTabHovered ? hoverColor : defaultColor, " 50%, ").concat(rightTabHovered ? hoverColor : defaultColor, " 50%)");
};
var getHoverState = function(param) {
    var _doubleHoverCondition = param.doubleHoverCondition, doubleHoverCondition = _doubleHoverCondition === void 0 ? false : _doubleHoverCondition, _transparentHoverCondition = param.transparentHoverCondition, transparentHoverCondition = _transparentHoverCondition === void 0 ? false : _transparentHoverCondition, _hoverCondition = param.hoverCondition, hoverCondition = _hoverCondition === void 0 ? true : _hoverCondition;
    if (transparentHoverCondition) {
        return transparentColor;
    }
    if (doubleHoverCondition || hoverCondition) {
        return hoverColor;
    }
};
var SearchBarContainer = (0,styled_esm/* default */.ZP)(Grid_esm/* default */.ZP, {
    shouldForwardProp: function(prop) {
        return ![
            "isAnyOptionSelected",
            "leftTabHovered",
            "rightTabHovered"
        ].includes(prop);
    }
})(function(param) {
    var isAnyOptionSelected = param.isAnyOptionSelected, leftTabHovered = param.leftTabHovered, rightTabHovered = param.rightTabHovered;
    return {
        width: "90%",
        height: "72px",
        border: styles_borderStyle,
        borderRadius: "60px",
        background: isAnyOptionSelected ? getGradientBackground({
            leftTabHovered: leftTabHovered,
            rightTabHovered: rightTabHovered
        }) : "#F4F7FD"
    };
});
var StyledIconButton = (0,styled_esm/* default */.ZP)(IconButton_esm/* default */.Z)({
    cursor: "pointer",
    width: "100%",
    borderRadius: "60px",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    padding: 0,
    margin: 0,
    "&.MuiIconButton-root": {
        backgroundColor: transparentColor
    },
    "&:hover, &.MuiIconButton": {
        background: "".concat(transparentColor, " !important")
    }
});
var CustomMenuItem = (0,styled_esm/* default */.ZP)(MenuItem_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return ![
            "isSearchFieldFocused",
            "openSearchTypeDropdown",
            "isLocationFieldFocused"
        ].includes(prop);
    }
})(function(param) {
    var isSearchFieldFocused = param.isSearchFieldFocused, openSearchTypeDropdown = param.openSearchTypeDropdown, isLocationFieldFocused = param.isLocationFieldFocused;
    return SearchBar_styles_objectSpread({
        height: defaultHeight,
        width: "100%",
        padding: "16px",
        borderRadius: "60px",
        zIndex: 5
    }, openSearchTypeDropdown && {
        boxShadow: boxShadow
    }, {
        "&:hover, &:focus": SearchBar_styles_objectSpread({}, openSearchTypeDropdown ? {
            backgroundColor: whiteColor
        } : {
            backgroundColor: getHoverState({
                transparentHoverCondition: isSearchFieldFocused,
                doubleHoverCondition: isLocationFieldFocused
            })
        }, {
            borderWidth: 0
        })
    });
});
var StyledAutocomplete = (0,styled_esm/* default */.ZP)(Autocomplete_esm/* default */.Z)({
    height: defaultHeight,
    "&:hover, &:focus": {
        background: transparentColor
    }
});
var AutocompleteSearchTextField = (0,styled_esm/* default */.ZP)(TextField_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return ![
            "isBorderLeftHidden",
            "isBorderRightHidden",
            "isSearchFieldFocused",
            "openSearchTypeDropdown",
            "isLocationFieldFocused",
            "isKeywordValidationFailed"
        ].includes(prop);
    }
})(function(param) {
    var isBorderLeftHidden = param.isBorderLeftHidden, isBorderRightHidden = param.isBorderRightHidden, isSearchFieldFocused = param.isSearchFieldFocused, openSearchTypeDropdown = param.openSearchTypeDropdown, isLocationFieldFocused = param.isLocationFieldFocused, isKeywordValidationFailed = param.isKeywordValidationFailed;
    return SearchBar_styles_objectSpread({
        height: defaultHeight,
        borderRadius: isSearchFieldFocused || isKeywordValidationFailed ? "60px" : 0,
        borderRight: isBorderRightHidden ? "" : styles_borderStyle,
        borderLeft: isBorderLeftHidden ? "" : styles_borderStyle,
        backgroundColor: isSearchFieldFocused || isKeywordValidationFailed ? whiteColor : transparentColor,
        borderWidth: isSearchFieldFocused ? 0 : 1,
        zIndex: isSearchFieldFocused || isKeywordValidationFailed ? 5 : 0
    }, isKeywordValidationFailed && {
        border: errorBorderStyle
    }, isSearchFieldFocused && {
        boxShadow: boxShadow
    }, {
        ".MuiInputBase-root": {
            height: "100%"
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none"
        },
        "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            border: "none"
        },
        "&:hover, &:focus": SearchBar_styles_objectSpread({}, isSearchFieldFocused ? {
            backgroundColor: whiteColor
        } : {
            backgroundColor: getHoverState({
                doubleHoverCondition: openSearchTypeDropdown || isLocationFieldFocused
            })
        }, {
            height: defaultHeight,
            borderRadius: "60px",
            borderWidth: 0
        })
    });
});
var LocationSearchTextField = (0,styled_esm/* default */.ZP)(TextField_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return ![
            "isAnyOptionSelected",
            "isLocationFieldFocused",
            "isLocationValidationFailed"
        ].includes(prop);
    }
})(function(param) {
    var isAnyOptionSelected = param.isAnyOptionSelected, isLocationFieldFocused = param.isLocationFieldFocused, isLocationValidationFailed = param.isLocationValidationFailed;
    return SearchBar_styles_objectSpread({
        height: defaultHeight,
        borderTopRightRadius: "32px",
        borderBottomRightRadius: "32px",
        borderWidth: 0,
        backgroundColor: isLocationFieldFocused || isLocationValidationFailed ? whiteColor : transparentColor,
        borderRadius: "60px"
    }, isLocationFieldFocused && {
        boxShadow: boxShadow
    }, isLocationValidationFailed && {
        border: errorBorderStyle
    }, {
        ".MuiInputBase-root": {
            padding: "0 85px 0 0",
            height: "100%",
            input: SearchBar_styles_objectSpread({
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                color: isLocationFieldFocused ? "#2247B3" : "#1A3586"
            }, isLocationValidationFailed && {
                color: "#CC4F4A"
            }, {
                fontWeight: isLocationFieldFocused ? "400" : "500"
            })
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "none"
        },
        "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            border: "none"
        },
        "&:hover, &:focus": SearchBar_styles_objectSpread({}, isLocationFieldFocused || isLocationValidationFailed ? SearchBar_styles_objectSpread({
            backgroundColor: whiteColor
        }, isLocationValidationFailed ? {
            border: errorBorderStyle
        } : {}) : {
            backgroundColor: getHoverState({
                doubleHoverCondition: isAnyOptionSelected
            })
        }, {
            height: defaultHeight,
            borderWidth: 0
        })
    });
});
var StyledMenuList = (0,styled_esm/* default */.ZP)(MenuList_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return ![
            "isOpen"
        ].includes(prop);
    }
})(function(param) {
    var theme = param.theme, isOpen = param.isOpen;
    return SearchBar_styles_defineProperty({
        width: "100%",
        border: styles_borderStyle,
        borderRadius: "16px",
        display: isOpen ? "block" : "none",
        position: "absolute",
        boxShadow: "0px 11px 15px 0px #0203030A, 0px 9px 46px 0px #02030305, 0px 24px 38px 0px #02030308",
        top: "110%"
    }, theme.breakpoints.down("lg"), {
        position: "static",
        borderRadius: isOpen ? "0px 0px 16px 16px" : "16px",
        "& li:first-child": {
            borderTopLeftRadius: isOpen ? 0 : "16px",
            borderTopRightRadius: isOpen ? 0 : "16px"
        }
    });
});
var StyledLink = (0,styled_esm/* default */.ZP)(Link_esm/* default */.Z)({
    textDecoration: "none",
    textDecorationColor: "-moz-initial",
    color: "text.primary"
});
var TypeMenuItem = (0,styled_esm/* default */.ZP)(MenuItem_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return ![
            "isFirstItem",
            "isLastItem"
        ].includes(prop);
    }
})(function(param) {
    var isFirstItem = param.isFirstItem, isLastItem = param.isLastItem, theme = param.theme;
    return {
        backgroundColor: "#fff",
        borderTopLeftRadius: isFirstItem ? "16px" : 0,
        borderTopRightRadius: isFirstItem ? "16px" : 0,
        borderBottomLeftRadius: isLastItem ? "16px" : 0,
        borderBottomRightRadius: isLastItem ? "16px" : 0,
        width: "100%",
        padding: "12px 20px 12px 12px",
        "&:hover": {
            backgroundColor: theme.custom.SearchBar.MenuItem.backgroundColor
        },
        ">.MuiStack-root": {
            gap: "15px",
            alignItems: "center",
            ">.MuiListItemIcon-root": {
                minWidth: "auto",
                padding: "0 5px"
            }
        }
    };
});
var SearchButtonContainer = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)({
    paddingLeft: "6px",
    justifyContent: "center",
    alignContent: "center"
});
var SearchIconButton = (0,styled_esm/* default */.ZP)(IconButton_esm/* default */.Z)(function(param) {
    var allFieldsAreFilled = param.allFieldsAreFilled;
    return {
        width: "72px",
        height: "72px",
        "&.MuiIconButton-root": {
            backgroundColor: allFieldsAreFilled ? "#2B59E0" : "#1A3586"
        }
    };
});
var StyledPaper = (0,styled_esm/* default */.ZP)(Paper_esm/* default */.Z)({
    position: "absolute",
    top: "110%",
    left: 0,
    width: "100%",
    border: styles_borderStyle,
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "8px 0px",
    maxHeight: "40vh",
    overflowY: "auto"
});
var StyledNoOptionText = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)({
    width: "100%",
    color: "rgb(76, 88, 112)",
    padding: "6px 16px"
});
var StyledCheckbox = (0,styled_esm/* default */.ZP)(Checkbox_esm/* default */.Z)(function(param) {
    var checked = param.checked;
    return {
        "& .MuiSvgIcon-root": {
            fontSize: "24px !important"
        },
        "&.MuiCheckbox-root": {
            padding: "0 4px 0 0",
            color: checked ? "#406AE3" : "#8794AE"
        }
    };
});
var StyledSelect = (0,styled_esm/* default */.ZP)(Select_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    return {
        borderRadius: "32px",
        border: "1px solid #D5DEF9",
        boxShadow: "none",
        ".MuiOutlinedInput-notchedOutline": {
            border: 0
        },
        "& .MuiList-root": {
            "&::-webkit-scrollbar": {
                width: 8,
                borderRadius: 8,
                background: "#D5DEF9"
            },
            "&::-webkit-scrollbar-thumb": {
                backgroundColor: theme.custom.scrollbarThumb.backgroundColor,
                borderRadius: 8
            }
        }
    };
});
var ref;
var StyledMenuItem = (0,styled_esm/* default */.ZP)(MenuItem_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    var ref3, ref2;
    return {
        "& .MuiMenuItem-root": {
            borderWidth: 0,
            display: "flex",
            justifyContent: "space-between",
            fontSize: "13.33px",
            fontFamily: theme.typography.fontFamily,
            flexDirection: "row",
            alignItems: "center",
            height: "36px !important",
            borderRadius: 0,
            flex: "none",
            order: 0,
            alignSelf: "stretch",
            flexGrow: 0
        },
        "&:hover": (ref = theme === null || theme === void 0 ? void 0 : (ref3 = theme.custom) === null || ref3 === void 0 ? void 0 : (ref2 = ref3.SearchFilters) === null || ref2 === void 0 ? void 0 : ref2.menuItemHover) !== null && ref !== void 0 ? ref : {}
    };
});
var FilterButton = (0,styled_esm/* default */.ZP)(Button_esm/* default */.Z)({
    borderRadius: "24px",
    border: "1px solid #142F76",
    color: "#142F76",
    fontWeight: 800,
    "&:active, &:focus, &:hover": {
        backgroundColor: "transparent",
        color: "#142F76"
    }
});
var ref1;
var StyledInputLabel = (0,styled_esm/* default */.ZP)(InputLabel_esm/* default */.Z)(function(param) {
    var theme = param.theme;
    var ref5, ref4;
    return SearchBar_styles_objectSpread({}, (ref1 = theme === null || theme === void 0 ? void 0 : (ref5 = theme.custom) === null || ref5 === void 0 ? void 0 : (ref4 = ref5.SearchFilters) === null || ref4 === void 0 ? void 0 : ref4.inputLabel) !== null && ref1 !== void 0 ? ref1 : {});
});
var StyledLocationOnIcon = (0,styled_esm/* default */.ZP)(LocationOn_index_esm/* default */.Z)({
    width: "16px",
    height: "16px"
});
var styles_ItemRootContainer = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return ![
            "isMobile"
        ].includes(prop);
    }
})(function(param) {
    var theme = param.theme, isMobile = param.isMobile;
    return SearchBar_styles_objectSpread({}, theme.typography.body2, {
        padding: theme.spacing(1.5, 2),
        display: "flex",
        alignItems: "center",
        minHeight: 47
    }, isMobile && {
        backgroundColor: "#fff",
        padding: "16px 24px"
    }, {
        "&:hover": {
            cursor: "pointer",
            userSelect: "none",
            backgroundColor: isMobile ? theme.custom.SearchBar.MenuItem.backgroundColor : "#f5f5f5"
        }
    });
});
var styles_ItemTitle = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return ![
            "specialistOrPractice"
        ].includes(prop);
    }
})(function(param) {
    var theme = param.theme, specialistOrPractice = param.specialistOrPractice;
    return SearchBar_styles_objectSpread({}, theme.typography.body2, {
        "& .text-highlight": {
            color: theme.palette.primary.main,
            fontWeight: 600
        },
        color: specialistOrPractice ? theme.palette.primary.main : theme.palette.text.primary,
        fontWeight: specialistOrPractice ? 600 : 400
    });
});

// EXTERNAL MODULE: ./components/Icons/LoadingWheel.tsx
var LoadingWheel = __webpack_require__(33137);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/icons-material/ChevronRight.esm.js + 1 modules
var ChevronRight_esm = __webpack_require__(89850);
;// CONCATENATED MODULE: ./components/HomePage/SearchBar/WebView/styles.ts
function WebView_styles_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function WebView_styles_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            WebView_styles_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var InputGradientText = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return ![
            "isActive",
            "isError"
        ].includes(prop);
    }
})(function(param) {
    var isActive = param.isActive, isError = param.isError;
    return WebView_styles_objectSpread({
        background: isActive ? "linear-gradient(90deg, rgba(43, 89, 224, 0.70) 50%, rgba(14, 182, 213, 0.51) 83.26%, rgba(0, 229, 208, 0.70) 99.99%, rgba(0, 229, 208, 0.70) 100%, rgba(0, 229, 208, 0.42) 100%, rgba(13, 187, 213, 0.70) 100%), #2B59E0" : "#4C5870"
    }, isError && {
        background: "#CC4F4A"
    }, {
        backgroundClip: "text",
        pointerEvents: "none",
        WebkitTextFillColor: "transparent",
        fontWeight: isActive ? 600 : 500,
        fontSize: "13px",
        lineHeight: "20px"
    });
});
var InputText = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return ![
            "isActive"
        ].includes(prop);
    }
})(function(param) {
    var isActive = param.isActive;
    return {
        color: isActive ? "#2247B3" : "#1A3586",
        fontSize: "13px",
        lineHeight: "20px",
        fontWeight: isActive ? "400" : "500"
    };
});
var StyledChevronRightIcon = (0,styled_esm/* default */.ZP)(ChevronRight_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return ![
            "isOpen"
        ].includes(prop);
    }
})(function(param) {
    var isOpen = param.isOpen;
    return {
        rotate: isOpen ? "270deg" : "90deg",
        width: "16px",
        height: "16px",
        color: "#1A3586",
        transition: "all 0.3s ease-in-out"
    };
});

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Stack/Stack.esm.js + 1 modules
var Stack_esm = __webpack_require__(11854);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/ListItemIcon/ListItemIcon.esm.js
var ListItemIcon_esm = __webpack_require__(48339);
;// CONCATENATED MODULE: ./components/HomePage/SearchBar/MobileFiltersModal/TypeMenuItemBlock.tsx
function TypeMenuItemBlock_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TypeMenuItemBlock_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TypeMenuItemBlock_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var TypeMenuItemBlock = function(param) {
    var title = param.title, value = param.value, isFirstItem = param.isFirstItem, isLastItem = param.isLastItem, Icon = param.Icon, onClick = param.onClick, searchType = param.searchType;
    var theme = (0,useTheme_esm/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeMenuItem, {
        value: value,
        isFirstItem: isFirstItem,
        isLastItem: isLastItem,
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack_esm/* default */.Z, {
            direction: "row",
            justifyContent: "space-between",
            p: 0.5,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon_esm/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/hermes-static/icons/".concat(Icon, ".svg"),
                        alt: "",
                        width: 22,
                        height: 22,
                        objectFit: "none",
                        unoptimized: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText_esm/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                        variant: "body1",
                        textAlign: "left",
                        sx: TypeMenuItemBlock_objectSpread({
                            color: "#11245A"
                        }, searchType === value ? theme.custom.SearchBar.SelectedMenuItem : {}),
                        children: title
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var MobileFiltersModal_TypeMenuItemBlock = (TypeMenuItemBlock);

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Divider/Divider.esm.js
var Divider_esm = __webpack_require__(15819);
// EXTERNAL MODULE: ./hooks/useClickOutside.ts
var useClickOutside = __webpack_require__(12056);
;// CONCATENATED MODULE: ./components/HomePage/SearchBar/WebView/LocationInput.tsx
function LocationInput_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LocationInput_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LocationInput_defineProperty(target, key, source[key]);
        });
    }
    return target;
}












var LocationInput = function(param1) {
    var onChangeLocationSearch = param1.onChangeLocationSearch, isClientSide = param1.isClientSide, isAnyOptionSelected = param1.isAnyOptionSelected, isLocationFieldFocused = param1.isLocationFieldFocused, getYourLocation = param1.getYourLocation, setIsLocationFieldFocused = param1.setIsLocationFieldFocused, setIsLocationFieldHovered = param1.setIsLocationFieldHovered;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var timeout = (0,useTimeout/* useTimeout */.K)();
    var theme = (0,useTheme_esm/* default */.Z)();
    var language = (0,react.useContext)(AppData/* AppDataContext */.R).language;
    var ref = (0,react.useContext)(HomePageContext), changeCurrentLocation = ref.changeCurrentLocation, _state = ref.state, locations = _state.locations, filters = _state.filters, isLocationChanged = _state.isLocationChanged, isLocationValidationFailed = _state.isLocationValidationFailed;
    var ref1 = (0,react.useState)(""), searchText = ref1[0], setSearchText = ref1[1];
    var locationsAutocompleteRef = (0,react.useRef)(null);
    (0,useClickOutside/* default */.Z)(locationsAutocompleteRef, function() {
        return setIsLocationFieldFocused(false);
    });
    var handleSetFocusOnLocation = function() {
        return setIsLocationFieldFocused(function(prev) {
            return !prev;
        });
    };
    var onLocationChanged = function(newValue) {
        return timeout(function() {
            var _slug;
            changeCurrentLocation(newValue.id, newValue.label, (_slug = newValue.slug) !== null && _slug !== void 0 ? _slug : undefined);
            setSearchText(newValue.label);
        });
    };
    var autocompleteLocationMapper = function(param) {
        var place_id = param.place_id, description = param.description, name = param.name, googlePlaceId = param.googlePlaceId, slug = param.slug;
        return {
            id: place_id || googlePlaceId,
            label: description || name[language],
            slug: slug
        };
    };
    var mappedLocation = (locations === null || locations === void 0 ? void 0 : locations.map(autocompleteLocationMapper)) || [];
    var _selectedLocationName, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
        item: true,
        position: "relative",
        width: "30%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGradientText, {
                style: {
                    position: "absolute",
                    zIndex: 10,
                    left: "14px",
                    top: "18px",
                    marginLeft: "8px"
                },
                isActive: isLocationFieldFocused,
                isError: isLocationValidationFailed,
                children: translate("homepage.searchbar.where")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationSearchTextField, {
                ref: locationsAutocompleteRef,
                fullWidth: true,
                value: searchText,
                autoComplete: "off",
                onFocus: function() {
                    if (!isLocationChanged) {
                        handleSetFocusOnLocation();
                    }
                },
                placeholder: translate("search.placeholder.location"),
                isLocationValidationFailed: isLocationValidationFailed,
                isAnyOptionSelected: isAnyOptionSelected,
                onChange: function(e) {
                    setIsLocationFieldFocused(true);
                    setSearchText(e.target.value);
                    onChangeLocationSearch(e);
                },
                onBlur: function() {
                    return setSearchText(decodeURIComponent((_selectedLocationName = filters.selectedLocationName) !== null && _selectedLocationName !== void 0 ? _selectedLocationName : ""));
                },
                onMouseEnter: function() {
                    return setIsLocationFieldHovered(true);
                },
                onMouseLeave: function() {
                    return setIsLocationFieldHovered(false);
                },
                isLocationFieldFocused: isLocationFieldFocused,
                sx: {
                    "& div": {
                        paddingRight: isLocationChanged ? "10px !important" : "",
                        "& input": {
                            marginLeft: "8px",
                            marginTop: "20px",
                            "::placeholder": {
                                color: getTextColor({
                                    isError: isLocationValidationFailed,
                                    isFocused: isLocationFieldFocused && !!filters.selectedLocationName
                                })
                            }
                        }
                    }
                },
                InputProps: {
                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRenderBox/* default */.Z, {
                        isOpen: isLocationFieldFocused,
                        isClientSide: isClientSide,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPaper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_ItemRootContainer, {
                                    sx: {
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    },
                                    onClick: getYourLocation,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ItemTitle, {
                                            children: translate("my_current_location")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MyLocation_esm/* default */.Z, {
                                            sx: {
                                                width: 14,
                                                height: 14,
                                                color: "primary.main"
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ItemRootContainer, {
                                    sx: {
                                        py: 0,
                                        minHeight: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_esm/* default */.Z, {
                                        sx: {
                                            width: "100%"
                                        }
                                    })
                                }),
                                mappedLocation.length ? mappedLocation.map(function(location) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(MenuItem_esm/* default */.Z, {
                                        onClick: function() {
                                            setIsLocationFieldFocused(false);
                                            onLocationChanged(location);
                                        },
                                        sx: LocationInput_objectSpread({
                                            fontSize: "14px",
                                            padding: "6px 16px",
                                            color: "text.primary",
                                            boxSizing: "border-box",
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            whiteSpace: "wrap",
                                            "&:hover": {
                                                backgroundColor: theme.custom.SearchBar.MenuItem.backgroundColor
                                            }
                                        }, decodeURIComponent((ref2 = filters === null || filters === void 0 ? void 0 : filters.selectedLocationName) !== null && ref2 !== void 0 ? ref2 : "") === location.label ? theme.custom.SearchBar.SelectedMenuItem : {}),
                                        children: location.label
                                    }, "location-link-".concat(location.id, "-").concat(location.label));
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNoOptionText, {
                                    children: translate("searchBar.noOption")
                                })
                            ]
                        })
                    })
                }
            })
        ]
    });
};
/* harmony default export */ var WebView_LocationInput = (LocationInput);

;// CONCATENATED MODULE: ./components/HomePage/SearchBar/WebView/index.tsx
function WebView_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function WebView_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            WebView_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}














var getTextColor = function(param) {
    var isError = param.isError, isFocused = param.isFocused;
    if (isFocused) {
        return "#2247B3";
    }
    return isError ? "#CC4F4A" : "#4C5870";
};
var WebView = function(_param) {
    var onChangeSearchType = _param.onChangeSearchType, onChangeSearch = _param.onChangeSearch, onSearchFieldFocus = _param.onSearchFieldFocus, onSearchFieldBlur = _param.onSearchFieldBlur, onChangeLocationSearch = _param.onChangeLocationSearch, isLocationFieldFocused = _param.isLocationFieldFocused, setIsLocationFieldFocused = _param.setIsLocationFieldFocused, isClientSide = _param.isClientSide, getYourLocation = _param.getYourLocation, handleSearch = _param.handleSearch, openSearchTypeDropdown = _param.openSearchTypeDropdown, setOpenSearchTypeDropdown = _param.setOpenSearchTypeDropdown, autocompleteProps = _objectWithoutProperties(_param, [
        "onChangeSearchType",
        "onChangeSearch",
        "onSearchFieldFocus",
        "onSearchFieldBlur",
        "onChangeLocationSearch",
        "isLocationFieldFocused",
        "setIsLocationFieldFocused",
        "isClientSide",
        "getYourLocation",
        "handleSearch",
        "openSearchTypeDropdown",
        "setOpenSearchTypeDropdown"
    ]);
    var translate = (0,useTranslateMessage/* default */.Z)();
    var theme = (0,useTheme_esm/* default */.Z)();
    var ref5 = (0,react.useContext)(HomePageContext), resetKeywordSearch = ref5.resetKeywordSearch, _state = ref5.state, filters = _state.filters, isKeywordChanged = _state.isKeywordChanged, isKeywordValidationFailed = _state.isKeywordValidationFailed, isLocationValidationFailed = _state.isLocationValidationFailed, isLoadingButtonState = _state.isLoadingButtonState;
    var ref1 = hooks_useHomePageSearchBarConfig(), searchTypes = ref1.searchTypes, selectedSearchType = ref1.selectedSearchType;
    var ref2 = (0,react.useState)(false), isTypeFieldHovered = ref2[0], setIsTypeFieldHovered = ref2[1];
    var ref3 = (0,react.useState)(false), isLocationFieldHovered = ref3[0], setIsLocationFieldHovered = ref3[1];
    var ref4 = (0,react.useState)(false), isAutocompleteHovered = ref4[0], setIsAutocompleteHovered = ref4[1];
    var allFieldsAreFilled = (0,react.useMemo)(function() {
        return !!filters.selectedKeywordId && !!filters.selectedLocationId;
    }, [
        filters.selectedKeywordId,
        filters.selectedLocationId
    ]);
    var handleCloseSearchTypeDown = function() {
        return setOpenSearchTypeDropdown(false);
    };
    var changeTypeDropdownState = function() {
        return setOpenSearchTypeDropdown(function(prev) {
            return !prev;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
        component: Hidden_esm/* default */.Z,
        implementation: "css",
        justifyContent: "center",
        sm: 8,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
            container: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchBarContainer, {
                    container: true,
                    isAnyOptionSelected: openSearchTypeDropdown || autocompleteProps.isSearchFieldFocused || isLocationFieldFocused,
                    leftTabHovered: isTypeFieldHovered && autocompleteProps.isSearchFieldFocused || openSearchTypeDropdown && isAutocompleteHovered,
                    rightTabHovered: isLocationFieldHovered && autocompleteProps.isSearchFieldFocused || isLocationFieldFocused && isAutocompleteHovered,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClickAwayListener_esm/* default */.Z, {
                            onClickAway: handleCloseSearchTypeDown,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid_esm/* default */.ZP, {
                                item: true,
                                width: "30%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledIconButton, {
                                    onClick: function() {
                                        return changeTypeDropdownState();
                                    },
                                    disableRipple: true,
                                    onMouseEnter: function() {
                                        return setIsTypeFieldHovered(true);
                                    },
                                    onMouseLeave: function() {
                                        return setIsTypeFieldHovered(false);
                                    },
                                    children: [
                                        selectedSearchType && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomMenuItem, {
                                            openSearchTypeDropdown: openSearchTypeDropdown,
                                            isSearchFieldFocused: autocompleteProps.isSearchFieldFocused,
                                            isLocationFieldFocused: isLocationFieldFocused,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemText_esm/* default */.Z, {
                                                    sx: {
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        width: "100%",
                                                        marginLeft: "8px"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGradientText, {
                                                            isActive: openSearchTypeDropdown,
                                                            children: translate("homepage.searchbar.look")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputText, {
                                                            textAlign: "left",
                                                            isActive: openSearchTypeDropdown,
                                                            children: selectedSearchType.title
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledChevronRightIcon, {
                                                    isOpen: openSearchTypeDropdown
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMenuList, {
                                            isOpen: openSearchTypeDropdown,
                                            children: searchTypes.map(function(param, index) {
                                                var value = param.value, title = param.title, Icon = param.Icon;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFiltersModal_TypeMenuItemBlock, {
                                                    isFirstItem: index === 0,
                                                    isLastItem: searchTypes.length - 1 === index,
                                                    value: value,
                                                    searchType: filters.searchType,
                                                    onClick: function() {
                                                        return onChangeSearchType(value);
                                                    },
                                                    title: title,
                                                    Icon: Icon
                                                }, value);
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid_esm/* default */.ZP, {
                            item: true,
                            width: "40%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                    position: "relative",
                                    sx: {
                                        marginLeft: "8px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputGradientText, {
                                        style: {
                                            position: "absolute",
                                            zIndex: 10,
                                            left: "14px",
                                            top: "18px"
                                        },
                                        isActive: autocompleteProps.isSearchFieldFocused,
                                        isError: isKeywordValidationFailed,
                                        children: translate("homepage.searchbar.what")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AutocompleteSearchTextField, {
                                    fullWidth: true,
                                    onMouseEnter: function() {
                                        return setIsAutocompleteHovered(true);
                                    },
                                    onMouseLeave: function() {
                                        return setIsAutocompleteHovered(false);
                                    },
                                    placeholder: translate("homepage.search.placeholder.second-input"),
                                    autoComplete: "off",
                                    onChange: function(event) {
                                        var ref;
                                        onChangeSearch(event);
                                        if (!((ref = event.target.value) === null || ref === void 0 ? void 0 : ref.length)) {
                                            resetKeywordSearch();
                                        }
                                    },
                                    value: filters.searchString,
                                    onFocus: function() {
                                        if (!isKeywordChanged) {
                                            onSearchFieldFocus();
                                        }
                                    },
                                    onBlur: onSearchFieldBlur,
                                    isKeywordValidationFailed: isKeywordValidationFailed,
                                    isBorderLeftHidden: isTypeFieldHovered || openSearchTypeDropdown,
                                    isBorderRightHidden: isLocationFieldHovered || isLocationFieldFocused || isLocationValidationFailed,
                                    isSearchFieldFocused: autocompleteProps.isSearchFieldFocused,
                                    openSearchTypeDropdown: openSearchTypeDropdown,
                                    isLocationFieldFocused: isLocationFieldFocused,
                                    InputProps: {
                                        endAdornment: isKeywordChanged ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWheel/* default */.Z, {}) : null,
                                        sx: {
                                            borderWidth: 1,
                                            borderColor: "red",
                                            marginLeft: "8px",
                                            paddingRight: isKeywordChanged ? "9px !important" : "",
                                            "& input": {
                                                marginTop: "20px",
                                                "::placeholder": filters.selectedKeywordName ? {
                                                    color: getTextColor({
                                                        isError: isKeywordValidationFailed,
                                                        isFocused: true
                                                    }),
                                                    fontWeight: 500
                                                } : {
                                                    color: getTextColor({
                                                        isError: isKeywordValidationFailed,
                                                        isFocused: false
                                                    }),
                                                    fontWeight: 400
                                                }
                                            }
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRenderBox/* default */.Z, {
                                    isOpen: autocompleteProps.isSearchFieldFocused,
                                    isClientSide: isClientSide,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar_CustomAutocomplete, WebView_objectSpread({
                                        onChangeSearch: onChangeSearch,
                                        onSearchFieldBlur: onSearchFieldBlur,
                                        customStyle: !!(filters === null || filters === void 0 ? void 0 : filters.searchType) && global/* newSearchTypesPractices.includes */.Bg.includes(filters.searchType) ? theme.custom.SearchBar.customPositionDesktopModal : theme.custom.SearchBar.customPositionDesktopModalForDoctify
                                    }, autocompleteProps))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WebView_LocationInput, {
                            getYourLocation: getYourLocation,
                            isClientSide: isClientSide,
                            isAnyOptionSelected: openSearchTypeDropdown || autocompleteProps.isSearchFieldFocused,
                            setIsLocationFieldFocused: setIsLocationFieldFocused,
                            setIsLocationFieldHovered: setIsLocationFieldHovered,
                            isLocationFieldFocused: isLocationFieldFocused,
                            onChangeLocationSearch: onChangeLocationSearch
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButtonContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIconButton, {
                        onClick: handleSearch,
                        allFieldsAreFilled: allFieldsAreFilled,
                        children: isLoadingButtonState ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWheel/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBarSearchIcon_index_esm/* default */.Z, {
                            sx: {
                                width: "24px",
                                height: "24px",
                                path: {
                                    stroke: whiteColor
                                }
                            }
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var SearchBar_WebView = (WebView);

;// CONCATENATED MODULE: ./components/HomePage/SearchBar/MobileView/styles.ts
function MobileView_styles_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MobileView_styles_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MobileView_styles_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var StartSearchButton = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)({
    backgroundClip: "padding-box, border-box",
    backgroundOrigin: "border-box",
    backgroundImage: "linear-gradient(0deg, #fff, #fff), linear-gradient(90.9deg, #0040FF 0.26%, #B8CAFF 100%)",
    border: "1px solid transparent",
    borderRadius: "40px",
    padding: "13px 20px",
    gap: "10px",
    display: "flex",
    alignItems: "center",
    boxShadow: "0px 0px 107px 0px rgba(21, 21, 183, 0.30)"
});
var StartSearchText = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)({
    background: "linear-gradient(90deg, rgba(17, 41, 113, 0.50) 0%, rgba(43, 89, 224, 0.50) 99.99%, rgba(43, 89, 224, 0.50) 100%), #2B59E0",
    backgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontWeight: 500,
    margin: "0 auto",
    fontSize: "15px",
    lineHeight: "20px"
});
var MobileSearchTextField = (0,styled_esm/* default */.ZP)(TextField_esm/* default */.Z, {
    shouldForwardProp: function(prop) {
        return ![
            "isFilled",
            "isError",
            "isFocused"
        ].includes(prop);
    }
})(function(param) {
    var theme = param.theme, isFocused = param.isFocused, isFilled = param.isFilled, isError = param.isError;
    return MobileView_styles_objectSpread({
        height: "48px",
        borderRadius: "24px",
        background: isFilled || isFocused ? "#fff" : "#F4F7FD"
    }, isError && {
        "& fieldset": {
            borderColor: "#FF635C"
        }
    }, MobileView_styles_defineProperty({
        "& .MuiInputBase-root": MobileView_styles_defineProperty({
            borderRadius: "24px",
            height: "100%",
            "input::placeholder": MobileView_styles_objectSpread({}, theme.typography.body1, {
                color: "#4C5870"
            })
        }, theme.breakpoints.down("lg"), {
            borderRadius: isFocused ? "16px 16px 0 0" : "24px"
        })
    }, theme.breakpoints.down("lg"), {
        borderRadius: isFocused ? "16px 16px 0 0" : "24px"
    }));
});

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/icons/CloseRounded/index.esm.js
var CloseRounded_index_esm = __webpack_require__(2555);
// EXTERNAL MODULE: ./utils/strings.ts
var strings = __webpack_require__(5892);
;// CONCATENATED MODULE: ./components/HomePage/SearchBar/MobileFiltersModal/styles.ts
function MobileFiltersModal_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function MobileFiltersModal_styles_templateObject() {
    var data = MobileFiltersModal_styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    background: linear-gradient(18deg, #A2B9F8 -15.4%, #EBEEFB 104.01%);;\n    position: fixed;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    padding: 80px 20px 24px 20px;\n    box-sizing: border-box;\n    overflow-y: auto;\n    z-index: 999;\n"
    ]);
    MobileFiltersModal_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var MobileFiltersModal_styles_Container = (0,styled_esm/* default */.ZP)("div")(MobileFiltersModal_styles_templateObject());

;// CONCATENATED MODULE: ./components/HomePage/SearchBar/MobileFiltersModal/index.tsx
function MobileFiltersModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function MobileFiltersModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            MobileFiltersModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

















var baseAdornmentStyles = {
    marginLeft: "17px",
    marginRight: "17px",
    width: "16px",
    height: "16px",
    cursor: "pointer"
};
var MobileFiltersModal = function(param1) {
    var searchText = param1.searchText, isSearchFieldFocused = param1.isSearchFieldFocused, setIsSearchFieldFocused = param1.setIsSearchFieldFocused, onSearch = param1.onSearch, onChangeLocationSearch = param1.onChangeLocationSearch, onChangeSearch = param1.onChangeSearch, onChangeSearchType = param1.onChangeSearchType, onSearchFieldFocus = param1.onSearchFieldFocus, getYourLocation = param1.getYourLocation, setSearchBarExpand = param1.setSearchBarExpand, setIsLocationFieldFocused = param1.setIsLocationFieldFocused, onSearchFieldBlur = param1.onSearchFieldBlur, setSearchText = param1.setSearchText;
    var ref17, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var timeout = (0,useTimeout/* useTimeout */.K)();
    var translate = (0,useTranslateMessage/* default */.Z)();
    var theme = (0,useTheme_esm/* default */.Z)();
    var language = (0,react.useContext)(AppData/* AppDataContext */.R).language;
    var ref10 = (0,react.useContext)(HomePageContext), changeCurrentLocation = ref10.changeCurrentLocation, resetKeywordSearch = ref10.resetKeywordSearch, resetValidation = ref10.resetValidation, _state = ref10.state, filters = _state.filters, isKeywordChanged = _state.isKeywordChanged, isLocationChanged = _state.isLocationChanged, locations = _state.locations, isKeywordValidationFailed = _state.isKeywordValidationFailed, isLocationValidationFailed = _state.isLocationValidationFailed, isLoadingButtonState = _state.isLoadingButtonState;
    var ref11 = hooks_useHomePageSearchBarConfig(), searchTypes = ref11.searchTypes, selectedSearchType = ref11.selectedSearchType, MobileProfileTypeLeftIcon = ref11.MobileProfileTypeLeftIcon, MobileProfileTypeRightIcon = ref11.MobileProfileTypeRightIcon, MobileKeywordSearchLeftIconAlternative = ref11.MobileKeywordSearchLeftIconAlternative, MobileLocationSearchLeftIconAlternative = ref11.MobileLocationSearchLeftIconAlternative;
    var ref12 = (0,react.useState)(false), isLocationFocused = ref12[0], setIsLocationFocused = ref12[1];
    var ref13 = (0,react.useState)(true), openSearchTypeDropdown = ref13[0], setOpenSearchTypeDropdown = ref13[1];
    var searchTypeRef = (0,react.useRef)(null);
    var searchFieldRef = (0,react.useRef)(null);
    var locationFieldRef = (0,react.useRef)(null);
    (0,useClickOutside/* default */.Z)(searchTypeRef, function() {
        return setOpenSearchTypeDropdown(false);
    });
    (0,useClickOutside/* default */.Z)(searchFieldRef, function() {
        return setIsSearchFieldFocused(false);
    });
    (0,useClickOutside/* default */.Z)(locationFieldRef, function() {
        return setIsLocationFocused(false);
    });
    var onToggleModal = function() {
        return setOpenSearchTypeDropdown(function(prev) {
            return !prev;
        });
    };
    var changeLocationFocus = function() {
        return setIsLocationFocused(function(prev) {
            return !prev;
        });
    };
    var onClose = function() {
        return setOpenSearchTypeDropdown(false);
    };
    var handleSearchType = (0,react.useCallback)(function(value) {
        return function() {
            onClose();
            onChangeSearchType(value);
            setIsSearchFieldFocused(true);
        };
    }, [
        onChangeSearchType,
        setIsSearchFieldFocused
    ]);
    var onLocationChanged = function(newValue) {
        return timeout(function() {
            var _slug;
            changeCurrentLocation(newValue.id, newValue.label, (_slug = newValue.slug) !== null && _slug !== void 0 ? _slug : undefined);
            setSearchText(newValue.label);
            setIsLocationFocused(false);
        });
    };
    var autocompleteLocationMapper = function(param) {
        var place_id = param.place_id, description = param.description, name = param.name, googlePlaceId = param.googlePlaceId, slug = param.slug;
        return {
            id: place_id || googlePlaceId,
            label: description || name[language],
            slug: slug
        };
    };
    var mappedLocation = (locations === null || locations === void 0 ? void 0 : locations.map(autocompleteLocationMapper)) || [];
    var getSearchEndIcon = function() {
        var ref;
        if (isKeywordChanged) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWheel/* default */.Z, {
                style: {
                    marginLeft: "10px"
                }
            });
        }
        if (((ref = filters.searchString) === null || ref === void 0 ? void 0 : ref.length) && filters.searchType !== types/* SearchTypes.dentist */.ai.dentist) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseRounded_index_esm/* CloseRoundedIcon */.v, {
                sx: {
                    borderRadius: "50%",
                    background: "#F4F5F5",
                    padding: "4px",
                    width: "24px",
                    height: "24px"
                },
                onClick: function() {
                    return resetKeywordSearch();
                }
            });
        }
        return null;
    };
    var _selectedLocationName, ref14, ref15, ref16;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileFiltersModal_styles_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: searchTypeRef,
                        style: {
                            position: "relative",
                            marginBottom: openSearchTypeDropdown ? "16px" : 0
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSearchTextField, {
                                fullWidth: true,
                                isFocused: openSearchTypeDropdown,
                                isFilled: !!selectedSearchType,
                                inputProps: {
                                    "aria-label": "Mobile Search Text Field"
                                },
                                onClick: function() {
                                    onToggleModal();
                                },
                                placeholder: (0,strings/* capitalise */.Ig)(selectedSearchType === null || selectedSearchType === void 0 ? void 0 : selectedSearchType.title),
                                value: openSearchTypeDropdown ? translate("homepage.searchbar.look") : (0,strings/* capitalise */.Ig)(selectedSearchType === null || selectedSearchType === void 0 ? void 0 : selectedSearchType.title),
                                InputProps: {
                                    startAdornment: openSearchTypeDropdown ? null : MobileProfileTypeLeftIcon,
                                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileProfileTypeRightIcon, {
                                        sx: MobileFiltersModal_objectSpread({
                                            color: "inherit",
                                            transition: "all 0.3s ease-in-out",
                                            rotate: openSearchTypeDropdown ? "180deg" : 0
                                        }, baseAdornmentStyles)
                                    }),
                                    readOnly: true,
                                    sx: function(themeIn) {
                                        return MobileFiltersModal_objectSpread({}, themeIn.typography.body1, {
                                            padding: 0
                                        });
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMenuList, {
                                style: {
                                    zIndex: 99
                                },
                                isOpen: openSearchTypeDropdown,
                                children: searchTypes.map(function(param, index) {
                                    var value = param.value, title = param.title, Icon = param.Icon;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileFiltersModal_TypeMenuItemBlock, {
                                        value: value,
                                        title: title,
                                        isFirstItem: index === 0,
                                        isLastItem: searchTypes.length - 1 === index,
                                        searchType: filters.searchType,
                                        onClick: handleSearchType(value),
                                        Icon: Icon
                                    }, title);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        ref: searchFieldRef,
                        style: {
                            position: "relative",
                            marginBottom: isSearchFieldFocused ? "16px" : 0
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSearchTextField, {
                                fullWidth: true,
                                isError: isKeywordValidationFailed,
                                isFilled: !!filters.selectedKeywordName,
                                isFocused: isSearchFieldFocused,
                                placeholder: translate("homepage.search.keyword.placeholder"),
                                autoComplete: "off",
                                inputProps: {
                                    "aria-label": "Mobile Search Text Field"
                                },
                                sx: {
                                    width: "100%",
                                    position: "relative"
                                },
                                value: filters.searchString,
                                onChange: function(e) {
                                    var value = e.target.value;
                                    onChangeSearch(e);
                                    if (!(value === null || value === void 0 ? void 0 : value.length)) {
                                        resetKeywordSearch();
                                    }
                                },
                                onFocus: function() {
                                    if (!isKeywordChanged) {
                                        onSearchFieldFocus();
                                    }
                                },
                                onBlur: onSearchFieldBlur,
                                InputProps: {
                                    startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileKeywordSearchLeftIconAlternative, {
                                        sx: MobileFiltersModal_objectSpread({
                                            borderRadius: "50%",
                                            path: {
                                                stroke: "#11245A"
                                            }
                                        }, baseAdornmentStyles)
                                    }),
                                    endAdornment: getSearchEndIcon(),
                                    sx: function(themeIn) {
                                        return MobileFiltersModal_objectSpread({}, themeIn.typography.body1, {
                                            padding: "0 20px 0 0"
                                        });
                                    }
                                }
                            }),
                            isSearchFieldFocused && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar_CustomAutocomplete, {
                                isSearchFieldFocused: isSearchFieldFocused,
                                setIsSearchFieldFocused: function(value) {
                                    setIsSearchFieldFocused(value);
                                    setIsLocationFocused(true);
                                },
                                onChangeSearch: onChangeSearch,
                                onSearchFieldBlur: onSearchFieldBlur
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            position: "relative"
                        },
                        ref: locationFieldRef,
                        onClick: function() {
                            return setIsLocationFocused(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSearchTextField, {
                                fullWidth: true,
                                isError: isLocationValidationFailed,
                                isFilled: !!searchText,
                                value: searchText,
                                isFocused: isLocationFocused,
                                autoComplete: "off",
                                onClick: function() {
                                    resetValidation();
                                    changeLocationFocus();
                                },
                                onFocus: changeLocationFocus,
                                placeholder: translate("homepage.search.location.placeholder"),
                                onChange: function(e) {
                                    setSearchText(e.target.value);
                                    onChangeLocationSearch(e);
                                },
                                onBlur: function() {
                                    return setSearchText(decodeURIComponent((_selectedLocationName = filters.selectedLocationName) !== null && _selectedLocationName !== void 0 ? _selectedLocationName : ""));
                                },
                                InputProps: {
                                    startAdornment: MobileLocationSearchLeftIconAlternative ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileLocationSearchLeftIconAlternative, {
                                        sx: MobileFiltersModal_objectSpread({
                                            color: (ref17 = theme.custom) === null || ref17 === void 0 ? void 0 : (ref1 = ref17.SearchFilters) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.mobile) === null || ref2 === void 0 ? void 0 : ref2.textColor,
                                            borderRadius: "50%"
                                        }, baseAdornmentStyles)
                                    }) : null,
                                    endAdornment: isLocationChanged ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWheel/* default */.Z, {
                                        style: {
                                            marginRight: "10px"
                                        }
                                    }) : null,
                                    sx: function(themeIn) {
                                        return MobileFiltersModal_objectSpread({}, themeIn.typography.body1, {
                                            padding: 0
                                        });
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMenuList, {
                                style: {
                                    zIndex: 99,
                                    overflow: "hidden"
                                },
                                isOpen: isLocationFocused,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_ItemRootContainer, {
                                        isMobile: true,
                                        sx: {
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        },
                                        onClick: getYourLocation,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ItemTitle, {
                                                sx: {
                                                    color: "#11245A"
                                                },
                                                children: translate("homepage.search.location.current")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MyLocation_esm/* default */.Z, {
                                                sx: {
                                                    width: 14,
                                                    height: 14,
                                                    color: "primary.main"
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_ItemRootContainer, {
                                        sx: {
                                            py: 0,
                                            minHeight: 0
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_esm/* default */.Z, {
                                            sx: {
                                                width: "100%"
                                            }
                                        })
                                    }),
                                    mappedLocation.length ? mappedLocation.map(function(location, index) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(MenuItem_esm/* default */.Z, {
                                            onClick: function() {
                                                setIsLocationFieldFocused(false);
                                                onLocationChanged(location);
                                            },
                                            sx: MobileFiltersModal_objectSpread({
                                                fontSize: "14px",
                                                padding: "16px 24px",
                                                color: "#11245A",
                                                boxSizing: "border-box",
                                                display: "flex",
                                                justifyContent: "flex-start",
                                                whiteSpace: "wrap",
                                                backgroundColor: "#fff",
                                                "&:hover": {
                                                    backgroundColor: theme.custom.SearchBar.MenuItem.backgroundColor
                                                }
                                            }, decodeURIComponent((ref14 = filters === null || filters === void 0 ? void 0 : filters.selectedLocationName) !== null && ref14 !== void 0 ? ref14 : "") === location.label ? theme.custom.SearchBar.SelectedMenuItem : {}),
                                            children: location.label
                                        }, String(location.id) + index);
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNoOptionText, {
                                        children: translate("searchBar.noOption")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link_esm/* default */.Z, {
                        component: "button",
                        onClick: function() {
                            return setSearchBarExpand(false);
                        },
                        sx: {
                            color: "#2C3341",
                            fontWeight: 500,
                            textDecorationColor: "#2C3341",
                            fontSize: "15px"
                        },
                        children: translate("homepage.search.close")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_esm/* default */.Z, {
                        sx: MobileFiltersModal_objectSpread({}, (ref15 = theme === null || theme === void 0 ? void 0 : (ref3 = theme.custom) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.SearchBar) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.mobile) === null || ref5 === void 0 ? void 0 : ref5.searchButton) !== null && ref15 !== void 0 ? ref15 : {}, {
                            background: "#1A3586",
                            marginTop: 0,
                            padding: "8px 24px"
                        }),
                        onClick: onSearch,
                        children: isLoadingButtonState ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWheel/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
                            fontSize: "15px",
                            variant: "h4",
                            color: (ref16 = theme === null || theme === void 0 ? void 0 : (ref6 = theme.custom) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.SearchBar) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.mobile) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.searchButton) === null || ref9 === void 0 ? void 0 : ref9.color) !== null && ref16 !== void 0 ? ref16 : "white",
                            children: translate("search")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SearchBar_MobileFiltersModal = (MobileFiltersModal);

;// CONCATENATED MODULE: ./components/HomePage/SearchBar/MobileView/index.tsx








var MobileView = function(param) {
    var onSearchFieldFocus = param.onSearchFieldFocus, onChangeLocationSearch = param.onChangeLocationSearch, onChangeSearchType = param.onChangeSearchType, setIsLocationFieldFocused = param.setIsLocationFieldFocused, onChangeSearch = param.onChangeSearch, onSearchFieldBlur = param.onSearchFieldBlur, getYourLocation = param.getYourLocation, setIsSearchFieldFocused = param.setIsSearchFieldFocused, isSearchFieldFocused = param.isSearchFieldFocused, handleSearch = param.handleSearch;
    var ref = (0,react.useContext)(HomePageContext), isKeywordChanged = ref.state.isKeywordChanged;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var MobileKeywordSearchLeftIconAlternative = hooks_useHomePageSearchBarConfig().MobileKeywordSearchLeftIconAlternative;
    var ref1 = (0,react.useState)(false), searchBarExpand = ref1[0], setSearchBarExpand = ref1[1];
    var ref2 = (0,react.useState)(""), searchText = ref2[0], setSearchText = ref2[1];
    var expandSearchBar = function() {
        return setSearchBarExpand(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
        children: searchBarExpand ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar_MobileFiltersModal, {
            setSearchBarExpand: setSearchBarExpand,
            isSearchFieldFocused: isSearchFieldFocused,
            setIsSearchFieldFocused: setIsSearchFieldFocused,
            onChangeSearch: onChangeSearch,
            onSearchFieldBlur: onSearchFieldBlur,
            onChangeLocationSearch: onChangeLocationSearch,
            onSearch: handleSearch,
            onChangeSearchType: onChangeSearchType,
            getYourLocation: getYourLocation,
            setIsLocationFieldFocused: setIsLocationFieldFocused,
            onSearchFieldFocus: onSearchFieldFocus,
            setSearchText: setSearchText,
            searchText: searchText
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(StartSearchButton, {
            onClick: function() {
                if (!isKeywordChanged) {
                    expandSearchBar();
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileKeywordSearchLeftIconAlternative, {
                    sx: {
                        color: "#2247B3",
                        path: {
                            stroke: "#2247B3"
                        },
                        width: "16px",
                        height: "16px"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StartSearchText, {
                    children: translate("homepage.search.start")
                })
            ]
        })
    });
};
/* harmony default export */ var SearchBar_MobileView = (MobileView);

;// CONCATENATED MODULE: ./components/HomePage/SearchBar/index.tsx








var SearchBar = function() {
    var ref = (0,react.useContext)(HomePageContext), buildUrl = ref.buildUrl, changeSearchType = ref.changeSearchType, changeSearch = ref.changeSearch, changeLocationSearch = ref.changeLocationSearch, loadCurrentLocationByLatLon = ref.loadCurrentLocationByLatLon, resetValidation = ref.resetValidation, changeButtonLoadingState = ref.changeButtonLoadingState;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(false), isSearchFieldFocused = ref1[0], setIsSearchFieldFocused = ref1[1];
    var ref2 = (0,react.useState)(false), isLocationFieldFocused = ref2[0], setIsLocationFieldFocused = ref2[1];
    var ref3 = (0,react.useState)(false), openSearchTypeDropdown = ref3[0], setOpenSearchTypeDropdown = ref3[1];
    var timeout = (0,useTimeout/* useTimeout */.K)();
    var onChangeSearch = function(ev) {
        return changeSearch(ev.target.value);
    };
    var onChangeLocationSearch = function(ev) {
        return timeout(function() {
            return changeLocationSearch(ev.target.value);
        });
    };
    var onSearchFieldFocus = function() {
        return timeout(function() {
            resetValidation();
            setIsSearchFieldFocused(true);
        });
    };
    var onSearchFieldBlur = function() {
        return timeout(function() {
            setIsSearchFieldFocused(false);
        });
    };
    var getYourLocation = function() {
        timeout(function() {
            navigator.geolocation.getCurrentPosition(function(position) {
                loadCurrentLocationByLatLon(position.coords.latitude.toString(), position.coords.longitude.toString());
            });
        });
    };
    (0,react.useEffect)(function() {
        if (isLocationFieldFocused) {
            resetValidation();
        }
    }, [
        isLocationFieldFocused,
        resetValidation
    ]);
    (0,react.useEffect)(function() {
        if (openSearchTypeDropdown || isSearchFieldFocused || isLocationFieldFocused) {
            window.scrollTo({
                top: 220,
                behavior: "smooth"
            });
        }
    }, [
        openSearchTypeDropdown,
        isSearchFieldFocused,
        isLocationFieldFocused
    ]);
    var handleSearch = function() {
        var url = buildUrl();
        changeButtonLoadingState(true);
        if (url) {
            router.push(url);
        } else {
            changeButtonLoadingState(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
        sx: {
            zIndex: 99,
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                lgDown: true,
                implementation: "css",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                    width: "100%",
                    position: "relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar_WebView, {
                        isClientSide: false,
                        getYourLocation: getYourLocation,
                        openSearchTypeDropdown: openSearchTypeDropdown,
                        setOpenSearchTypeDropdown: setOpenSearchTypeDropdown,
                        isSearchFieldFocused: isSearchFieldFocused,
                        isLocationFieldFocused: isLocationFieldFocused,
                        onChangeLocationSearch: onChangeLocationSearch,
                        onChangeSearch: onChangeSearch,
                        onChangeSearchType: changeSearchType,
                        onSearchFieldBlur: onSearchFieldBlur,
                        onSearchFieldFocus: onSearchFieldFocus,
                        handleSearch: handleSearch,
                        setIsSearchFieldFocused: setIsSearchFieldFocused,
                        setIsLocationFieldFocused: setIsLocationFieldFocused
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden_esm/* default */.Z, {
                lgUp: true,
                implementation: "css",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar_MobileView, {
                    isClientSide: false,
                    getYourLocation: getYourLocation,
                    openSearchTypeDropdown: openSearchTypeDropdown,
                    setOpenSearchTypeDropdown: setOpenSearchTypeDropdown,
                    isSearchFieldFocused: isSearchFieldFocused,
                    onChangeLocationSearch: onChangeLocationSearch,
                    onChangeSearch: onChangeSearch,
                    onChangeSearchType: changeSearchType,
                    onSearchFieldBlur: onSearchFieldBlur,
                    onSearchFieldFocus: onSearchFieldFocus,
                    setIsSearchFieldFocused: setIsSearchFieldFocused,
                    isLocationFieldFocused: isLocationFieldFocused,
                    handleSearch: handleSearch,
                    setIsLocationFieldFocused: setIsLocationFieldFocused
                })
            })
        ]
    });
};
/* harmony default export */ var HomePage_SearchBar = (SearchBar);

;// CONCATENATED MODULE: ./components/HomePage/KeywordsSection/styles.ts
function KeywordsSection_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function KeywordsSection_styles_templateObject() {
    var data = KeywordsSection_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 17px;\n  width: 100%;\n  "
    ]);
    KeywordsSection_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function KeywordsSection_styles_templateObject1() {
    var data = KeywordsSection_styles_taggedTemplateLiteral([
        "\n  height: 1px;\n  width: 100%;\n  background-color: #D5DEF9;\n  "
    ]);
    KeywordsSection_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function KeywordsSection_styles_templateObject2() {
    var data = KeywordsSection_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 30px;\n  @media (max-width: 768px) {\n    overflow-x: auto;\n    padding-bottom: 10px;\n    margin-bottom: -10px;\n  }\n  "
    ]);
    KeywordsSection_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function KeywordsSection_styles_templateObject3() {
    var data = KeywordsSection_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  gap: 15px;\n  grid-template-columns: repeat(4, 1fr);\n  opacity: ",
        ";\n  transition: opacity 0.2s ease-in-out;\n\n  @media (max-width: 768px) {\n    grid-template-columns: 1fr;\n  }\n"
    ]);
    KeywordsSection_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var MainContainer = (0,styled_esm/* default */.ZP)("div")(KeywordsSection_styles_templateObject());
var HorizontalLine = (0,styled_esm/* default */.ZP)("div")(KeywordsSection_styles_templateObject1());
var SelectContainer = (0,styled_esm/* default */.ZP)("div")(KeywordsSection_styles_templateObject2());
var DropDownContainer = (0,styled_esm/* default */.ZP)("div")(KeywordsSection_styles_templateObject3(), function(param) {
    var isVisible = param.isVisible;
    return isVisible ? 1 : 0;
});

;// CONCATENATED MODULE: ./components/HomePage/KeywordsComponents/styles.ts
function KeywordsComponents_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function KeywordsComponents_styles_templateObject() {
    var data = KeywordsComponents_styles_taggedTemplateLiteral([
        "\n  color: #11245A;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  font-family: Poppins;\n  white-space: nowrap;\n\n  ",
        "\n  "
    ]);
    KeywordsComponents_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var styles_Button = (0,styled_esm/* default */.ZP)("button")(KeywordsComponents_styles_templateObject(), function(param) {
    var active = param.active;
    return active ? "\n      border: 1px solid #AABDF3;\n      background: #D5DEF9;\n      border-radius: 50px;\n      padding: 6px 16px;" : "\n      border: 1px solid transparent;\n      background: transparent;\n      border-radius: 50px;\n      padding: 6px 16px;\n      ";
});
var ButtonText = (0,styled_esm/* default */.ZP)(Typography_esm/* default */.Z)({
    fontSize: "inherit"
});

;// CONCATENATED MODULE: ./components/HomePage/KeywordsComponents/CustomDropDown/styles.ts
function CustomDropDown_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CustomDropDown_styles_templateObject() {
    var data = CustomDropDown_styles_taggedTemplateLiteral([
        "\n  width: 270px;\n  position: relative;\n  cursor: ",
        ";\n  width: 100%;\n  "
    ]);
    CustomDropDown_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CustomDropDown_styles_templateObject1() {
    var data = CustomDropDown_styles_taggedTemplateLiteral([
        "\n  border: 1px solid #EAEEFC;\n  background: #F4F7FD;\n  padding: 8px 16px;\n  border-radius: 8px;\n  min-height: 40px;\n  font-size: 15px;\n  color: #112971;\n  max-width: 270px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  ",
        "\n  @media (max-width: 768px) {\n    max-width: 100%;\n    width: 100%;\n  }\n  "
    ]);
    CustomDropDown_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CustomDropDown_styles_templateObject2() {
    var data = CustomDropDown_styles_taggedTemplateLiteral([
        "\n  padding: 16px;\n  background: #FFFFFF;\n  display: flex;\n  flex-direction: column;\n  gap: 11px;\n  max-height: 300px;\n  overflow-y: auto;\n  position: absolute;\n  z-index: 9;\n  width: 100%;\n  max-width: 270px;\n  justify-content: flex-start;\n  border-radius: 0 0 8px 8px;\n  border: 1px solid #D5DEF9;\n  border-top: none;\n  @media (max-width: 768px) {\n    max-width: 100%;\n  }\n  "
    ]);
    CustomDropDown_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CustomDropDown_styles_templateObject3() {
    var data = CustomDropDown_styles_taggedTemplateLiteral([
        "\n  background: #EAEEFC;\n  border-radius: 16px;\n  height: 26px;\n  min-height: 26px;\n  width: fit-content;\n  padding: 2px 12px;\n  font-weight: 500;\n  font-size: 13px;\n  color: #1A3586;\n  cursor: pointer;\n  white-space: nowrap;\n  ",
        "\n  max-width: 100%;\n  text-decoration: none;\n  "
    ]);
    CustomDropDown_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var styles_MainContainer = (0,styled_esm/* default */.ZP)("div")(CustomDropDown_styles_templateObject(), function(param) {
    var open = param.open;
    return open ? "default" : "pointer";
});
var StyledDropDown = (0,styled_esm/* default */.ZP)("div")(CustomDropDown_styles_templateObject1(), function(param) {
    var open = param.open;
    return "border-radius: ".concat(open ? "8px 8px 0 0" : "8px", ";\n  border-bottom: 1px solid #EAEEFC;");
});
var HiddenMenu = (0,styled_esm/* default */.ZP)("div")(CustomDropDown_styles_templateObject2());
var MenuItem = (0,styled_esm/* default */.ZP)("a")(CustomDropDown_styles_templateObject3(), function(param) {
    var isHospital = param.isHospital;
    return !isHospital && "\n    overflow: hidden;\n    text-overflow: ellipsis;\n  ";
});

;// CONCATENATED MODULE: ./components/HomePage/icons/ArrowIcon.tsx
function ArrowIcon_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ArrowIcon_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ArrowIcon_defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var ArrowIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", ArrowIcon_objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        width: 9,
        height: 6,
        fill: "none"
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#11245A",
            d: "m8.5 1.273-.94-.94L4.5 3.387 1.44.333l-.94.94 4 4 4-4Z"
        })
    }));
};
/* harmony default export */ var icons_ArrowIcon = (ArrowIcon);

;// CONCATENATED MODULE: ./components/HomePage/KeywordsComponents/CustomDropDown/index.tsx
function CustomDropDown_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function CustomDropDown_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function CustomDropDown_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function CustomDropDown_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function CustomDropDown_slicedToArray(arr, i) {
    return CustomDropDown_arrayWithHoles(arr) || CustomDropDown_iterableToArrayLimit(arr, i) || CustomDropDown_unsupportedIterableToArray(arr, i) || CustomDropDown_nonIterableRest();
}
function CustomDropDown_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return CustomDropDown_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return CustomDropDown_arrayLikeToArray(o, minLen);
}








var CustomDropDown = function(param) {
    var name = param.name, specialties = param.specialties, city = param.city, typeOfProfile = param.typeOfProfile;
    var ref = CustomDropDown_slicedToArray(react.useState(false), 2), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useContext)(AppData/* AppDataContext */.R), locale = ref1.locale, language = ref1.language;
    var menuRef = react.useRef(null);
    var domainName = (0,getDomainName/* default */.Z)();
    var originWithLang = (0,url/* purifyTenantDomain */.ng)(domainName, locale);
    var toggleMenu = function() {
        setOpen(function(prev) {
            return !prev;
        });
    };
    var toggleClose = function() {
        setOpen(false);
    };
    (0,useClickOutside/* default */.Z)(menuRef, toggleClose);
    if (!specialties.length) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_MainContainer, {
        open: open,
        ref: menuRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDropDown, {
                onClick: toggleMenu,
                open: open,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            textAlign: "start"
                        },
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ArrowIcon, {
                        style: {
                            transform: open ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 0.3s"
                        }
                    })
                ]
            }),
            open && /*#__PURE__*/ (0,jsx_runtime.jsx)(HiddenMenu, {
                children: specialties.map(function(specialty) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                        href: "".concat(originWithLang, "/find/").concat(specialty.slug[0], "/").concat(city, "/").concat(typeOfProfile ? typeOfProfile : "specialists"),
                        children: specialty.name[language]
                    }, specialty.id);
                })
            })
        ]
    });
};
/* harmony default export */ var KeywordsComponents_CustomDropDown = (CustomDropDown);

;// CONCATENATED MODULE: ./components/HomePage/KeywordsSection/index.tsx






var KeywordSection = function(param) {
    var keywordsForView = param.keywordsForView;
    var ref, ref1;
    var ref2 = (0,react.useState)((ref = keywordsForView[0]) === null || ref === void 0 ? void 0 : ref.slug), selectedCity = ref2[0], setSelectedCity = ref2[1];
    var language = (0,react.useContext)(AppData/* AppDataContext */.R).language;
    var ref3 = (0,react.useState)(true), isVisible = ref3[0], setIsVisible = ref3[1];
    var onSelectCity = function(e) {
        var newCity = e.currentTarget.value;
        if (newCity === selectedCity) {
            return;
        }
        setIsVisible(false);
        setTimeout(function() {
            setSelectedCity(newCity);
            setIsVisible(true);
        }, 300);
    };
    var filteredByCity = (0,react.useMemo)(function() {
        if (!selectedCity) {
            return keywordsForView === null || keywordsForView === void 0 ? void 0 : keywordsForView[0];
        }
        return keywordsForView.find(function(keyword) {
            return keyword.slug === selectedCity;
        });
    }, [
        selectedCity,
        keywordsForView
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectContainer, {
                children: keywordsForView === null || keywordsForView === void 0 ? void 0 : (ref1 = keywordsForView.map) === null || ref1 === void 0 ? void 0 : ref1.call(keywordsForView, function(keyword) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Button, {
                        active: selectedCity === keyword.slug,
                        onClick: onSelectCity,
                        value: keyword.slug,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText, {
                            variant: "h3",
                            children: keyword.name[language]
                        })
                    }, keyword.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalLine, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownContainer, {
                isVisible: isVisible,
                children: filteredByCity === null || filteredByCity === void 0 ? void 0 : filteredByCity.specialties.map(function(specialty) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordsComponents_CustomDropDown, {
                        name: specialty.name[language],
                        specialties: specialty.treatments,
                        city: filteredByCity.slug
                    }, specialty.id);
                })
            })
        ]
    });
};
/* harmony default export */ var KeywordsSection = (KeywordSection);

;// CONCATENATED MODULE: ./components/HomePage/LocationsSection/styles.ts
function LocationsSection_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function LocationsSection_styles_templateObject() {
    var data = LocationsSection_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 17px;\n  width: 100%;\n  "
    ]);
    LocationsSection_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LocationsSection_styles_templateObject1() {
    var data = LocationsSection_styles_taggedTemplateLiteral([
        "\n  height: 1px;\n  width: 100%;\n  background-color: #D5DEF9;\n  "
    ]);
    LocationsSection_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LocationsSection_styles_templateObject2() {
    var data = LocationsSection_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 42px;\n  ",
        " {\n    gap: 8px;\n    justify-content: space-between;\n  }\n  "
    ]);
    LocationsSection_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function LocationsSection_styles_templateObject3() {
    var data = LocationsSection_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  gap: 15px;\n  grid-template-columns: repeat(4, 1fr);\n  opacity: ",
        ";\n  transition: opacity 0.2s ease-in-out;\n  \n  ",
        "\n\n  @media (max-width: 768px) {\n    grid-template-columns: 1fr;\n  }\n"
    ]);
    LocationsSection_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function LocationsSection_styles_templateObject4() {
    var data = LocationsSection_styles_taggedTemplateLiteral([
        "\n  font-size: 15px;\n  color: #11245A;\n  text-decoration: underline;\n  "
    ]);
    LocationsSection_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = LocationsSection_styles_taggedTemplateLiteral([
        "\n  display: grid;\n  gap: 15px;\n  grid-template-columns: repeat(4, 1fr);\n\n  @media (max-width: 768px) {\n    grid-template-columns: 1fr;\n  }\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var LocationsSection_styles_MainContainer = (0,styled_esm/* default */.ZP)("div")(LocationsSection_styles_templateObject());
var styles_HorizontalLine = (0,styled_esm/* default */.ZP)("div")(LocationsSection_styles_templateObject1());
var styles_SelectContainer = (0,styled_esm/* default */.ZP)("div")(LocationsSection_styles_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.down("sm");
});
var styles_DropDownContainer = (0,styled_esm/* default */.ZP)("div")(LocationsSection_styles_templateObject3(), function(param) {
    var isVisible = param.isVisible;
    return isVisible ? 1 : 0;
}, function(param) {
    var isHospital = param.isHospital;
    return isHospital && "\n  @media (max-width: 970px) {\n      grid-template-columns: repeat(3, 1fr);\n  }\n  ";
});
var Link = (0,styled_esm/* default */.ZP)("a")(LocationsSection_styles_templateObject4());
var CustomMenuItems = (0,styled_esm/* default */.ZP)("div")(_templateObject5());

;// CONCATENATED MODULE: ./constants/homePage.ts
var LOCATION_BUTTONS = {
    specialist: "specialists",
    clinic: "practices",
    hospital: "hospitals"
};

;// CONCATENATED MODULE: ./components/HomePage/LocationsSection/index.tsx











var LocationsSection = function(param) {
    var locationsForView = param.locationsForView, hospitalsForView = param.hospitalsForView;
    var ref = (0,react.useContext)(AppData/* AppDataContext */.R), language = ref.language, locale = ref.locale;
    var ref1 = (0,react.useState)(LOCATION_BUTTONS.specialist), selectedType = ref1[0], setSelectedType = ref1[1];
    var ref2 = (0,react.useState)(true), isVisible = ref2[0], setIsVisible = ref2[1];
    var domainName = (0,getDomainName/* default */.Z)();
    var translate = (0,useTranslateMessage/* default */.Z)();
    var onSelectType = function(e) {
        var newType = e.currentTarget.value;
        if (newType === selectedType) {
            return;
        }
        setIsVisible(false);
        setTimeout(function() {
            setSelectedType(newType);
            setIsVisible(true);
        }, 300);
    };
    var isSelectedHospitals = (0,react.useMemo)(function() {
        return selectedType === LOCATION_BUTTONS.hospital;
    }, [
        selectedType
    ]);
    var originWithLang = (0,url/* purifyTenantDomain */.ng)(domainName, locale);
    var locations = Array.isArray(locationsForView) ? locationsForView : [];
    var hospitals = Array.isArray(hospitalsForView) ? hospitalsForView : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LocationsSection_styles_MainContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_SelectContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Button, {
                        active: selectedType === LOCATION_BUTTONS.specialist,
                        onClick: onSelectType,
                        value: LOCATION_BUTTONS.specialist,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText, {
                            variant: "h3",
                            children: translate("homepage.location.specialist")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Button, {
                        active: selectedType === LOCATION_BUTTONS.clinic,
                        onClick: onSelectType,
                        value: LOCATION_BUTTONS.clinic,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText, {
                            variant: "h3",
                            children: translate("homepage.location.clinic")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Button, {
                        active: selectedType === LOCATION_BUTTONS.hospital,
                        onClick: onSelectType,
                        value: LOCATION_BUTTONS.hospital,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonText, {
                            variant: "h3",
                            children: translate("homepage.location.hospital")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_HorizontalLine, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_DropDownContainer, {
                isVisible: isVisible,
                isHospital: isSelectedHospitals,
                children: isSelectedHospitals ? hospitals.map(function(hospital) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomMenuItems, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuItem, {
                            isHospital: true,
                            href: "".concat(originWithLang, "/find/all/").concat(hospital.slug, "/hospitals"),
                            children: [
                                "Hospitals in ",
                                hospital.name[language]
                            ]
                        })
                    }, hospital.id);
                }) : locations.map(function(location) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordsComponents_CustomDropDown, {
                        name: location.name[language],
                        specialties: location.specialties,
                        city: location.slug,
                        typeOfProfile: selectedType
                    }, location.id);
                })
            })
        ]
    });
};
/* harmony default export */ var HomePage_LocationsSection = (LocationsSection);

;// CONCATENATED MODULE: ./hooks/useHomePageHrefLang.ts


var useHreflangsForLocales = [
    {
        hreflang: "en-gb",
        locale: "uk"
    },
    {
        hreflang: "de-at",
        locale: "de-at"
    },
    {
        hreflang: "en-ae",
        locale: "en-ae"
    },
    {
        hreflang: "de-de",
        locale: "de/"
    },
    {
        hreflang: "en-au",
        locale: "au"
    },
    {
        hreflang: "en-ie",
        locale: "ie"
    }
];
var useHomePageHrefLang = function() {
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    var matchedLocale = useHreflangsForLocales.find(function(item) {
        return item.locale === locale;
    });
    if (matchedLocale) {
        return useHreflangsForLocales.map(function(useHreflangsForLocale) {
            return {
                rel: "alternate",
                href: "https://www.doctify.com/".concat(useHreflangsForLocale.locale),
                hreflang: useHreflangsForLocale.hreflang
            };
        });
    }
    return undefined;
};

;// CONCATENATED MODULE: ./hooks/useHomePageMeta.ts







function useHomePageMeta() {
    var ref = (0,react.useContext)(AppData/* AppDataContext */.R), language = ref.language, locale = ref.locale;
    var translate = (0,useTranslateMessage/* default */.Z)();
    var host = (0,getConfigVariable/* default */.Z)("HOST");
    var hrefLangs = useHomePageHrefLang();
    return (0,react.useMemo)(function() {
        var title = translate("home-page.meta.title");
        var description = translate("home-page.meta.description");
        var canonicalUrl = "".concat(host, "/").concat(locale).concat(locale === global/* TENANTS.DE */.rk.DE ? "/" : "");
        var preloadImage = (0,imageLoaders/* preloadImageLoader */.z6)({
            src: "hermes-static/logo.svg",
            host: host
        });
        return {
            title: title,
            description: description,
            canonicalUrl: canonicalUrl,
            language: language,
            preloadImage: preloadImage,
            hrefLangs: hrefLangs
        };
    }, [
        host,
        hrefLangs,
        language,
        locale,
        translate
    ]);
};

;// CONCATENATED MODULE: ./utils/schema/home.ts
function getHomeSchema(param) {
    var meta = param.meta, locale = param.locale;
    var organizationSchema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Doctify",
        description: meta.description,
        url: "https://www.doctify.com/".concat(locale),
        logo: meta.preloadImage,
        sameAs: [
            "https://twitter.com/doctifyuk",
            "https://www.facebook.com/doctifyuk",
            "https://www.linkedin.com/company/doctify",
            "https://www.youtube.com/@doctify"
        ]
    };
    return JSON.stringify([
        organizationSchema
    ]);
};

;// CONCATENATED MODULE: ./hooks/useHomePageSchema.ts




function useHomePageSchema() {
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    var homePageMeta = useHomePageMeta();
    return (0,react.useMemo)(function() {
        return getHomeSchema({
            meta: homePageMeta,
            locale: locale
        });
    }, [
        homePageMeta,
        locale
    ]);
};

;// CONCATENATED MODULE: ./components/HomePage/constants.ts
var ROLL_ANIMATION_WORDS = [
    "homepage.header.roll.doctor",
    "homepage.header.roll.hospital",
    "homepage.header.roll.surgeon",
    "homepage.header.roll.dentist",
    "homepage.header.roll.cardiologist",
    "homepage.header.roll.dermatologist",
    "homepage.header.roll.paediatrician",
    "homepage.header.roll.urologist",
    "homepage.header.roll.obstetrician",
    "homepage.header.roll.physiotherapist",
    "homepage.header.roll.clinic",
    "homepage.header.roll.care",
    "homepage.header.roll.pharmacy"
];
var ROLL_ANIMATION_WORDS_DE = [
    "homepage.header.roll.doctor",
    "homepage.header.roll.hospital",
    "homepage.header.roll.surgeon",
    "homepage.header.roll.dentist",
    "homepage.header.roll.cardiologist",
    "homepage.header.roll.dermatologist",
    "homepage.header.roll.paediatrician",
    "homepage.header.roll.orthopaedic",
    "homepage.header.roll.urologist",
    "homepage.header.roll.obstetrician",
    "homepage.header.roll.clinic",
    "homepage.header.roll.care",
    "homepage.header.roll.pharmacy"
];

;// CONCATENATED MODULE: ./components/HomePage/index.tsx
function components_HomePage_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function components_HomePage_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            components_HomePage_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
























var HomePage = function(param1) {
    var defaultLocation = param1.defaultLocation, locationsAutocomplete = param1.locationsAutocomplete, specialties = param1.specialties, conditionsAndProcedures = param1.conditionsAndProcedures, reviews = param1.reviews, endorsements = param1.endorsements, popularSpecialties = param1.popularSpecialties, videoReviews = param1.videoReviews, locationsForView = param1.locationsForView, hospitalsForView = param1.hospitalsForView, keywordsForView = param1.keywordsForView, customSpecialtiesSection = param1.customSpecialtiesSection, practicesAutocomplete = param1.practicesAutocomplete, specialistsAutocomplete = param1.specialistsAutocomplete;
    var locale = (0,react.useContext)(AppData/* AppDataContext */.R).locale;
    var pageMeta = useHomePageMeta();
    var pageSchema = useHomePageSchema();
    var translate = (0,useTranslateMessage/* default */.Z)();
    var theme = (0,useTheme_esm/* default */.Z)();
    var isGerman = (0,react.useMemo)(function() {
        return locale === global/* TENANTS.DE */.rk.DE || locale === global/* TENANTS.AT */.rk.AT;
    }, [
        locale
    ]);
    var rollItems = (0,react.useMemo)(function() {
        return isGerman ? ROLL_ANIMATION_WORDS_DE : ROLL_ANIMATION_WORDS;
    }, [
        isGerman
    ]);
    var insightItems = (0,react.useMemo)(function() {
        return [
            {
                title: translate("homepage.insight.pledge.title"),
                subtitle: translate("homepage.insight.pledge.subtitle")
            },
            {
                title: translate("homepage.insight.doctors.title"),
                subtitle: translate("homepage.insight.doctors.subtitle")
            },
            {
                title: translate("homepage.insight.mean.title"),
                subtitle: translate("homepage.insight.mean.subtitle")
            },
            {
                title: translate("homepage.insight.secured.title"),
                subtitle: translate("homepage.insight.secured.subtitle")
            }
        ];
    }, [
        translate
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMeta/* default */.Z, components_HomePage_objectSpread({}, pageMeta, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: pageSchema
                    }
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageProvider, {
                conditionsAndProcedures: conditionsAndProcedures,
                specialties: specialties,
                defaultLocation: defaultLocation,
                locationsAutocomplete: locationsAutocomplete,
                practicesAutocomplete: practicesAutocomplete,
                specialistsAutocomplete: specialistsAutocomplete,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomePageLayout, {
                    sx: {
                        paddingBottom: {
                            xs: "60px",
                            md: "100px"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageLayout, {
                            sx: {
                                padding: 0,
                                background: "linear-gradient(135deg, #89acfe 20%, #eaeffc 100%)",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "cover"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroSection, {
                                sx: components_HomePage_defineProperty({
                                    paddingTop: {
                                        xs: "50px",
                                        md: "120px"
                                    },
                                    gap: "132px",
                                    paddingBottom: "46px",
                                    paddingLeft: "16px",
                                    paddingRight: "16px"
                                }, theme.breakpoints.down("md"), {
                                    gap: "88px"
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                                        sx: components_HomePage_defineProperty({
                                            display: "flex",
                                            flexDirection: "column",
                                            width: "100%",
                                            gap: "60px"
                                        }, theme.breakpoints.down("md"), {
                                            gap: isGerman ? "32px" : "16px"
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                                                sx: components_HomePage_defineProperty({
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "16px",
                                                    alignItems: "start",
                                                    textAlign: "start"
                                                }, theme.breakpoints.down("md"), {
                                                    textAlign: "center",
                                                    alignItems: "center"
                                                }),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(H2Title, {
                                                        sx: components_HomePage_defineProperty({}, theme.breakpoints.down("md"), {
                                                            fontSize: "18px"
                                                        }),
                                                        variant: "body1",
                                                        children: translate("homepage.yourhealth.title")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(H1Title, {
                                                        sx: components_HomePage_defineProperty({}, theme.breakpoints.down("md"), {
                                                            fontSize: "36px"
                                                        }),
                                                        variant: "h1",
                                                        children: [
                                                            translate("homepage.search.title") + " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_RollAnimation, {
                                                                items: rollItems
                                                            })
                                                        ]
                                                    }),
                                                    customSpecialtiesSection ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_SpecialtiesSection, {
                                                        specialties: popularSpecialties,
                                                        variant: "variant2"
                                                    }) : null
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_SearchBar, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                                        sx: {
                                            marginBottom: "32px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(H3Title, {
                                                sx: components_HomePage_defineProperty({
                                                    marginBottom: "12px"
                                                }, theme.breakpoints.down("md"), {
                                                    fontSize: "24px"
                                                }),
                                                variant: "h2",
                                                children: translate("homepage.search.review.title")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyLarge, {
                                                variant: "h3",
                                                sx: {
                                                    fontWeight: 400
                                                },
                                                children: translate("homepage.search.review.subtitle")
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                            sx: {
                                marginTop: "-90px",
                                marginBottom: "24px",
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_ReviewsSection, {
                                reviews: reviews
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_PeerEndorsementsSection, {
                            endorsements: endorsements
                        }),
                        customSpecialtiesSection ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_SpecialtiesSection, {
                            specialties: popularSpecialties
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomePageLayout, {
                            sx: {
                                background: "linear-gradient(180deg, #eaeffc 0%, #fff 100%)",
                                paddingBottom: "68px",
                                paddingTop: isGerman ? "62px" : "100px"
                            },
                            children: [
                                !isGerman && /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_TrustSection, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondarySection, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                                        sx: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "12px",
                                            alignItems: "start"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(H3Title, {
                                                variant: "h2",
                                                style: {
                                                    background: "linear-gradient(90deg, #051851 0%, #2B59E0 100%)",
                                                    WebkitBackgroundClip: "text",
                                                    WebkitTextFillColor: "transparent"
                                                },
                                                sx: {
                                                    marginTop: {
                                                        xs: "24px",
                                                        md: "108px"
                                                    }
                                                },
                                                children: translate("homepage.promoting.title")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                                                sx: {
                                                    display: "flex",
                                                    gap: {
                                                        xs: "0",
                                                        sm: "48px"
                                                    },
                                                    marginTop: {
                                                        xs: "13px",
                                                        md: "24px"
                                                    },
                                                    flexWrap: {
                                                        xs: "wrap",
                                                        lg: "nowrap"
                                                    },
                                                    justifyContent: {
                                                        xs: "center",
                                                        md: "flex-start"
                                                    },
                                                    marginBottom: {
                                                        xs: "0px",
                                                        sm: "48px",
                                                        md: "0px"
                                                    }
                                                },
                                                children: insightItems.map(function(param, index) {
                                                    var title = param.title, subtitle = param.subtitle;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_InsightItem, {
                                                        title: title,
                                                        subtitle: subtitle
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                                    sx: {
                                        marginTop: {
                                            xs: "-48px",
                                            md: "14px"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                                        sx: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: {
                                                md: "32px",
                                                xs: "24px"
                                            },
                                            alignItems: "start"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(H4Title, {
                                                variant: "h3",
                                                children: translate("homepage.hear.title")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_VideoReviews, {
                                                videoReviews: videoReviews
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box_esm/* default */.Z, {
                            sx: {
                                marginBottom: {
                                    md: "52px",
                                    xs: "4px"
                                },
                                width: "100%",
                                height: "100%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_ProvidersSection, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                            sx: components_HomePage_defineProperty({
                                marginBottom: "12px"
                            }, theme.breakpoints.down("md"), {
                                marginTop: "24px"
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "24px",
                                    alignItems: "start"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(H4Title, {
                                        variant: "h2",
                                        sx: {
                                            textAlign: "start"
                                        },
                                        children: translate("homepage.find.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_LocationsSection, {
                                        locationsForView: locationsForView,
                                        hospitalsForView: hospitalsForView
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
                            sx: {
                                marginTop: {
                                    xs: "12px",
                                    md: "0"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box_esm/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "24px",
                                    alignItems: "start"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(H4Title, {
                                        sx: {
                                            textAlign: "start"
                                        },
                                        variant: "h2",
                                        children: translate("homepage.procedures.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(KeywordsSection, {
                                        keywordsForView: keywordsForView
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_HomePage = (HomePage);

;// CONCATENATED MODULE: ./pages/index.tsx


var HomePageWitError = (0,withError/* default */.Z)(components_HomePage);
var __N_SSG = true;
/* harmony default export */ var pages = (HomePageWitError);


/***/ }),

/***/ 8477:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var highlightText = function(text, value) {
    if (!value) {
        return text;
    }
    var regString = value.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
    var regExp = new RegExp(regString, "ig");
    return text.replace(regExp, function(str) {
        return '<b class="text-highlight">'.concat(str, "</b>");
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (highlightText);


/***/ }),

/***/ 32013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ux": function() { return /* binding */ doctifyCDNLoader; },
/* harmony export */   "xy": function() { return /* binding */ defaultLoader; },
/* harmony export */   "z6": function() { return /* binding */ preloadImageLoader; }
/* harmony export */ });
var defaultLoader = function(param) {
    var src = param.src, width = param.width;
    return "/_next/image?url=".concat(src, "&w=").concat(width, "&q=75");
};
var preloadImageLoader = function(param) {
    var src = param.src, host = param.host;
    return "\n  ".concat(host, "/_next/image?url=").concat(src, "&w=384&q=75");
};
var doctifyCDNLoader = function(param) {
    var src = param.src, width = param.width;
    return "https://cdn.doctify.com/_next/image?url=".concat(src, "&w=").concat(width, "&q=75");
};


/***/ }),

/***/ 28253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O8": function() { return /* binding */ parseParamsFromPath; },
/* harmony export */   "aR": function() { return /* binding */ transformToQuery; },
/* harmony export */   "p9": function() { return /* binding */ parseQueryFromString; }
/* harmony export */ });
var transformToQuery = function(data) {
    var params = new URLSearchParams();
    Object.keys(data).forEach(function(key) {
        var value = data[key];
        if (value && !Array.isArray(value) || value && Array.isArray(value) && value.length) {
            if (Array.isArray(value)) {
                return value.forEach(function(item) {
                    if (item) {
                        params.append("".concat(key, "[]"), String(item));
                    }
                });
            }
            if (key === "keyword") {
                return params.append(key, '"'.concat(String(value), '"'));
            }
            return params.append(key, String(value));
        }
        return null;
    });
    return params.toString();
};
var parseQueryFromString = function(url) {
    var withProtocol = (url === null || url === void 0 ? void 0 : url.includes("http://")) || (url === null || url === void 0 ? void 0 : url.includes("https://"));
    var parsedUrl = new URL(url !== null && url !== void 0 ? url : "", !withProtocol ? "http://test.com" : undefined);
    return Object.fromEntries(parsedUrl.searchParams);
};
var parseParamsFromPath = function(path) {
    return path.split("/").slice(1);
};


/***/ }),

/***/ 5892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A5": function() { return /* binding */ compareStrings; },
/* harmony export */   "Ig": function() { return /* binding */ capitalise; },
/* harmony export */   "aS": function() { return /* binding */ truncateString; },
/* harmony export */   "eV": function() { return /* binding */ camelCase; },
/* harmony export */   "i": function() { return /* binding */ removeSpecificSymbols; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toArray(arr) {
    return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var capitalise = function(value) {
    if (!value) {
        return "";
    }
    var ref = _toArray(value.split("")), firstLetter = ref[0], restLitters = ref.slice(1);
    return [
        firstLetter.toUpperCase()
    ].concat(_toConsumableArray(restLitters)).join("");
};
/**
 * Truncates the given string to a maximum number of words or length, if necessary.
 *
 * @param {string} str - The string to truncate.
 * @param {number} [maxAmountWords=15] - The maximum number of words that can be returned. Default is 15.
 * @param {number} [maxStringLength=100] - The maximum length of the string that can be returned. Default is 100.
 * @param {string} [suffix='...'] - The string to append to the end of the truncated string. Default is '...'.
 *
 * @returns {string} - The truncated string.
 */ var truncateString = function(str) {
    var maxAmountWords = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 15, maxStringLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100, suffix = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "...";
    if (str.length <= maxStringLength && str.split(" ").length <= maxAmountWords) {
        return str;
    }
    return str.split(" ").reduce(function(prev, curr, index) {
        return prev.length + curr.length <= maxStringLength - suffix.length && index <= maxAmountWords ? "".concat(prev, " ").concat(curr) : prev;
    }, "") + suffix;
};
var compareStrings = function(sample) {
    for(var _len = arguments.length, strings = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        strings[_key - 1] = arguments[_key];
    }
    return strings.every(function(value) {
        return value.toLowerCase() === sample.toLowerCase();
    });
};
var camelCase = function(str) {
    return str === null || str === void 0 ? void 0 : str.replace(/[^a-zA-Z0-9]+(.)/g, function(_, chr) {
        return chr.toUpperCase();
    }).replace(/^[^a-zA-Z0-9]+/, "").replace(/[^a-zA-Z0-9]/g, "").replace(/^./, function(match) {
        return match.toLowerCase();
    });
};
var removeSpecificSymbols = function(str) {
    return str.replace(/[^\S\r\n\x21-\x7E\u00A0-\uFFFF ]/g, "");
};


/***/ }),

/***/ 79521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EC": function() { return /* binding */ transformAutocompleteKeyword; },
/* harmony export */   "ae": function() { return /* binding */ transformAutocompleteSpecialist; },
/* harmony export */   "bS": function() { return /* binding */ alternativeTransformAutocompletePractices; },
/* harmony export */   "dP": function() { return /* binding */ transformAutocompletePractices; },
/* harmony export */   "lT": function() { return /* binding */ transformSearchType; }
/* harmony export */ });
/* harmony import */ var _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42108);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

var transformAutocompleteSpecialist = function(profile, language) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    return {
        name: "".concat(profile === null || profile === void 0 ? void 0 : (ref = profile.firstName) === null || ref === void 0 ? void 0 : ref[language], " ").concat((ref1 = profile.lastName) === null || ref1 === void 0 ? void 0 : ref1[language]).trim() || "",
        id: profile === null || profile === void 0 ? void 0 : profile.id,
        slug: profile === null || profile === void 0 ? void 0 : profile.slug,
        logo: profile === null || profile === void 0 ? void 0 : (ref2 = profile.images) === null || ref2 === void 0 ? void 0 : ref2.logo,
        subtitle: (ref4 = profile === null || profile === void 0 ? void 0 : (ref3 = profile.keywords) === null || ref3 === void 0 ? void 0 : ref3.find(function(f) {
            return f.keywordType === "specialty";
        })) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.name) === null || ref5 === void 0 ? void 0 : ref5[language]
    };
};
var transformAutocompletePractices = function(profile, language) {
    var ref, ref6;
    return {
        name: (profile === null || profile === void 0 ? void 0 : (ref = profile.name) === null || ref === void 0 ? void 0 : ref[language]) || "",
        id: profile === null || profile === void 0 ? void 0 : profile.id,
        slug: profile === null || profile === void 0 ? void 0 : profile.slug,
        logo: profile === null || profile === void 0 ? void 0 : (ref6 = profile.images) === null || ref6 === void 0 ? void 0 : ref6.logo,
        subtitle: ""
    };
};
var alternativeTransformAutocompletePractices = function(profile, language) {
    var ref, ref7;
    return {
        name: (profile === null || profile === void 0 ? void 0 : (ref = profile.name) === null || ref === void 0 ? void 0 : ref[language]) || "",
        id: profile === null || profile === void 0 ? void 0 : profile.id,
        slug: profile === null || profile === void 0 ? void 0 : profile.slug,
        logo: profile === null || profile === void 0 ? void 0 : (ref7 = profile.images) === null || ref7 === void 0 ? void 0 : ref7.cover,
        subtitle: ""
    };
};
var transformAutocompleteKeyword = function(keyword, language) {
    var ref;
    return {
        name: (keyword === null || keyword === void 0 ? void 0 : (ref = keyword.name) === null || ref === void 0 ? void 0 : ref[language]) || "",
        id: keyword === null || keyword === void 0 ? void 0 : keyword.id,
        slug: keyword === null || keyword === void 0 ? void 0 : keyword.slug[0],
        logo: keyword === null || keyword === void 0 ? void 0 : keyword.iconUri,
        subtitle: "",
        type: keyword.type
    };
};
var transformSearchType = function(type) {
    var _obj;
    var obj = (_obj = {}, _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.specialists */ .ai.specialists, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.specialists */ .g7.specialists), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.practices */ .ai.practices, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.practices */ .g7.practices), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.dentist */ .ai.dentist, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.dentist */ .g7.dentist), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.healthAndSocialCare */ .ai.healthAndSocialCare, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.healthAndSocialCare */ .g7.healthAndSocialCare), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.hospital */ .ai.hospital, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.hospital */ .g7.hospital), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.pharmacy */ .ai.pharmacy, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.pharmacy */ .g7.pharmacy), _defineProperty(_obj, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .SearchTypes.careHome */ .ai.careHome, _providers_SearchProfilesPage_types__WEBPACK_IMPORTED_MODULE_0__/* .AlternativeNavigationSearchTypes.careHome */ .g7.careHome), _obj);
    return obj[type] || type;
};


/***/ }),

/***/ 89097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ Check; }
/* harmony export */ });
var Check = {};




/***/ }),

/***/ 75540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ MyLocation; }
/* harmony export */ });
var MyLocation = {};




/***/ }),

/***/ 20926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ Search; }
/* harmony export */ });
var Search = {};




/***/ }),

/***/ 725:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lr": function() { return /* binding */ Carousel; },
  "qs": function() { return /* binding */ CarouselSlide; }
});

// UNUSED EXPORTS: AutoScroll, CarouselNavButton

// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/react-intersection-observer/index.esm.js
var index_esm = __webpack_require__(92320);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@splidejs/react-splide/dist/js/react-splide.esm.esm.js
var react_splide_esm_esm = __webpack_require__(29465);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Box/Box.esm.js + 1 modules
var Box_esm = __webpack_require__(4595);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Button/Button.esm.js + 2 modules
var Button_esm = __webpack_require__(77428);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/components/Carousel/styles.esm.js




(0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)({
    position: 'relative'
});
const NavigationContainer = (0,styled_esm/* default */.ZP)(Box_esm/* default */.Z, {
    shouldForwardProp: (prop) => prop !== 'bottom' && prop !== 'laterally' && prop !== 'inside' && prop !== 'navigationPosition'
})(({ navigationPosition, theme }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (navigationPosition === 'bottom' && {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px'
})), { zIndex: 3 }), (navigationPosition === 'laterally' && {
    button: {
        position: 'absolute',
        zIndex: 500,
        top: 'calc(50% - 20px)',
        '&:first-of-type': {
            left: '-25px'
        },
        '&:last-of-type': {
            right: '-25px'
        }
    }
})), (navigationPosition === 'inside' && {
    position: 'absolute',
    display: 'flex',
    marginTop: '40px',
    width: '30%',
    justifyContent: 'center',
    gap: '10px',
    bottom: '50px',
    zIndex: 1
})), { [theme.breakpoints.down('sm')]: Object.assign({}, (navigationPosition === 'laterally' && {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        justifyContent: 'center',
        gap: '25px',
        marginTop: '35px',
        button: {
            left: '0 !important',
            right: '0 !important',
            position: 'relative'
        }
    })) })));
const NavButton = (0,styled_esm/* default */.ZP)(Button_esm/* default */.Z)(({ theme }) => ({
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    padding: 0,
    minWidth: 'auto',
    border: `0.2px solid ${theme.palette.common.white}`,
    backgroundColor: theme.palette.background.paper,
    transition: '0.2s',
    '&.Mui-disabled': {
        pointerEvents: 'auto !important',
        'svg > path': {
            fill: '#D9D9D9'
        },
        '&:hover': {
            backgroundColor: theme.palette.background.paper,
            'svg > path': {
                fill: '#D9D9D9'
            }
        }
    },
    '&:hover': {
        backgroundColor: theme.palette.primary.main,
        'svg > path': {
            fill: theme.palette.background.default
        }
    },
    [theme.breakpoints.down('sm')]: {
        width: '40px',
        height: '40px'
    }
}));
(0,styled_esm/* default */.ZP)(Box_esm/* default */.Z)({
    display: 'grid',
    gap: '45px',
    width: 'inherit',
    minHeight: 'max-content',
    '&>div': {
        width: 'inherit'
    }
});



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/_virtual/_tslib.esm.js
var _tslib_esm = __webpack_require__(10395);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/theme/index.esm.js + 26 modules
var theme_index_esm = __webpack_require__(1189);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/SvgIcon/SvgIcon.esm.js + 1 modules
var SvgIcon_esm = __webpack_require__(46224);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/icons/CarouselArrow/index.esm.js





const CarouselArrow = (_a) => {
    var { color, rotation } = _a, props = (0,_tslib_esm/* __rest */._)(_a, ["color", "rotation"]);
    return (react.createElement(SvgIcon_esm/* default */.Z, Object.assign({ viewBox: "0 0 17 18" }, props, { sx: {
            transform: `rotate(${rotation}deg)`
        } }),
        react.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.59233 2.40768L7.59 2.41L13.17 8L1 8C0.447716 8 9.24263e-08 8.44772 9.90123e-08 9C1.05598e-07 9.55229 0.447716 10 1 10L13.17 10L7.59 15.59L7.59186 15.5919C7.39739 15.7737 7.27585 16.0326 7.27585 16.3198C7.27585 16.8701 7.72195 17.3162 8.27224 17.3162C8.56187 17.3162 8.82264 17.1926 9.00469 16.9953L17 9L9.03428 1.03429C8.85171 0.827455 8.5846 0.697006 8.28703 0.697006C7.73673 0.697006 7.29063 1.14311 7.29063 1.6934C7.29063 1.97352 7.40623 2.22665 7.59233 2.40768Z", fill: color || theme_index_esm/* theme.palette.primary.main */.rS.palette.primary.main })));
};



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Grid/Grid.esm.js + 2 modules
var Grid_esm = __webpack_require__(54597);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/components/Carousel/index.esm.js











const CarouselSlide = (0,styled_esm/* default */.ZP)(react_splide_esm_esm/* SplideSlide */.jw)({});
const CarouselNavButton = ({ onClick, type, refObj, sx = {} }) => (react.createElement(NavButton, { ref: refObj, sx: Object.assign({ backgroundColor: theme_index_esm/* theme.palette.background.default */.rS.palette.background["default"] }, sx), onClick: onClick, "aria-label": `carousel-navigation-${type}` },
    type === 'next' && react.createElement(CarouselArrow, null),
    type === 'prev' && react.createElement(CarouselArrow, { rotation: 180 })));
const Carousel = ({ children, slidesPerView = 3, navigation = false, navigationPosition = 'laterally', navigationElement = null, pagination = false, isRtl = false, spaceBetween, slidesPerGroup = 1, updateOnMove = false, loop = false, vertical = false, currentSlide = 0, verticalHeight, trimSpace = false, centerFocus = false, slidePadding = 0, wheel = false, lazyLoad = false, sx = {}, breakpoints = {}, disableDrag = false, options = {}, navButtonStyles = {}, onRefReady, extensions = {} }) => {
    const splide = (0,react.useRef)(null);
    const prevRef = (0,react.useRef)(null);
    const nextRef = (0,react.useRef)(null);
    const [perPage, setPerPage] = react.useState(slidesPerView);
    const { ref, inView } = (0,index_esm/* useInView */.YD)({
        triggerOnce: true,
        skip: !lazyLoad,
        trackVisibility: lazyLoad,
        delay: 500,
        threshold: 0.25
    });
    (0,react.useEffect)(() => {
        var _a, _b, _c;
        const splideInstance = (_a = splide === null || splide === void 0 ? void 0 : splide.current) === null || _a === void 0 ? void 0 : _a.splide;
        if (!splideInstance) {
            return;
        }
        if (inView && lazyLoad) {
            splideInstance.options = Object.assign(Object.assign({}, splideInstance.options), { autoplay: !!(options === null || options === void 0 ? void 0 : options.autoplay) });
            if (splideInstance.options.autoplay) {
                (_b = splideInstance.Components.Autoplay) === null || _b === void 0 ? void 0 : _b.play();
            }
            else {
                (_c = splideInstance.Components.Autoplay) === null || _c === void 0 ? void 0 : _c.pause();
            }
            if (options === null || options === void 0 ? void 0 : options.autoScroll) {
                splideInstance.options = Object.assign(Object.assign({}, splideInstance.options), { autoScroll: (options === null || options === void 0 ? void 0 : options.autoScroll) ? options === null || options === void 0 ? void 0 : options.autoScroll : false, extensions: (options === null || options === void 0 ? void 0 : options.autoScroll) ? options === null || options === void 0 ? void 0 : options.extensions : {} });
                splideInstance.destroy();
                splideInstance.mount();
            }
        }
    }, [inView, lazyLoad, options === null || options === void 0 ? void 0 : options.autoScroll, options === null || options === void 0 ? void 0 : options.autoplay, options === null || options === void 0 ? void 0 : options.extensions]);
    (0,react.useEffect)(() => {
        if (onRefReady) {
            onRefReady(splide.current);
        }
    }, [onRefReady]);
    (0,react.useEffect)(() => {
        if (splide.current) {
            splide.current.go(currentSlide);
        }
    }, [currentSlide, splide]);
    const handleNext = () => {
        var _a;
        (_a = splide.current) === null || _a === void 0 ? void 0 : _a.go('+1');
    };
    const handlePrev = () => { var _a; return (_a = splide.current) === null || _a === void 0 ? void 0 : _a.go('-1'); };
    const directionScroll = (0,react.useMemo)(() => (isRtl ? 'rtl' : 'ltr'), [isRtl]);
    return (react.createElement(Grid_esm/* default */.ZP, { ref: ref, md: 12, lg: 12, xs: 12, sx: sx },
        react.createElement(react_splide_esm_esm/* Splide */.tv, { ref: splide, options: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (vertical
                ? {
                    direction: 'ttb',
                    height: `${verticalHeight}px`,
                    trimSpace,
                    focus: centerFocus ? 'center' : undefined
                }
                : {})), { type: loop ? 'loop' : 'slide', direction: directionScroll, paginationDirection: directionScroll, perPage: slidesPerView, perMove: slidesPerGroup, pagination, arrows: false, gap: spaceBetween, updateOnMove, padding: `${slidePadding}rem`, wheel, drag: !disableDrag, breakpoints }), (lazyLoad
                ? {
                    lazyLoad: 'nearby'
                }
                : {})), options), { autoScroll: lazyLoad ? false : options === null || options === void 0 ? void 0 : options.autoScroll, autoplay: lazyLoad ? false : options === null || options === void 0 ? void 0 : options.autoplay }), onMounted: (e) => {
                setPerPage((e === null || e === void 0 ? void 0 : e.options.perPage) || slidesPerView);
            }, extensions: extensions }, children),
        react.createElement(Grid_esm/* default */.ZP, { sx: { display: 'flex', gap: '16px', alignItems: 'center', justifyContent: 'space-between', width: '100%' } },
            navigationElement,
            navigation && react.Children.count(children) > perPage && (react.createElement(NavigationContainer, { navigationPosition: navigationPosition },
                react.createElement(CarouselNavButton, { refObj: prevRef, sx: navButtonStyles, onClick: handlePrev, type: isRtl ? 'next' : 'prev' }),
                react.createElement(CarouselNavButton, { refObj: nextRef, sx: navButtonStyles, onClick: handleNext, type: isRtl ? 'prev' : 'next' }))))));
};




/***/ }),

/***/ 98855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Rating; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _node_modules_mui_material_Grid_Grid_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54597);
/* harmony import */ var _node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46224);




var StarIconDimensions;
(function (StarIconDimensions) {
    StarIconDimensions["XXS"] = "xxs";
    StarIconDimensions["XS"] = "xs";
    StarIconDimensions["SMALL"] = "small";
    StarIconDimensions["LOWMID"] = "low-medium";
    StarIconDimensions["MEDIUM"] = "medium";
    StarIconDimensions["LARGE"] = "large";
})(StarIconDimensions || (StarIconDimensions = {}));
var StarIconSizeValue;
(function (StarIconSizeValue) {
    StarIconSizeValue[StarIconSizeValue["XXS"] = 10] = "XXS";
    StarIconSizeValue[StarIconSizeValue["XS"] = 12] = "XS";
    StarIconSizeValue[StarIconSizeValue["SMALL"] = 16] = "SMALL";
    StarIconSizeValue[StarIconSizeValue["LOWMID"] = 20] = "LOWMID";
    StarIconSizeValue[StarIconSizeValue["MEDIUM"] = 24] = "MEDIUM";
    StarIconSizeValue[StarIconSizeValue["LARGE"] = 40] = "LARGE";
    StarIconSizeValue[StarIconSizeValue["DEFAULT"] = 32] = "DEFAULT";
})(StarIconSizeValue || (StarIconSizeValue = {}));
const getStarIconSize = (size) => {
    switch (size) {
        case StarIconDimensions.XXS:
            return StarIconSizeValue.XXS;
        case StarIconDimensions.XS:
            return StarIconSizeValue.XS;
        case StarIconDimensions.SMALL:
            return StarIconSizeValue.SMALL;
        case StarIconDimensions.LOWMID:
            return StarIconSizeValue.LOWMID;
        case StarIconDimensions.MEDIUM:
            return StarIconSizeValue.MEDIUM;
        case StarIconDimensions.LARGE:
            return StarIconSizeValue.LARGE;
        default:
            return StarIconSizeValue.DEFAULT;
    }
};
const Rating = ({ max = 5, sx, value = 0, size = 'medium', starIconId = '#rating-star-icon', emptyStarIconId = '#rating-empty-star-icon' }) => {
    const iconSize = getStarIconSize(size);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_Grid_Grid_esm_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, { container: true, gap: "4px", alignItems: "center", height: "100%", wrap: "nowrap", width: "auto", m: "0 2px", boxSizing: "border-box", sx: sx }, Array.from({ length: max }).map((_, index) => index >= value ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { fontSize: "inherit", viewBox: "0 0 18 17", key: `star-rating-item-${index}-empty`, sx: {
            width: iconSize,
            height: iconSize
        } },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", { href: emptyStarIconId }))) : (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { fontSize: "inherit", viewBox: "0 0 24 23", key: `star-rating-item-${index}`, sx: {
            width: iconSize,
            height: iconSize
        } },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("use", { href: starIconId }))))));
};




/***/ }),

/***/ 93716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArrowRight; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10395);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46224);




const ArrowRight = (_a) => {
    var { color } = _a, props = (0,_virtual_tslib_esm_js__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._)(_a, ["color"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, Object.assign({ width: "16", height: "16", viewBox: "0 0 16 16" }, props),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M8 2L6.9425 3.0575L11.1275 7.25H2V8.75H11.1275L6.9425 12.9425L8 14L14 8L8 2Z", fill: color || '#2B59E0' })));
};




/***/ }),

/***/ 2555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ CloseRoundedIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46224);



const CloseRoundedIcon = (props) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "20", height: "21", fill: "none", viewBox: "0 0 20 21" }, props),
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { fill: "#fff", d: "M0 0H20V20H0z", transform: "translate(0 .728)", style: { mixBlendMode: 'multiply' } }),
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2", d: "M5.042 5.813l9.916 9.829M14.914 5.77l-9.828 9.916" })));




/***/ }),

/***/ 76605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PulseIcon; }
/* harmony export */ });
/* harmony import */ var _virtual_tslib_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10395);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46224);




const PulseIcon = (_a) => {
    var props = (0,_virtual_tslib_esm_js__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._)(_a, []);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, Object.assign({ width: "32", height: "32", viewBox: "0 0 17 16" }, props),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M0 10.5H2.41886C2.46615 10.5 2.50697 10.4669 2.51672 10.4206L4.40301 1.4607C4.42526 1.35503 4.57602 1.35476 4.59865 1.46035L7.42027 14.6279C7.44181 14.7285 7.58283 14.7349 7.6135 14.6368L9.91926 7.25836C9.94697 7.1697 10.07 7.16342 10.1066 7.24879L11.474 10.4394C11.4898 10.4762 11.5259 10.5 11.5659 10.5H15.5", stroke: "#2C3341" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", { cx: "15", cy: "10.5", r: "1.5" }))));
};




/***/ }),

/***/ 1758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SearchBarLocationIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46224);



const SearchBarLocationIcon = (props) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 12.861, height: 15.719, viewBox: "272 176.246 18 15" }, props),
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { stroke: "#11245A", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M286.736 182.676c0 4.288-6.431 9.289-6.431 9.289s-6.43-5.001-6.43-9.289c0-3.502 2.928-6.43 6.43-6.43 3.503 0 6.431 2.928 6.431 6.43Z", style: {
            fill: 'transparent'
        } }),
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { stroke: "#11245A", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M280.305 184.82a2.143 2.143 0 1 0 0-4.287 2.143 2.143 0 0 0 0 4.287Z", style: {
            fill: 'transparent'
        } })));




/***/ }),

/***/ 12841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SearchBarSearchIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32735);
/* harmony import */ var _node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46224);



const SearchBarSearchIcon = (props) => (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_node_modules_mui_material_SvgIcon_SvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "22", height: "22", viewBox: "0 0 22 22" }, props, { sx: Object.assign({ fill: 'none' }, ((props === null || props === void 0 ? void 0 : props.sx) || {})) }),
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M9.86816 18C14.2864 18 17.8682 14.4183 17.8682 10C17.8682 5.58172 14.2864 2 9.86816 2C5.44989 2 1.86816 5.58172 1.86816 10C1.86816 14.4183 5.44989 18 9.86816 18Z", stroke: "#11245A", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M19.8681 20L15.5181 15.65", stroke: "#11245A", strokeWidth: "2.5", strokeLinecap: "round", strokeLinejoin: "round" })));




/***/ }),

/***/ 32799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Checkbox$1; }
});

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.esm.js
var objectWithoutPropertiesLoose_esm = __webpack_require__(86804);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@babel/runtime/helpers/esm/extends.esm.js
var extends_esm = __webpack_require__(93335);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/clsx/dist/clsx.m.esm.js
var clsx_m_esm = __webpack_require__(88793);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/FormControl/useFormControl.esm.js
var useFormControl_esm = __webpack_require__(38894);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.esm.js
var generateUtilityClass_esm = __webpack_require__(90566);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.esm.js
var generateUtilityClasses_esm = __webpack_require__(82637);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/internal/switchBaseClasses.esm.js



function getSwitchBaseUtilityClass(slot) {
  return (0,generateUtilityClass_esm/* default */.Z)('PrivateSwitchBase', slot);
}
(0,generateUtilityClasses_esm/* default */.Z)('PrivateSwitchBase', ['root', 'checked', 'disabled', 'input', 'edgeStart', 'edgeEnd']);



// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/ButtonBase/ButtonBase.esm.js + 7 modules
var ButtonBase_esm = __webpack_require__(73399);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/utils/esm/composeClasses/composeClasses.esm.js
var composeClasses_esm = __webpack_require__(94723);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/utils/esm/useControlled/useControlled.esm.js
var useControlled_esm = __webpack_require__(33107);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/utils/esm/capitalize/capitalize.esm.js
var capitalize_esm = __webpack_require__(6573);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/internal/SwitchBase.esm.js















const _excluded = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"];
const useUtilityClasses = ownerState => {
  const {
    classes,
    checked,
    disabled,
    edge
  } = ownerState;
  const slots = {
    root: ['root', checked && 'checked', disabled && 'disabled', edge && `edge${(0,capitalize_esm/* default */.Z)(edge)}`],
    input: ['input']
  };
  return (0,composeClasses_esm/* default */.Z)(slots, getSwitchBaseUtilityClass, classes);
};
const SwitchBaseRoot = (0,styled_esm/* default */.ZP)(ButtonBase_esm/* default */.Z)(({
  ownerState
}) => (0,extends_esm/* default */.Z)({
  padding: 9,
  borderRadius: '50%'
}, ownerState.edge === 'start' && {
  marginLeft: ownerState.size === 'small' ? -3 : -12
}, ownerState.edge === 'end' && {
  marginRight: ownerState.size === 'small' ? -3 : -12
}));
const SwitchBaseInput = (0,styled_esm/* default */.ZP)('input')({
  cursor: 'inherit',
  position: 'absolute',
  opacity: 0,
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
});

/**
 * @ignore - internal component.
 */
const SwitchBase = /*#__PURE__*/react.forwardRef(function SwitchBase(props, ref) {
  const {
      autoFocus,
      checked: checkedProp,
      checkedIcon,
      className,
      defaultChecked,
      disabled: disabledProp,
      disableFocusRipple = false,
      edge = false,
      icon,
      id,
      inputProps,
      inputRef,
      name,
      onBlur,
      onChange,
      onFocus,
      readOnly,
      required = false,
      tabIndex,
      type,
      value
    } = props,
    other = (0,objectWithoutPropertiesLoose_esm/* default */.Z)(props, _excluded);
  const [checked, setCheckedState] = (0,useControlled_esm/* default */.Z)({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: 'SwitchBase',
    state: 'checked'
  });
  const muiFormControl = (0,useFormControl_esm/* default */.Z)();
  const handleFocus = event => {
    if (onFocus) {
      onFocus(event);
    }
    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };
  const handleBlur = event => {
    if (onBlur) {
      onBlur(event);
    }
    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };
  const handleInputChange = event => {
    // Workaround for https://github.com/facebook/react/issues/9023
    if (event.nativeEvent.defaultPrevented) {
      return;
    }
    const newChecked = event.target.checked;
    setCheckedState(newChecked);
    if (onChange) {
      // TODO v6: remove the second argument.
      onChange(event, newChecked);
    }
  };
  let disabled = disabledProp;
  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }
  const hasLabelFor = type === 'checkbox' || type === 'radio';
  const ownerState = (0,extends_esm/* default */.Z)({}, props, {
    checked,
    disabled,
    disableFocusRipple,
    edge
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(SwitchBaseRoot, (0,extends_esm/* default */.Z)({
    component: "span",
    className: (0,clsx_m_esm/* clsx */.W)(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SwitchBaseInput, (0,extends_esm/* default */.Z)({
      autoFocus: autoFocus,
      checked: checkedProp,
      defaultChecked: defaultChecked,
      className: classes.input,
      disabled: disabled,
      id: hasLabelFor ? id : undefined,
      name: name,
      onChange: handleInputChange,
      readOnly: readOnly,
      ref: inputRef,
      required: required,
      ownerState: ownerState,
      tabIndex: tabIndex,
      type: type
    }, type === 'checkbox' && value === undefined ? {} : {
      value
    }, inputProps)), checked ? checkedIcon : icon]
  }));
});

// NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.
 false ? 0 : void 0;
var SwitchBase$1 = SwitchBase;



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/utils/createSvgIcon.esm.js
var createSvgIcon_esm = __webpack_require__(18660);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/internal/svg-icons/CheckBoxOutlineBlank.esm.js




var CheckBoxOutlineBlankIcon = (0,createSvgIcon_esm/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/internal/svg-icons/CheckBox.esm.js




var CheckBoxIcon = (0,createSvgIcon_esm/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/internal/svg-icons/IndeterminateCheckBox.esm.js




var IndeterminateCheckBoxIcon = (0,createSvgIcon_esm/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useThemeProps.esm.js
var useThemeProps_esm = __webpack_require__(33164);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Checkbox/checkboxClasses.esm.js



function getCheckboxUtilityClass(slot) {
  return (0,generateUtilityClass_esm/* default */.Z)('MuiCheckbox', slot);
}
const checkboxClasses = (0,generateUtilityClasses_esm/* default */.Z)('MuiCheckbox', ['root', 'checked', 'disabled', 'indeterminate', 'colorPrimary', 'colorSecondary']);
var checkboxClasses$1 = checkboxClasses;



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/system/esm/colorManipulator.esm.js
var colorManipulator_esm = __webpack_require__(19916);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Checkbox/Checkbox.esm.js


















const Checkbox_esm_excluded = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size", "className"];
const Checkbox_esm_useUtilityClasses = ownerState => {
  const {
    classes,
    indeterminate,
    color
  } = ownerState;
  const slots = {
    root: ['root', indeterminate && 'indeterminate', `color${(0,capitalize_esm/* default */.Z)(color)}`]
  };
  const composedClasses = (0,composeClasses_esm/* default */.Z)(slots, getCheckboxUtilityClass, classes);
  return (0,extends_esm/* default */.Z)({}, classes, composedClasses);
};
const CheckboxRoot = (0,styled_esm/* default */.ZP)(SwitchBase$1, {
  shouldForwardProp: prop => (0,styled_esm/* rootShouldForwardProp */.FO)(prop) || prop === 'classes',
  name: 'MuiCheckbox',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.indeterminate && styles.indeterminate, ownerState.color !== 'default' && styles[`color${(0,capitalize_esm/* default */.Z)(ownerState.color)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,extends_esm/* default */.Z)({
  color: (theme.vars || theme).palette.text.secondary
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0,colorManipulator_esm/* alpha */.Fq)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.color !== 'default' && {
  [`&.${checkboxClasses$1.checked}, &.${checkboxClasses$1.indeterminate}`]: {
    color: (theme.vars || theme).palette[ownerState.color].main
  },
  [`&.${checkboxClasses$1.disabled}`]: {
    color: (theme.vars || theme).palette.action.disabled
  }
}));
const defaultCheckedIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(CheckBoxIcon, {});
const defaultIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(CheckBoxOutlineBlankIcon, {});
const defaultIndeterminateIcon = /*#__PURE__*/(0,jsx_runtime.jsx)(IndeterminateCheckBoxIcon, {});
const Checkbox = /*#__PURE__*/react.forwardRef(function Checkbox(inProps, ref) {
  var _icon$props$fontSize, _indeterminateIcon$pr;
  const props = (0,useThemeProps_esm/* default */.Z)({
    props: inProps,
    name: 'MuiCheckbox'
  });
  const {
      checkedIcon = defaultCheckedIcon,
      color = 'primary',
      icon: iconProp = defaultIcon,
      indeterminate = false,
      indeterminateIcon: indeterminateIconProp = defaultIndeterminateIcon,
      inputProps,
      size = 'medium',
      className
    } = props,
    other = (0,objectWithoutPropertiesLoose_esm/* default */.Z)(props, Checkbox_esm_excluded);
  const icon = indeterminate ? indeterminateIconProp : iconProp;
  const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
  const ownerState = (0,extends_esm/* default */.Z)({}, props, {
    color,
    indeterminate,
    size
  });
  const classes = Checkbox_esm_useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckboxRoot, (0,extends_esm/* default */.Z)({
    type: "checkbox",
    inputProps: (0,extends_esm/* default */.Z)({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: /*#__PURE__*/react.cloneElement(icon, {
      fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
    }),
    checkedIcon: /*#__PURE__*/react.cloneElement(indeterminateIcon, {
      fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
    }),
    ownerState: ownerState,
    ref: ref,
    className: (0,clsx_m_esm/* clsx */.W)(classes.root, className)
  }, other, {
    classes: classes
  }));
});
 false ? 0 : void 0;
var Checkbox$1 = Checkbox;




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4322,7667,1583,2430,9774,2888,179], function() { return __webpack_exec__(4878); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);